var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHertfordshireConstabularyBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106.411,
    height: 129.268,
    viewBox: "0 0 106.411 129.268",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hertfordshire_Constabulary_badge_4_",
    "data-name": "Hertfordshire_Constabulary_badge (4)",
    transform: "translate(0.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9682",
    "data-name": "Trazado 9682",
    d: "M79.986,172.241A35.186,35.186,0,1,0,44.8,137.055a35.183,35.183,0,0,0,35.186,35.187m36.989-72.175a4.674,4.674,0,0,1-1.217,3.673c-.39-.413-.792-.838-1.205-1.251s-.826-.815-1.251-1.205a4.76,4.76,0,0,1,3.673-1.217",
    transform: "translate(-27.672 -61.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9683",
    "data-name": "Trazado 9683",
    d: "M224.078,100.066a4.674,4.674,0,0,1-1.217,3.673c-.39-.413-.792-.838-1.205-1.251s-.826-.815-1.251-1.205a4.76,4.76,0,0,1,3.673-1.217Zm0,0",
    transform: "translate(-134.775 -61.011)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9684",
    "data-name": "Trazado 9684",
    d: "M217.62,105.706a21.159,21.159,0,0,1-1.883,1.986l-1.469,1.354c-.39-.425-.792-.838-1.194-1.251s-.834-.812-1.263-1.205l1.366-1.458a18.765,18.765,0,0,1,1.986-1.894q1.28,1.181,2.457,2.468",
    transform: "translate(-129.533 -62.966)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9685",
    "data-name": "Trazado 9685",
    d: "M217.62,105.706a21.159,21.159,0,0,1-1.883,1.986l-1.469,1.354c-.39-.425-.792-.838-1.194-1.251s-.834-.812-1.263-1.205l1.366-1.458a18.765,18.765,0,0,1,1.986-1.894q1.28,1.181,2.457,2.468Zm0,0",
    transform: "translate(-129.533 -62.966)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9686",
    "data-name": "Trazado 9686",
    d: "M207.085,115.424q-.563-.569-1.159-1.1l2.3-2.492c.425.4.85.792,1.251,1.205s.815.827,1.205,1.251l-2.479,2.3c-.367-.39-.735-.781-1.114-1.159",
    transform: "translate(-125.944 -68.207)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9687",
    "data-name": "Trazado 9687",
    d: "M207.085,115.424q-.563-.569-1.159-1.1l2.3-2.492c.425.4.85.792,1.251,1.205s.815.827,1.205,1.251l-2.479,2.3C207.832,116.194,207.464,115.8,207.085,115.424Zm0,0",
    transform: "translate(-125.944 -68.207)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9688",
    "data-name": "Trazado 9688",
    d: "M204.968,120.479l-2.239,2.066q-1-1.1-2.1-2.089l2.067-2.238c.39.356.78.723,1.159,1.1s.746.769,1.114,1.159",
    transform: "translate(-122.713 -72.102)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9689",
    "data-name": "Trazado 9689",
    d: "M204.968,120.479l-2.239,2.066q-1-1.1-2.1-2.089l2.067-2.238c.39.356.78.723,1.159,1.1S204.6,120.089,204.968,120.479Zm0,0",
    transform: "translate(-122.713 -72.102)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9690",
    "data-name": "Trazado 9690",
    d: "M196.318,127.125q-.485-.479-.987-.941l2.066-2.227q1.1.992,2.1,2.089l-2.239,2.067c-.31-.333-.62-.655-.941-.987",
    transform: "translate(-119.482 -75.602)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9691",
    "data-name": "Trazado 9691",
    d: "M196.318,127.125q-.485-.479-.987-.941l2.066-2.227q1.1.992,2.1,2.089l-2.239,2.067C196.949,127.779,196.639,127.457,196.318,127.125Zm0,0",
    transform: "translate(-119.482 -75.602)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9692",
    "data-name": "Trazado 9692",
    d: "M222.814,113.775c.012,1.688-.964,2.939-2.411,4.236q-1.026-1.3-2.147-2.515c1.492-1.228,2.893-2,4.558-1.722",
    transform: "translate(-133.464 -69.358)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9693",
    "data-name": "Trazado 9693",
    d: "M222.814,113.775c.012,1.688-.964,2.939-2.411,4.236q-1.026-1.3-2.147-2.515c1.492-1.228,2.893-2,4.558-1.722Zm0,0",
    transform: "translate(-133.464 -69.358)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9694",
    "data-name": "Trazado 9694",
    d: "M215.231,121.812l-1.412,1.125q-.986-1.245-2.066-2.411L213.1,119.3q.579-.531,1.194-1.022,1.12,1.217,2.147,2.514-.585.531-1.205,1.022",
    transform: "translate(-129.498 -72.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9695",
    "data-name": "Trazado 9695",
    d: "M215.231,121.812l-1.412,1.125q-.986-1.245-2.066-2.411L213.1,119.3q.579-.531,1.194-1.022,1.12,1.217,2.147,2.514-.585.531-1.205,1.022Zm0,0",
    transform: "translate(-129.498 -72.138)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9696",
    "data-name": "Trazado 9696",
    d: "M206.014,126.1l2.239-2.055q1.08,1.165,2.066,2.411l-2.388,1.894q-.915-1.161-1.917-2.25",
    transform: "translate(-125.998 -75.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9697",
    "data-name": "Trazado 9697",
    d: "M206.014,126.1l2.239-2.055q1.08,1.165,2.066,2.411l-2.388,1.894Q207.015,127.189,206.014,126.1Zm0,0",
    transform: "translate(-125.998 -75.656)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9698",
    "data-name": "Trazado 9698",
    d: "M202.055,133.456q-.848-1.074-1.78-2.078l2.239-2.067q1,1.088,1.917,2.25Zm0,0",
    transform: "translate(-122.497 -78.869)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9699",
    "data-name": "Trazado 9699",
    d: "M226.779,125.656a3.584,3.584,0,0,1-.643,1.974q-.691-1.006-1.435-1.974a3.557,3.557,0,0,1,2.078,0",
    transform: "translate(-137.395 -76.544)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9700",
    "data-name": "Trazado 9700",
    d: "M226.779,125.656a3.584,3.584,0,0,1-.643,1.974q-.691-1.006-1.435-1.974a3.557,3.557,0,0,1,2.078,0Zm0,0",
    transform: "translate(-137.395 -76.544)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9701",
    "data-name": "Trazado 9701",
    d: "M218.969,130.169q-.883-1.313-1.86-2.56a9.793,9.793,0,0,1,2.962-1.711q.739.972,1.436,1.974a9.806,9.806,0,0,1-2.538,2.3",
    transform: "translate(-132.765 -76.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9702",
    "data-name": "Trazado 9702",
    d: "M218.969,130.169q-.883-1.313-1.86-2.56a9.793,9.793,0,0,1,2.962-1.711q.739.972,1.436,1.974A9.806,9.806,0,0,1,218.969,130.169Zm0,0",
    transform: "translate(-132.765 -76.787)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9703",
    "data-name": "Trazado 9703",
    d: "M212.692,134.543q-.816-1.224-1.734-2.376l2.147-1.7c.08-.057.161-.126.252-.183q.98,1.243,1.86,2.56c-.08.057-.172.115-.252.184Zm0,0",
    transform: "translate(-129.013 -79.462)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9704",
    "data-name": "Trazado 9704",
    d: "M206.421,139.174q-.746-1.124-1.584-2.181l2.387-1.883q.922,1.147,1.734,2.376Zm0,0",
    transform: "translate(-125.28 -82.405)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9705",
    "data-name": "Trazado 9705",
    d: "M225.241,136.311a3.785,3.785,0,0,1-1.619,2.629q-.695-1.233-1.481-2.411a3.9,3.9,0,0,1,3.1-.218",
    transform: "translate(-135.834 -82.998)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9706",
    "data-name": "Trazado 9706",
    d: "M225.241,136.311a3.785,3.785,0,0,1-1.619,2.629q-.695-1.233-1.481-2.411a3.9,3.9,0,0,1,3.1-.218Zm0,0",
    transform: "translate(-135.834 -82.998)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9707",
    "data-name": "Trazado 9707",
    d: "M217.664,140.846l-.735.413q-.712-1.271-1.527-2.48l.689-.459a14.693,14.693,0,0,1,1.94-1.091q.785,1.177,1.481,2.411a16.576,16.576,0,0,1-1.848,1.205",
    transform: "translate(-131.723 -83.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9708",
    "data-name": "Trazado 9708",
    d: "M217.664,140.846l-.735.413q-.712-1.271-1.527-2.48l.689-.459a14.693,14.693,0,0,1,1.94-1.091q.785,1.177,1.481,2.411a16.576,16.576,0,0,1-1.848,1.205Zm0,0",
    transform: "translate(-131.723 -83.697)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9709",
    "data-name": "Trazado 9709",
    d: "M208.927,142.9l2.537-1.7q.8,1.212,1.516,2.48l-2.652,1.5q-.651-1.172-1.4-2.285",
    transform: "translate(-127.774 -86.121)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9710",
    "data-name": "Trazado 9710",
    d: "M208.927,142.9l2.537-1.7q.8,1.212,1.516,2.48l-2.652,1.5q-.651-1.172-1.4-2.285Zm0,0",
    transform: "translate(-127.774 -86.121)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9711",
    "data-name": "Trazado 9711",
    d: "M228.286,145.878a3.1,3.1,0,0,1-.378,1.194q-.379-.795-.792-1.572a3.048,3.048,0,0,1,1.171.378",
    transform: "translate(-138.867 -88.741)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9712",
    "data-name": "Trazado 9712",
    d: "M228.286,145.878a3.1,3.1,0,0,1-.378,1.194q-.379-.795-.792-1.572a3.048,3.048,0,0,1,1.171.378Zm0,0",
    transform: "translate(-138.867 -88.741)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9713",
    "data-name": "Trazado 9713",
    d: "M220.746,149.059q-.645-1.41-1.4-2.766a5.773,5.773,0,0,1,3.031-.815q.413.778.792,1.573a5.74,5.74,0,0,1-2.422,2.009",
    transform: "translate(-134.129 -88.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9714",
    "data-name": "Trazado 9714",
    d: "M220.746,149.059q-.645-1.41-1.4-2.766a5.773,5.773,0,0,1,3.031-.815q.413.778.792,1.573a5.739,5.739,0,0,1-2.422,2.009Zm0,0",
    transform: "translate(-134.129 -88.72)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9715",
    "data-name": "Trazado 9715",
    d: "M215.732,150.78l-1.906.861q-.6-1.312-1.309-2.572l1.8-1.022q.427-.236.861-.459.758,1.353,1.4,2.767c-.275.149-.562.287-.849.425",
    transform: "translate(-129.964 -90.015)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9716",
    "data-name": "Trazado 9716",
    d: "M215.732,150.78l-1.906.861q-.6-1.312-1.309-2.572l1.8-1.022q.427-.236.861-.459.758,1.353,1.4,2.767C216.307,150.5,216.019,150.642,215.732,150.78Zm0,0",
    transform: "translate(-129.964 -90.015)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9717",
    "data-name": "Trazado 9717",
    d: "M225.806,155.077a3.745,3.745,0,0,1-1.757,2.009q-.41-1.119-.907-2.2a3.717,3.717,0,0,1,2.663.2",
    transform: "translate(-136.444 -94.371)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9718",
    "data-name": "Trazado 9718",
    d: "M225.806,155.077a3.745,3.745,0,0,1-1.757,2.009q-.41-1.119-.907-2.2a3.717,3.717,0,0,1,2.663.2Zm0,0",
    transform: "translate(-136.444 -94.371)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9719",
    "data-name": "Trazado 9719",
    d: "M216.807,158.554q-.435-1.184-.964-2.33l.494-.218a14.8,14.8,0,0,1,2.353-.884q.493,1.079.907,2.192a14.625,14.625,0,0,1-2.285,1.056Zm0,0",
    transform: "translate(-131.992 -94.61)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9720",
    "data-name": "Trazado 9720",
    d: "M209.455,100c-1.687-.011-2.939.965-4.236,2.411q1.3,1.036,2.526,2.158c1.217-1.5,2-2.893,1.711-4.569",
    transform: "translate(-125.513 -60.991)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9721",
    "data-name": "Trazado 9721",
    d: "M209.455,100c-1.687-.011-2.939.965-4.236,2.411q1.3,1.036,2.526,2.158c1.217-1.5,2-2.893,1.711-4.569Zm0,0",
    transform: "translate(-125.513 -60.991)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9722",
    "data-name": "Trazado 9722",
    d: "M200.859,107.386l-1.114,1.412q1.223.981,2.411,2.066l1.217-1.332c.367-.413.712-.8,1.033-1.194q-1.226-1.121-2.526-2.158c-.333.379-.666.781-1.022,1.205",
    transform: "translate(-122.174 -64.761)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9723",
    "data-name": "Trazado 9723",
    d: "M200.859,107.386l-1.114,1.412q1.223.981,2.411,2.066l1.217-1.332c.367-.413.712-.8,1.033-1.194q-1.226-1.121-2.526-2.158C201.548,106.56,201.214,106.962,200.859,107.386Zm0,0",
    transform: "translate(-122.174 -64.761)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9724",
    "data-name": "Trazado 9724",
    d: "M197.128,117.2l2.067-2.239c-.792-.723-1.6-1.412-2.422-2.066l-1.883,2.388q1.151.921,2.238,1.917",
    transform: "translate(-119.213 -68.853)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9725",
    "data-name": "Trazado 9725",
    d: "M197.128,117.2l2.067-2.239c-.792-.723-1.6-1.412-2.422-2.066l-1.883,2.388Q196.041,116.2,197.128,117.2Zm0,0",
    transform: "translate(-119.213 -68.853)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9726",
    "data-name": "Trazado 9726",
    d: "M190.034,121.4q1.075.847,2.078,1.78l2.055-2.25q-1.087-1-2.238-1.917Zm0,0",
    transform: "translate(-116.251 -72.587)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9727",
    "data-name": "Trazado 9727",
    d: "M200.955,99.913a3.61,3.61,0,0,0-1.975.643q1.007.7,1.975,1.446a3.6,3.6,0,0,0,0-2.089",
    transform: "translate(-121.708 -60.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9728",
    "data-name": "Trazado 9728",
    d: "M200.955,99.913a3.61,3.61,0,0,0-1.975.643q1.007.7,1.975,1.446A3.6,3.6,0,0,0,200.955,99.913Zm0,0",
    transform: "translate(-121.708 -60.938)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9729",
    "data-name": "Trazado 9729",
    d: "M193.094,104.1c.873.586,1.734,1.205,2.56,1.871A9.519,9.519,0,0,0,197.365,103q-.969-.742-1.975-1.435a9.81,9.81,0,0,0-2.3,2.537",
    transform: "translate(-118.118 -61.943)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9730",
    "data-name": "Trazado 9730",
    d: "M193.094,104.1c.873.586,1.734,1.205,2.56,1.871A9.519,9.519,0,0,0,197.365,103q-.969-.742-1.975-1.435A9.81,9.81,0,0,0,193.094,104.1Zm0,0",
    transform: "translate(-118.118 -61.943)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9731",
    "data-name": "Trazado 9731",
    d: "M188.768,110.59c.8.551,1.6,1.125,2.376,1.734l1.688-2.147c.069-.08.126-.161.2-.241q-1.245-.983-2.56-1.871-.1.128-.184.264Zm0,0",
    transform: "translate(-115.479 -65.909)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9732",
    "data-name": "Trazado 9732",
    d: "M184.413,117.076q1.122.747,2.181,1.584l1.894-2.388q-1.164-.907-2.388-1.734Zm0,0",
    transform: "translate(-112.823 -69.858)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9733",
    "data-name": "Trazado 9733",
    d: "M189.16,99.854a3.782,3.782,0,0,0-2.628,1.63c.826.459,1.619.953,2.411,1.469a3.859,3.859,0,0,0,.218-3.1",
    transform: "translate(-114.115 -60.902)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9734",
    "data-name": "Trazado 9734",
    d: "M189.16,99.854a3.782,3.782,0,0,0-2.628,1.63c.826.459,1.619.953,2.411,1.469a3.859,3.859,0,0,0,.218-3.1Zm0,0",
    transform: "translate(-114.115 -60.902)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9735",
    "data-name": "Trazado 9735",
    d: "M182.825,105.863l-.413.724q1.258.724,2.468,1.527l.459-.689a13.544,13.544,0,0,0,1.091-1.94c-.781-.528-1.585-1.01-2.411-1.481a16.834,16.834,0,0,0-1.194,1.86",
    transform: "translate(-111.603 -63.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9736",
    "data-name": "Trazado 9736",
    d: "M182.825,105.863l-.413.724q1.258.724,2.468,1.527l.459-.689a13.544,13.544,0,0,0,1.091-1.94c-.781-.528-1.585-1.01-2.411-1.481a16.834,16.834,0,0,0-1.194,1.86Zm0,0",
    transform: "translate(-111.603 -63.432)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9737",
    "data-name": "Trazado 9737",
    d: "M180.823,114.677l1.688-2.525q-1.207-.816-2.48-1.527l-1.5,2.652q1.174.657,2.3,1.4",
    transform: "translate(-109.233 -67.471)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9738",
    "data-name": "Trazado 9738",
    d: "M180.823,114.677l1.688-2.525q-1.207-.816-2.48-1.527l-1.5,2.652Q179.7,113.934,180.823,114.677Zm0,0",
    transform: "translate(-109.233 -67.471)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9739",
    "data-name": "Trazado 9739",
    d: "M181.622,99.824a2.826,2.826,0,0,0-1.182.39c.516.253,1.045.517,1.561.792a2.747,2.747,0,0,0-.379-1.182",
    transform: "translate(-110.4 -60.884)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9740",
    "data-name": "Trazado 9740",
    d: "M181.622,99.824a2.826,2.826,0,0,0-1.182.39c.516.253,1.045.517,1.561.792a2.747,2.747,0,0,0-.379-1.182Zm0,0",
    transform: "translate(-110.4 -60.884)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9741",
    "data-name": "Trazado 9741",
    d: "M175.26,103.236q1.412.642,2.767,1.4a5.736,5.736,0,0,0,.815-3.019q-.772-.413-1.562-.792a5.645,5.645,0,0,0-2.021,2.411",
    transform: "translate(-107.24 -61.494)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9742",
    "data-name": "Trazado 9742",
    d: "M175.26,103.236q1.412.642,2.767,1.4a5.736,5.736,0,0,0,.815-3.019q-.772-.413-1.562-.792A5.645,5.645,0,0,0,175.26,103.236Zm0,0",
    transform: "translate(-107.24 -61.494)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9743",
    "data-name": "Trazado 9743",
    d: "M172.825,107.866l-.861,1.906c.873.39,1.734.827,2.571,1.3l1.022-1.791c.161-.287.31-.574.459-.861q-1.349-.771-2.767-1.412c-.138.275-.287.563-.425.861",
    transform: "translate(-105.23 -65.263)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9744",
    "data-name": "Trazado 9744",
    d: "M172.825,107.866l-.861,1.906c.873.39,1.734.827,2.571,1.3l1.022-1.791c.161-.287.31-.574.459-.861q-1.349-.771-2.767-1.412c-.138.275-.287.563-.425.861Zm0,0",
    transform: "translate(-105.23 -65.263)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9745",
    "data-name": "Trazado 9745",
    d: "M263.69,192.23a4.723,4.723,0,0,0-3.467-1.734c.023.574.046,1.159.046,1.734s-.023,1.171-.046,1.745a4.7,4.7,0,0,0,3.467-1.745",
    transform: "translate(-159.06 -116.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9746",
    "data-name": "Trazado 9746",
    d: "M263.69,192.23a4.723,4.723,0,0,0-3.467-1.734c.023.574.046,1.159.046,1.734s-.023,1.171-.046,1.745A4.7,4.7,0,0,0,263.69,192.23Zm0,0",
    transform: "translate(-159.06 -116.185)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9747",
    "data-name": "Trazado 9747",
    d: "M252.839,190.351a19.2,19.2,0,0,0-2.744-.08l-2,.08q.069,1.733,0,3.467l2,.08a21.274,21.274,0,0,0,2.744-.069c.012-.574.034-1.159.034-1.745s-.023-1.16-.034-1.734",
    transform: "translate(-151.665 -116.04)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9748",
    "data-name": "Trazado 9748",
    d: "M252.839,190.351a19.2,19.2,0,0,0-2.744-.08l-2,.08q.069,1.733,0,3.467l2,.08a21.274,21.274,0,0,0,2.744-.069c.012-.574.034-1.159.034-1.745s-.023-1.16-.034-1.734Zm0,0",
    transform: "translate(-151.665 -116.04)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9749",
    "data-name": "Trazado 9749",
    d: "M239.45,192.23c0,.54-.012,1.068-.034,1.607l3.387.126q.068-1.733,0-3.467l-3.387.138c.023.528.034,1.068.034,1.6",
    transform: "translate(-146.37 -116.185)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9750",
    "data-name": "Trazado 9750",
    d: "M239.45,192.23c0,.54-.012,1.068-.034,1.607l3.387.126q.068-1.733,0-3.467l-3.387.138c.023.528.034,1.068.034,1.6Zm0,0",
    transform: "translate(-146.37 -116.185)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9751",
    "data-name": "Trazado 9751",
    d: "M234.659,190.85l-3.042.114q.035.741.035,1.481t-.035,1.481l3.043.126q.068-1.6,0-3.2",
    transform: "translate(-141.613 -116.401)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9752",
    "data-name": "Trazado 9752",
    d: "M234.659,190.85l-3.042.114q.035.741.035,1.481t-.035,1.481l3.043.126q.068-1.6,0-3.2Zm0,0",
    transform: "translate(-141.613 -116.401)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9753",
    "data-name": "Trazado 9753",
    d: "M223.853,192.624c0,.459-.012.907-.034,1.366l3.042.115q.068-1.48,0-2.962l-3.043.126q.035.677.035,1.355",
    transform: "translate(-136.856 -116.58)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9754",
    "data-name": "Trazado 9754",
    d: "M223.853,192.624c0,.459-.012.907-.034,1.366l3.042.115q.068-1.48,0-2.962l-3.043.126Q223.853,191.946,223.853,192.624Zm0,0",
    transform: "translate(-136.856 -116.58)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9755",
    "data-name": "Trazado 9755",
    d: "M252.128,183.092c-1.194-1.194-2.767-1.389-4.707-1.286.126,1.091.218,2.192.252,3.306,1.929-.207,3.467-.631,4.454-2.021",
    transform: "translate(-151.252 -110.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9756",
    "data-name": "Trazado 9756",
    d: "M252.128,183.092c-1.194-1.194-2.767-1.389-4.707-1.286.126,1.091.218,2.192.252,3.306,1.929-.207,3.467-.631,4.454-2.021Zm0,0",
    transform: "translate(-151.252 -110.871)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9757",
    "data-name": "Trazado 9757",
    d: "M240.589,181.97l-1.791.207c.115,1.045.207,2.1.241,3.169l1.814-.08c.551-.035,1.068-.069,1.573-.115-.057-1.113-.138-2.216-.264-3.306q-.788.04-1.572.126",
    transform: "translate(-145.993 -110.909)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9758",
    "data-name": "Trazado 9758",
    d: "M240.589,181.97l-1.791.207c.115,1.045.207,2.1.241,3.169l1.814-.08c.551-.035,1.068-.069,1.573-.115-.057-1.113-.138-2.216-.264-3.306q-.788.04-1.572.126Zm0,0",
    transform: "translate(-145.993 -110.909)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9759",
    "data-name": "Trazado 9759",
    d: "M231.258,185.992l3.043-.126c-.035-1.068-.127-2.124-.241-3.169l-3.031.344c.115.976.2,1.963.23,2.95",
    transform: "translate(-141.254 -111.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9760",
    "data-name": "Trazado 9760",
    d: "M231.258,185.992l3.043-.126c-.035-1.068-.127-2.124-.241-3.169l-3.031.344c.115.976.2,1.963.23,2.95Zm0,0",
    transform: "translate(-141.254 -111.429)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9761",
    "data-name": "Trazado 9761",
    d: "M223.289,183.936q.155,1.343.207,2.721l3.042-.126q-.054-1.479-.229-2.95Zm0,0",
    transform: "translate(-136.534 -111.967)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9762",
    "data-name": "Trazado 9762",
    d: "M248.133,175.1a3.6,3.6,0,0,0-1.86-.941q.224,1.188.379,2.411a3.648,3.648,0,0,0,1.481-1.469",
    transform: "translate(-150.552 -106.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9763",
    "data-name": "Trazado 9763",
    d: "M248.133,175.1a3.6,3.6,0,0,0-1.86-.941q.224,1.188.379,2.411a3.648,3.648,0,0,0,1.481-1.469Zm0,0",
    transform: "translate(-150.552 -106.224)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9764",
    "data-name": "Trazado 9764",
    d: "M237.533,174.19c.2,1.033.367,2.066.482,3.134a9.629,9.629,0,0,0,3.306-.9q-.155-1.223-.378-2.411a9.513,9.513,0,0,0-3.41.172",
    transform: "translate(-145.221 -106.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9765",
    "data-name": "Trazado 9765",
    d: "M237.533,174.19c.2,1.033.367,2.066.482,3.134a9.629,9.629,0,0,0,3.306-.9q-.155-1.223-.378-2.411A9.513,9.513,0,0,0,237.533,174.19Zm0,0",
    transform: "translate(-145.221 -106.078)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9766",
    "data-name": "Trazado 9766",
    d: "M229.852,175.189c.2.953.344,1.929.459,2.9l2.72-.321.31-.035c-.126-1.068-.3-2.1-.493-3.134a2.98,2.98,0,0,0-.31.057Zm0,0",
    transform: "translate(-140.537 -106.493)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9767",
    "data-name": "Trazado 9767",
    d: "M222.2,176.7q.257,1.324.425,2.664l3.019-.356q-.168-1.461-.459-2.9Zm0,0",
    transform: "translate(-135.87 -107.408)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9768",
    "data-name": "Trazado 9768",
    d: "M238.746,167.737a3.765,3.765,0,0,0-3.008-.712q.375,1.361.666,2.744a3.884,3.884,0,0,0,2.342-2.032",
    transform: "translate(-144.127 -101.841)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9769",
    "data-name": "Trazado 9769",
    d: "M238.746,167.737a3.765,3.765,0,0,0-3.008-.712q.375,1.361.666,2.744A3.884,3.884,0,0,0,238.746,167.737Zm0,0",
    transform: "translate(-144.127 -101.841)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9770",
    "data-name": "Trazado 9770",
    d: "M228.949,167.559l-.8.218c.252.93.482,1.871.666,2.824l.815-.161a14.145,14.145,0,0,0,2.147-.6c-.2-.93-.413-1.837-.666-2.744a16.26,16.26,0,0,0-2.158.459",
    transform: "translate(-139.496 -101.916)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9771",
    "data-name": "Trazado 9771",
    d: "M228.949,167.559l-.8.218c.252.93.482,1.871.666,2.824l.815-.161a14.145,14.145,0,0,0,2.147-.6c-.2-.93-.413-1.837-.666-2.744A16.26,16.26,0,0,0,228.949,167.559Zm0,0",
    transform: "translate(-139.496 -101.916)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9772",
    "data-name": "Trazado 9772",
    d: "M221.231,172.257l2.985-.6c-.184-.953-.413-1.894-.666-2.824l-2.939.815q.364,1.289.62,2.606",
    transform: "translate(-134.9 -102.975)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9773",
    "data-name": "Trazado 9773",
    d: "M221.231,172.257l2.985-.6c-.184-.953-.413-1.894-.666-2.824l-2.939.815Q220.975,170.941,221.231,172.257Zm0,0",
    transform: "translate(-134.9 -102.975)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9774",
    "data-name": "Trazado 9774",
    d: "M234.809,161.07a2.96,2.96,0,0,0-1.1-.563c.183.551.367,1.114.539,1.665a2.866,2.866,0,0,0,.563-1.1",
    transform: "translate(-142.888 -97.895)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9775",
    "data-name": "Trazado 9775",
    d: "M234.809,161.07a2.96,2.96,0,0,0-1.1-.563c.183.551.367,1.114.539,1.665a2.866,2.866,0,0,0,.563-1.1Zm0,0",
    transform: "translate(-142.888 -97.895)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9776",
    "data-name": "Trazado 9776",
    d: "M225.673,160.607q.538,1.455.953,2.951a5.8,5.8,0,0,0,2.721-1.573q-.262-.835-.539-1.665a5.658,5.658,0,0,0-3.134.287",
    transform: "translate(-137.988 -97.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9777",
    "data-name": "Trazado 9777",
    d: "M225.673,160.607q.538,1.455.953,2.951a5.8,5.8,0,0,0,2.721-1.573q-.262-.835-.539-1.665a5.658,5.658,0,0,0-3.134.287Zm0,0",
    transform: "translate(-137.988 -97.708)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9778",
    "data-name": "Trazado 9778",
    d: "M220.278,161.541l-1.963.746c.333.9.643,1.8.9,2.732l2-.539c.31-.092.632-.183.93-.287q-.414-1.495-.953-2.951c-.31.092-.609.2-.907.3",
    transform: "translate(-133.5 -98.344)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9779",
    "data-name": "Trazado 9779",
    d: "M220.278,161.541l-1.963.746c.333.9.643,1.8.9,2.732l2-.539c.31-.092.632-.183.93-.287q-.414-1.495-.953-2.951C220.875,161.335,220.577,161.438,220.278,161.541Zm0,0",
    transform: "translate(-133.5 -98.344)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9780",
    "data-name": "Trazado 9780",
    d: "M224.078,284.017a4.687,4.687,0,0,0-1.217-3.673c-.39.425-.792.838-1.205,1.251s-.826.815-1.251,1.205a4.674,4.674,0,0,0,3.673,1.217",
    transform: "translate(-134.775 -170.985)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9781",
    "data-name": "Trazado 9781",
    d: "M224.078,284.017a4.687,4.687,0,0,0-1.217-3.673c-.39.425-.792.838-1.205,1.251s-.826.815-1.251,1.205A4.674,4.674,0,0,0,224.078,284.017Zm0,0",
    transform: "translate(-134.775 -170.985)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9782",
    "data-name": "Trazado 9782",
    d: "M217.62,275.121a21.158,21.158,0,0,0-1.883-1.986l-1.469-1.354c-.39.414-.792.838-1.194,1.251s-.838.8-1.263,1.194l1.366,1.469a20.035,20.035,0,0,0,1.986,1.894c.425-.4.838-.8,1.251-1.217s.815-.823,1.205-1.251",
    transform: "translate(-129.533 -165.761)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9783",
    "data-name": "Trazado 9783",
    d: "M217.62,275.121a21.158,21.158,0,0,0-1.883-1.986l-1.469-1.354c-.39.414-.792.838-1.194,1.251s-.838.8-1.263,1.194l1.366,1.469a20.035,20.035,0,0,0,1.986,1.894c.425-.4.838-.8,1.251-1.217S217.23,275.549,217.62,275.121Zm0,0",
    transform: "translate(-129.533 -165.761)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9784",
    "data-name": "Trazado 9784",
    d: "M207.085,267.042q-.567.57-1.159,1.113l2.3,2.48c.425-.39.85-.781,1.251-1.194s.81-.829,1.205-1.251l-2.479-2.3c-.367.39-.735.769-1.114,1.148",
    transform: "translate(-125.944 -162.171)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9785",
    "data-name": "Trazado 9785",
    d: "M207.085,267.042q-.567.57-1.159,1.113l2.3,2.48c.425-.39.85-.781,1.251-1.194s.815-.838,1.205-1.251l-2.479-2.3C207.832,266.284,207.464,266.663,207.085,267.042Zm0,0",
    transform: "translate(-125.944 -162.171)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9786",
    "data-name": "Trazado 9786",
    d: "M204.968,262.663l-2.239-2.066c-.333.356-.677.712-1.021,1.068s-.712.688-1.079,1.022l2.067,2.238c.39-.367.78-.735,1.159-1.113s.746-.758,1.114-1.148",
    transform: "translate(-122.713 -158.941)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9787",
    "data-name": "Trazado 9787",
    d: "M204.968,262.663l-2.239-2.066c-.333.356-.677.712-1.021,1.068s-.712.688-1.079,1.022l2.067,2.238c.39-.367.78-.735,1.159-1.113S204.6,263.053,204.968,262.663Zm0,0",
    transform: "translate(-122.713 -158.941)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9788",
    "data-name": "Trazado 9788",
    d: "M196.318,256.275q-.485.48-.987.942l2.066,2.239c.367-.333.723-.678,1.079-1.022s.689-.712,1.022-1.067L197.26,255.3q-.462.5-.941.976",
    transform: "translate(-119.482 -155.709)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9789",
    "data-name": "Trazado 9789",
    d: "M196.318,256.275q-.485.48-.987.942l2.066,2.239c.367-.333.723-.678,1.079-1.022s.689-.712,1.022-1.067L197.26,255.3q-.462.5-.941.976Zm0,0",
    transform: "translate(-119.482 -155.709)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9790",
    "data-name": "Trazado 9790",
    d: "M222.814,269.406c.012-1.7-.964-2.95-2.411-4.248-.678.861-1.4,1.7-2.147,2.526,1.492,1.217,2.893,2,4.558,1.722",
    transform: "translate(-133.464 -161.723)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9791",
    "data-name": "Trazado 9791",
    d: "M222.814,269.406c.012-1.7-.964-2.95-2.411-4.248-.678.861-1.4,1.7-2.147,2.526,1.492,1.217,2.893,2,4.558,1.722Zm0,0",
    transform: "translate(-133.464 -161.723)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9792",
    "data-name": "Trazado 9792",
    d: "M215.231,260.809l-1.412-1.125c-.655.827-1.343,1.619-2.066,2.411l1.343,1.229c.4.356.8.7,1.194,1.022q1.112-1.224,2.147-2.514c-.367-.344-.769-.678-1.205-1.022",
    transform: "translate(-129.498 -158.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9793",
    "data-name": "Trazado 9793",
    d: "M215.231,260.809l-1.412-1.125c-.655.827-1.343,1.619-2.066,2.411l1.343,1.229c.4.356.8.7,1.194,1.022q1.112-1.224,2.147-2.514C216.069,261.487,215.668,261.153,215.231,260.809Zm0,0",
    transform: "translate(-129.498 -158.384)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9794",
    "data-name": "Trazado 9794",
    d: "M206.014,257.067l2.239,2.066c.723-.792,1.412-1.584,2.066-2.411l-2.388-1.894q-.911,1.159-1.917,2.239",
    transform: "translate(-125.998 -155.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9795",
    "data-name": "Trazado 9795",
    d: "M206.014,257.067l2.239,2.066c.723-.792,1.412-1.584,2.066-2.411l-2.388-1.894q-.911,1.159-1.917,2.239Zm0,0",
    transform: "translate(-125.998 -155.422)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9796",
    "data-name": "Trazado 9796",
    d: "M202.055,249.973q-.852,1.071-1.78,2.078l2.239,2.055q1-1.079,1.917-2.239Zm0,0",
    transform: "translate(-122.497 -152.461)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9797",
    "data-name": "Trazado 9797",
    d: "M226.779,260.906a3.62,3.62,0,0,0-.643-1.986c-.459.665-.93,1.331-1.435,1.974a3.654,3.654,0,0,0,2.078.012",
    transform: "translate(-137.395 -157.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9798",
    "data-name": "Trazado 9798",
    d: "M226.779,260.906a3.62,3.62,0,0,0-.643-1.986c-.459.665-.93,1.331-1.435,1.974a3.654,3.654,0,0,0,2.078.012Zm0,0",
    transform: "translate(-137.395 -157.918)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9799",
    "data-name": "Trazado 9799",
    d: "M218.969,253.063c-.585.872-1.205,1.722-1.86,2.56a9.511,9.511,0,0,0,2.962,1.7q.743-.969,1.436-1.975a9.788,9.788,0,0,0-2.538-2.284",
    transform: "translate(-132.765 -154.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9800",
    "data-name": "Trazado 9800",
    d: "M218.969,253.063c-.585.872-1.205,1.722-1.86,2.56a9.511,9.511,0,0,0,2.962,1.7q.743-.969,1.436-1.975a9.788,9.788,0,0,0-2.538-2.284Zm0,0",
    transform: "translate(-132.765 -154.346)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9801",
    "data-name": "Trazado 9801",
    d: "M212.692,248.707c-.539.8-1.125,1.6-1.734,2.376l2.147,1.688c.08.069.161.126.252.2q.976-1.246,1.86-2.56c-.08-.057-.172-.126-.252-.184Zm0,0",
    transform: "translate(-129.013 -151.689)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9802",
    "data-name": "Trazado 9802",
    d: "M206.421,244.352q-.746,1.129-1.584,2.192l2.387,1.883q.914-1.153,1.734-2.376Zm0,0",
    transform: "translate(-125.28 -149.033)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9803",
    "data-name": "Trazado 9803",
    d: "M225.241,249.118a3.762,3.762,0,0,0-1.619-2.617q-.695,1.233-1.481,2.411a3.9,3.9,0,0,0,3.1.207",
    transform: "translate(-135.834 -150.343)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9804",
    "data-name": "Trazado 9804",
    d: "M225.241,249.118a3.762,3.762,0,0,0-1.619-2.617q-.695,1.233-1.481,2.411A3.9,3.9,0,0,0,225.241,249.118Zm0,0",
    transform: "translate(-135.834 -150.343)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9805",
    "data-name": "Trazado 9805",
    d: "M217.664,242.763l-.735-.413q-.708,1.268-1.527,2.468l.689.459a14.89,14.89,0,0,0,1.94,1.1q.785-1.177,1.481-2.411a16.583,16.583,0,0,0-1.848-1.205",
    transform: "translate(-131.723 -147.812)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9806",
    "data-name": "Trazado 9806",
    d: "M217.664,242.763l-.735-.413q-.708,1.268-1.527,2.468l.689.459a14.89,14.89,0,0,0,1.94,1.1q.785-1.177,1.481-2.411a16.581,16.581,0,0,0-1.848-1.205Zm0,0",
    transform: "translate(-131.723 -147.812)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9807",
    "data-name": "Trazado 9807",
    d: "M208.927,240.78l2.537,1.688q.806-1.2,1.515-2.469l-2.652-1.5c-.437.769-.9,1.538-1.4,2.285",
    transform: "translate(-127.774 -145.461)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9808",
    "data-name": "Trazado 9808",
    d: "M208.927,240.78l2.537,1.688q.806-1.2,1.515-2.469l-2.652-1.5c-.437.769-.9,1.538-1.4,2.285Zm0,0",
    transform: "translate(-127.774 -145.461)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9809",
    "data-name": "Trazado 9809",
    d: "M228.286,241.561a3.113,3.113,0,0,0-.378-1.182q-.379.789-.792,1.561a2.7,2.7,0,0,0,1.171-.379",
    transform: "translate(-138.867 -146.61)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9810",
    "data-name": "Trazado 9810",
    d: "M228.286,241.561a3.113,3.113,0,0,0-.378-1.182q-.379.789-.792,1.561A2.7,2.7,0,0,0,228.286,241.561Zm0,0",
    transform: "translate(-138.867 -146.61)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9811",
    "data-name": "Trazado 9811",
    d: "M220.746,235.229q-.645,1.4-1.4,2.755a5.67,5.67,0,0,0,3.031.815q.413-.772.792-1.561a5.656,5.656,0,0,0-2.422-2.009",
    transform: "translate(-134.129 -143.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9812",
    "data-name": "Trazado 9812",
    d: "M220.746,235.229q-.645,1.4-1.4,2.755a5.67,5.67,0,0,0,3.031.815q.413-.772.792-1.561a5.656,5.656,0,0,0-2.422-2.009Zm0,0",
    transform: "translate(-134.129 -143.469)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9813",
    "data-name": "Trazado 9813",
    d: "M215.732,232.793l-1.906-.861q-.606,1.3-1.309,2.56l1.8,1.022c.287.16.574.321.861.459q.758-1.347,1.4-2.755c-.275-.149-.562-.287-.849-.425",
    transform: "translate(-129.964 -141.458)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9814",
    "data-name": "Trazado 9814",
    d: "M215.732,232.793l-1.906-.861q-.606,1.3-1.309,2.56l1.8,1.022c.287.16.574.321.861.459q.758-1.347,1.4-2.755c-.275-.149-.562-.287-.849-.425Zm0,0",
    transform: "translate(-129.964 -141.458)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9815",
    "data-name": "Trazado 9815",
    d: "M225.806,231.146a3.7,3.7,0,0,0-1.757-2.009q-.413,1.112-.907,2.192a3.657,3.657,0,0,0,2.663-.183",
    transform: "translate(-136.444 -139.753)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9816",
    "data-name": "Trazado 9816",
    d: "M225.806,231.146a3.7,3.7,0,0,0-1.757-2.009q-.413,1.112-.907,2.192a3.657,3.657,0,0,0,2.663-.183Zm0,0",
    transform: "translate(-136.444 -139.753)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9817",
    "data-name": "Trazado 9817",
    d: "M216.807,225.958q-.429,1.187-.964,2.33l.494.23a15.923,15.923,0,0,0,2.353.872q.493-1.079.907-2.193a14.716,14.716,0,0,0-2.285-1.045Zm0,0",
    transform: "translate(-131.992 -137.814)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9818",
    "data-name": "Trazado 9818",
    d: "M209.455,282.753c-1.687.023-2.939-.964-4.236-2.411q1.3-1.025,2.526-2.147c1.217,1.5,2,2.893,1.711,4.558",
    transform: "translate(-125.513 -169.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9819",
    "data-name": "Trazado 9819",
    d: "M209.455,282.753c-1.687.023-2.939-.964-4.236-2.411q1.3-1.025,2.526-2.147C208.962,279.7,209.742,281.088,209.455,282.753Zm0,0",
    transform: "translate(-125.513 -169.674)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9820",
    "data-name": "Trazado 9820",
    d: "M200.859,275.2l-1.114-1.424c.815-.642,1.619-1.331,2.411-2.055l1.217,1.332q.532.583,1.033,1.194c-.827.746-1.665,1.469-2.526,2.147-.333-.368-.666-.769-1.022-1.194",
    transform: "translate(-122.174 -165.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9821",
    "data-name": "Trazado 9821",
    d: "M200.859,275.2l-1.114-1.424c.815-.642,1.619-1.331,2.411-2.055l1.217,1.332q.532.583,1.033,1.194c-.827.746-1.665,1.469-2.526,2.147C201.548,276.026,201.214,275.624,200.859,275.2Zm0,0",
    transform: "translate(-122.174 -165.725)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9822",
    "data-name": "Trazado 9822",
    d: "M197.128,265.953l2.067,2.25c-.792.723-1.6,1.412-2.422,2.055l-1.883-2.376q1.155-.922,2.238-1.929",
    transform: "translate(-119.213 -162.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9823",
    "data-name": "Trazado 9823",
    d: "M197.128,265.953l2.067,2.25c-.792.723-1.6,1.412-2.422,2.055l-1.883-2.376q1.155-.922,2.238-1.929Zm0,0",
    transform: "translate(-119.213 -162.207)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9824",
    "data-name": "Trazado 9824",
    d: "M190.034,261.994q1.071-.852,2.078-1.78l2.055,2.239q-1.082,1.006-2.238,1.929Zm0,0",
    transform: "translate(-116.251 -158.707)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9825",
    "data-name": "Trazado 9825",
    d: "M200.955,286.729a3.62,3.62,0,0,1-1.975-.654q1.006-.691,1.975-1.435a3.6,3.6,0,0,1,0,2.089",
    transform: "translate(-121.708 -173.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9826",
    "data-name": "Trazado 9826",
    d: "M200.955,286.729a3.62,3.62,0,0,1-1.975-.654q1.006-.691,1.975-1.435A3.6,3.6,0,0,1,200.955,286.729Zm0,0",
    transform: "translate(-121.708 -173.605)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9827",
    "data-name": "Trazado 9827",
    d: "M193.094,278.908c.873-.585,1.734-1.205,2.56-1.859a9.474,9.474,0,0,1,1.711,2.962c-.643.505-1.309.976-1.975,1.435a9.623,9.623,0,0,1-2.3-2.537",
    transform: "translate(-118.118 -168.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9828",
    "data-name": "Trazado 9828",
    d: "M193.094,278.908c.873-.585,1.734-1.205,2.56-1.859a9.474,9.474,0,0,1,1.711,2.962c-.643.505-1.309.976-1.975,1.435A9.623,9.623,0,0,1,193.094,278.908Zm0,0",
    transform: "translate(-118.118 -168.974)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9829",
    "data-name": "Trazado 9829",
    d: "M188.768,272.63q1.222-.819,2.376-1.733l1.688,2.147c.069.08.126.172.2.253q-1.249.972-2.56,1.86a2.031,2.031,0,0,1-.184-.252Zm0,0",
    transform: "translate(-115.479 -165.223)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9830",
    "data-name": "Trazado 9830",
    d: "M184.413,266.371c.746-.505,1.481-1.033,2.181-1.6l1.894,2.387q-1.156.918-2.388,1.734Zm0,0",
    transform: "translate(-112.823 -161.49)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9831",
    "data-name": "Trazado 9831",
    d: "M189.16,285.18a3.768,3.768,0,0,1-2.628-1.619q1.235-.691,2.411-1.481a3.858,3.858,0,0,1,.218,3.1",
    transform: "translate(-114.115 -172.044)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9832",
    "data-name": "Trazado 9832",
    d: "M189.16,285.18a3.768,3.768,0,0,1-2.628-1.619q1.235-.691,2.411-1.481a3.858,3.858,0,0,1,.218,3.1Zm0,0",
    transform: "translate(-114.115 -172.044)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9833",
    "data-name": "Trazado 9833",
    d: "M182.825,277.62l-.413-.735q1.261-.712,2.468-1.516l.459.689a13.462,13.462,0,0,1,1.091,1.929q-1.172.793-2.411,1.481a16.583,16.583,0,0,1-1.194-1.848",
    transform: "translate(-111.603 -167.951)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9834",
    "data-name": "Trazado 9834",
    d: "M182.825,277.62l-.413-.735q1.261-.712,2.468-1.516l.459.689a13.462,13.462,0,0,1,1.091,1.929q-1.172.793-2.411,1.481a16.578,16.578,0,0,1-1.194-1.848Zm0,0",
    transform: "translate(-111.603 -167.951)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9835",
    "data-name": "Trazado 9835",
    d: "M180.823,268.866l1.688,2.537q-1.207.81-2.48,1.516l-1.5-2.641q1.178-.657,2.3-1.412",
    transform: "translate(-109.233 -163.984)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9836",
    "data-name": "Trazado 9836",
    d: "M180.823,268.866l1.688,2.537q-1.207.81-2.48,1.516l-1.5-2.641Q179.7,269.621,180.823,268.866Zm0,0",
    transform: "translate(-109.233 -163.984)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9837",
    "data-name": "Trazado 9837",
    d: "M181.622,288.236a3,3,0,0,1-1.182-.39q.787-.382,1.561-.792a2.8,2.8,0,0,1-.379,1.182",
    transform: "translate(-110.4 -175.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9838",
    "data-name": "Trazado 9838",
    d: "M181.622,288.236a3,3,0,0,1-1.182-.39q.787-.382,1.561-.792a2.8,2.8,0,0,1-.379,1.182Zm0,0",
    transform: "translate(-110.4 -175.077)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9839",
    "data-name": "Trazado 9839",
    d: "M175.26,280.7q1.409-.654,2.767-1.412a5.776,5.776,0,0,1,.815,3.031q-.772.413-1.562.792a5.716,5.716,0,0,1-2.021-2.411",
    transform: "translate(-107.24 -170.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9840",
    "data-name": "Trazado 9840",
    d: "M175.26,280.7q1.409-.654,2.767-1.412a5.776,5.776,0,0,1,.815,3.031q-.772.413-1.562.792A5.716,5.716,0,0,1,175.26,280.7Zm0,0",
    transform: "translate(-107.24 -170.338)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9841",
    "data-name": "Trazado 9841",
    d: "M172.825,275.671l-.861-1.906c.873-.4,1.734-.827,2.571-1.309l1.022,1.8c.161.287.31.574.459.861q-1.353.758-2.767,1.4c-.138-.275-.287-.562-.425-.849",
    transform: "translate(-105.23 -166.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9842",
    "data-name": "Trazado 9842",
    d: "M172.825,275.671l-.861-1.906c.873-.4,1.734-.827,2.571-1.309l1.022,1.8c.161.287.31.574.459.861q-1.353.758-2.767,1.4c-.138-.275-.287-.562-.425-.849Zm0,0",
    transform: "translate(-105.23 -166.174)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9843",
    "data-name": "Trazado 9843",
    d: "M171.207,285.744A3.681,3.681,0,0,1,169.2,284q1.112-.419,2.192-.918a3.716,3.716,0,0,1-.183,2.663",
    transform: "translate(-103.543 -172.654)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9844",
    "data-name": "Trazado 9844",
    d: "M171.207,285.744A3.681,3.681,0,0,1,169.2,284q1.112-.419,2.192-.918A3.716,3.716,0,0,1,171.207,285.744Zm0,0",
    transform: "translate(-103.543 -172.654)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9845",
    "data-name": "Trazado 9845",
    d: "M166.02,276.776c.792-.3,1.561-.62,2.33-.964l.218.482a15.257,15.257,0,0,1,.884,2.353q-1.079.5-2.193.918a14.364,14.364,0,0,1-1.045-2.3Zm0,0",
    transform: "translate(-101.605 -168.221)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9846",
    "data-name": "Trazado 9846",
    d: "M132.272,323.647a4.734,4.734,0,0,1-1.744-3.456c.585.012,1.159.034,1.745.034s1.159-.023,1.745-.034a4.772,4.772,0,0,1-1.745,3.455",
    transform: "translate(-79.958 -195.288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9847",
    "data-name": "Trazado 9847",
    d: "M132.272,323.647a4.734,4.734,0,0,1-1.744-3.456c.585.012,1.159.034,1.745.034s1.159-.023,1.745-.034a4.772,4.772,0,0,1-1.745,3.455Zm0,0",
    transform: "translate(-79.958 -195.288)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9848",
    "data-name": "Trazado 9848",
    d: "M130.4,312.778a21.262,21.262,0,0,1-.069-2.744l.08-2q1.733.069,3.467,0l.08,2a21.062,21.062,0,0,1-.069,2.744c-.585.012-1.159.034-1.745.034s-1.16-.023-1.745-.034",
    transform: "translate(-79.83 -187.875)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9849",
    "data-name": "Trazado 9849",
    d: "M130.4,312.778a21.262,21.262,0,0,1-.069-2.744l.08-2q1.733.069,3.467,0l.08,2a21.062,21.062,0,0,1-.069,2.744c-.585.012-1.159.034-1.745.034S130.986,312.789,130.4,312.778Zm0,0",
    transform: "translate(-79.83 -187.875)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9850",
    "data-name": "Trazado 9850",
    d: "M132.29,299.389c.54,0,1.068-.012,1.6-.034l.138,3.387q-1.733.069-3.467,0l.138-3.387c.528.023,1.056.034,1.6.034",
    transform: "translate(-79.976 -182.58)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9851",
    "data-name": "Trazado 9851",
    d: "M132.29,299.389c.54,0,1.068-.012,1.6-.034l.138,3.387q-1.733.069-3.467,0l.138-3.387c.528.023,1.056.034,1.6.034Zm0,0",
    transform: "translate(-79.976 -182.58)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9852",
    "data-name": "Trazado 9852",
    d: "M130.91,294.6l.115-3.042q1.48.069,2.962,0l.115,3.042q-1.595.07-3.191,0",
    transform: "translate(-80.191 -177.823)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9853",
    "data-name": "Trazado 9853",
    d: "M130.91,294.6l.115-3.042q1.48.069,2.962,0l.115,3.042q-1.595.07-3.191,0Zm0,0",
    transform: "translate(-80.191 -177.823)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9854",
    "data-name": "Trazado 9854",
    d: "M132.685,283.792c.46,0,.907-.012,1.355-.035l.126,3.043q-1.48.069-2.962,0l.115-3.043c.459.023.907.035,1.366.035",
    transform: "translate(-80.371 -173.066)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9855",
    "data-name": "Trazado 9855",
    d: "M132.685,283.792c.46,0,.907-.012,1.355-.035l.126,3.043q-1.48.069-2.962,0l.115-3.043c.459.023.907.035,1.366.035Zm0,0",
    transform: "translate(-80.371 -173.066)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9856",
    "data-name": "Trazado 9856",
    d: "M141.66,312.067c1.205-1.182,1.4-2.767,1.286-4.707-1.079.126-2.181.218-3.295.264.2,1.929.631,3.455,2.009,4.443",
    transform: "translate(-85.522 -187.462)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9857",
    "data-name": "Trazado 9857",
    d: "M141.66,312.067c1.205-1.182,1.4-2.767,1.286-4.707-1.079.126-2.181.218-3.295.264.2,1.929.631,3.455,2.009,4.443Zm0,0",
    transform: "translate(-85.522 -187.462)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9858",
    "data-name": "Trazado 9858",
    d: "M142.514,300.528l-.207-1.791c-1.045.126-2.1.207-3.157.241l.069,1.814c.034.551.069,1.068.126,1.573,1.1-.046,2.2-.138,3.295-.264q-.041-.788-.126-1.573",
    transform: "translate(-85.217 -182.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9859",
    "data-name": "Trazado 9859",
    d: "M142.514,300.528l-.207-1.791c-1.045.126-2.1.207-3.157.241l.069,1.814c.034.551.069,1.068.126,1.573,1.1-.046,2.2-.138,3.295-.264Q142.6,301.313,142.514,300.528Zm0,0",
    transform: "translate(-85.217 -182.203)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9860",
    "data-name": "Trazado 9860",
    d: "M138.8,291.2l.138,3.042q1.583-.051,3.157-.241l-.344-3.031q-1.47.176-2.951.23",
    transform: "translate(-85.001 -177.464)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9861",
    "data-name": "Trazado 9861",
    d: "M138.8,291.2l.138,3.042q1.583-.051,3.157-.241l-.344-3.031c-.976.115-1.952.2-2.951.23Zm0,0",
    transform: "translate(-85.001 -177.464)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9862",
    "data-name": "Trazado 9862",
    d: "M141.206,283.228q-1.362.155-2.733.207l.126,3.042q1.479-.053,2.951-.229Zm0,0",
    transform: "translate(-84.804 -172.744)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9863",
    "data-name": "Trazado 9863",
    d: "M151.067,308.072a3.561,3.561,0,0,0,.941-1.86q-1.188.224-2.411.379a3.719,3.719,0,0,0,1.469,1.481",
    transform: "translate(-91.589 -186.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9864",
    "data-name": "Trazado 9864",
    d: "M151.067,308.072a3.561,3.561,0,0,0,.941-1.86q-1.188.224-2.411.379A3.719,3.719,0,0,0,151.067,308.072Zm0,0",
    transform: "translate(-91.589 -186.762)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9865",
    "data-name": "Trazado 9865",
    d: "M150.455,297.472c-1.022.207-2.067.367-3.123.493a9.9,9.9,0,0,0,.884,3.295q1.223-.155,2.411-.379a9.5,9.5,0,0,0-.172-3.409",
    transform: "translate(-90.207 -181.431)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9866",
    "data-name": "Trazado 9866",
    d: "M150.455,297.472c-1.022.207-2.067.367-3.123.493a9.9,9.9,0,0,0,.884,3.295q1.223-.155,2.411-.379a9.5,9.5,0,0,0-.172-3.409Zm0,0",
    transform: "translate(-90.207 -181.431)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9867",
    "data-name": "Trazado 9867",
    d: "M149.295,289.82c-.953.183-1.929.333-2.9.448l.321,2.72a3.036,3.036,0,0,0,.046.31q1.57-.184,3.122-.493c-.012-.1-.034-.207-.046-.31Zm0,0",
    transform: "translate(-89.632 -176.764)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9868",
    "data-name": "Trazado 9868",
    d: "M148.141,282.139q-1.321.274-2.663.425l.356,3.019c.976-.115,1.952-.264,2.9-.448Zm0,0",
    transform: "translate(-89.076 -172.079)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9869",
    "data-name": "Trazado 9869",
    d: "M157.839,298.7a3.748,3.748,0,0,0,.712-3c-.9.241-1.814.47-2.744.654a3.925,3.925,0,0,0,2.032,2.342",
    transform: "translate(-95.376 -180.354)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9870",
    "data-name": "Trazado 9870",
    d: "M157.839,298.7a3.748,3.748,0,0,0,.712-3c-.9.241-1.814.47-2.744.654a3.925,3.925,0,0,0,2.032,2.342Zm0,0",
    transform: "translate(-95.376 -180.354)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9871",
    "data-name": "Trazado 9871",
    d: "M156.907,288.888l-.218-.8q-1.4.393-2.824.665l.161.815a13.781,13.781,0,0,0,.6,2.147c.93-.2,1.849-.414,2.744-.654a15.943,15.943,0,0,0-.459-2.17",
    transform: "translate(-94.191 -175.705)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9872",
    "data-name": "Trazado 9872",
    d: "M156.907,288.888l-.218-.8q-1.4.393-2.824.665l.161.815a13.781,13.781,0,0,0,.6,2.147c.93-.2,1.849-.414,2.744-.654a15.943,15.943,0,0,0-.459-2.17Zm0,0",
    transform: "translate(-94.191 -175.705)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9873",
    "data-name": "Trazado 9873",
    d: "M152.335,281.17l.6,2.985q1.426-.272,2.824-.666l-.8-2.939q-1.3.363-2.618.62",
    transform: "translate(-93.258 -171.11)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9874",
    "data-name": "Trazado 9874",
    d: "M152.335,281.17l.6,2.985q1.426-.272,2.824-.666l-.8-2.939Q153.657,280.913,152.335,281.17Zm0,0",
    transform: "translate(-93.258 -171.11)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9875",
    "data-name": "Trazado 9875",
    d: "M166.268,294.748a2.962,2.962,0,0,0,.563-1.1c-.551.2-1.1.367-1.665.54a2.865,2.865,0,0,0,1.1.563",
    transform: "translate(-101.084 -179.098)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9876",
    "data-name": "Trazado 9876",
    d: "M166.268,294.748a2.962,2.962,0,0,0,.563-1.1c-.551.2-1.1.367-1.665.54a2.865,2.865,0,0,0,1.1.563Zm0,0",
    transform: "translate(-101.084 -179.098)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9877",
    "data-name": "Trazado 9877",
    d: "M164.1,285.612q-1.451.536-2.939.964a5.8,5.8,0,0,0,1.562,2.709c.563-.172,1.114-.344,1.665-.54a5.663,5.663,0,0,0-.287-3.134",
    transform: "translate(-98.642 -174.198)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9878",
    "data-name": "Trazado 9878",
    d: "M164.1,285.612q-1.451.536-2.939.964a5.8,5.8,0,0,0,1.562,2.709q.838-.252,1.665-.54A5.663,5.663,0,0,0,164.1,285.612Zm0,0",
    transform: "translate(-98.642 -174.198)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9879",
    "data-name": "Trazado 9879",
    d: "M162.493,280.236l-.735-1.952q-1.351.5-2.744.884l.551,2c.092.31.183.632.287.93q1.494-.416,2.95-.953c-.1-.3-.207-.609-.31-.907",
    transform: "translate(-97.332 -169.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9880",
    "data-name": "Trazado 9880",
    d: "M162.493,280.236l-.735-1.952q-1.351.5-2.744.884l.551,2c.092.31.183.632.287.93q1.494-.416,2.95-.953C162.7,280.844,162.6,280.534,162.493,280.236Zm0,0",
    transform: "translate(-97.332 -169.728)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9881",
    "data-name": "Trazado 9881",
    d: "M252.128,201.6c-1.194,1.205-2.767,1.4-4.707,1.3.126-1.091.218-2.192.252-3.306,1.929.2,3.467.631,4.454,2.009",
    transform: "translate(-151.252 -121.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9882",
    "data-name": "Trazado 9882",
    d: "M252.128,201.6c-1.194,1.205-2.767,1.4-4.707,1.3.126-1.091.218-2.192.252-3.306,1.929.2,3.467.631,4.454,2.009Zm0,0",
    transform: "translate(-151.252 -121.732)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9883",
    "data-name": "Trazado 9883",
    d: "M240.589,202.453l-1.791-.2c.115-1.045.207-2.1.241-3.169l1.814.08c.551.023,1.068.057,1.573.115-.057,1.113-.138,2.216-.264,3.306-.505-.034-1.022-.08-1.573-.138",
    transform: "translate(-145.993 -121.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9884",
    "data-name": "Trazado 9884",
    d: "M240.589,202.453l-1.791-.2c.115-1.045.207-2.1.241-3.169l1.814.08c.551.023,1.068.057,1.573.115-.057,1.113-.138,2.216-.264,3.306-.505-.034-1.022-.08-1.573-.138Zm0,0",
    transform: "translate(-145.993 -121.426)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9885",
    "data-name": "Trazado 9885",
    d: "M231.258,198.766l3.043.126c-.035,1.068-.127,2.124-.241,3.169l-3.031-.356c.115-.965.2-1.952.23-2.939",
    transform: "translate(-141.254 -121.229)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9886",
    "data-name": "Trazado 9886",
    d: "M231.258,198.766l3.043.126c-.035,1.068-.127,2.124-.241,3.169l-3.031-.356c.115-.965.2-1.952.23-2.939Zm0,0",
    transform: "translate(-141.254 -121.229)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9887",
    "data-name": "Trazado 9887",
    d: "M223.289,201.145c.1-.907.172-1.814.207-2.733l3.042.138q-.054,1.473-.229,2.939Zm0,0",
    transform: "translate(-136.534 -121.013)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9888",
    "data-name": "Trazado 9888",
    d: "M248.133,211.035a3.783,3.783,0,0,1-1.86.941q.224-1.205.379-2.411a3.578,3.578,0,0,1,1.481,1.469",
    transform: "translate(-150.552 -127.816)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9889",
    "data-name": "Trazado 9889",
    d: "M248.133,211.035a3.783,3.783,0,0,1-1.86.941q.224-1.205.379-2.411a3.578,3.578,0,0,1,1.481,1.469Zm0,0",
    transform: "translate(-150.552 -127.816)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9890",
    "data-name": "Trazado 9890",
    d: "M237.533,210.4c.2-1.033.367-2.078.482-3.134a9.63,9.63,0,0,1,3.306.9q-.155,1.205-.378,2.411a10.06,10.06,0,0,1-3.41-.172",
    transform: "translate(-145.221 -126.417)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9891",
    "data-name": "Trazado 9891",
    d: "M237.533,210.4c.2-1.033.367-2.078.482-3.134a9.63,9.63,0,0,1,3.306.9q-.155,1.205-.378,2.411A10.06,10.06,0,0,1,237.533,210.4Zm0,0",
    transform: "translate(-145.221 -126.417)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9892",
    "data-name": "Trazado 9892",
    d: "M229.852,209.234c.2-.953.344-1.917.459-2.9l2.72.321c.1.012.207.034.31.046-.126,1.056-.3,2.1-.493,3.134-.1-.023-.207-.034-.31-.057Zm0,0",
    transform: "translate(-140.537 -125.842)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9893",
    "data-name": "Trazado 9893",
    d: "M222.2,208.092c.172-.884.31-1.768.425-2.675l3.019.356q-.167,1.462-.459,2.9Zm0,0",
    transform: "translate(-135.87 -125.286)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9894",
    "data-name": "Trazado 9894",
    d: "M238.746,217.79a3.808,3.808,0,0,1-3.008.712c.252-.907.47-1.825.666-2.755a3.94,3.94,0,0,1,2.342,2.044",
    transform: "translate(-144.127 -131.586)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9895",
    "data-name": "Trazado 9895",
    d: "M238.746,217.79a3.808,3.808,0,0,1-3.008.712c.252-.907.47-1.825.666-2.755A3.94,3.94,0,0,1,238.746,217.79Zm0,0",
    transform: "translate(-144.127 -131.586)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9896",
    "data-name": "Trazado 9896",
    d: "M228.949,216.858l-.8-.229q.387-1.4.666-2.824l.815.172a14.133,14.133,0,0,1,2.147.586q-.288,1.388-.666,2.755a16.263,16.263,0,0,1-2.158-.459",
    transform: "translate(-139.496 -130.401)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9897",
    "data-name": "Trazado 9897",
    d: "M228.949,216.858l-.8-.229q.387-1.4.666-2.824l.815.172a14.134,14.134,0,0,1,2.147.586c-.2.93-.413,1.848-.666,2.755A16.265,16.265,0,0,1,228.949,216.858Zm0,0",
    transform: "translate(-139.496 -130.401)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9898",
    "data-name": "Trazado 9898",
    d: "M221.231,212.3l2.985.586c-.184.953-.413,1.894-.666,2.824l-2.939-.8q.362-1.29.62-2.606",
    transform: "translate(-134.9 -129.486)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9899",
    "data-name": "Trazado 9899",
    d: "M221.231,212.3l2.985.586c-.184.953-.413,1.894-.666,2.824l-2.939-.8q.362-1.29.62-2.606Zm0,0",
    transform: "translate(-134.9 -129.486)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9900",
    "data-name": "Trazado 9900",
    d: "M234.809,226.207a3.173,3.173,0,0,1-1.1.574c.183-.563.367-1.114.539-1.676a2.951,2.951,0,0,1,.563,1.1",
    transform: "translate(-142.888 -137.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9901",
    "data-name": "Trazado 9901",
    d: "M234.809,226.207a3.173,3.173,0,0,1-1.1.574c.183-.563.367-1.114.539-1.676A2.951,2.951,0,0,1,234.809,226.207Zm0,0",
    transform: "translate(-142.888 -137.294)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9902",
    "data-name": "Trazado 9902",
    d: "M225.673,224.053q.538-1.455.953-2.951a5.781,5.781,0,0,1,2.721,1.562q-.259.841-.539,1.676a5.763,5.763,0,0,1-3.134-.287",
    transform: "translate(-137.988 -134.852)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9903",
    "data-name": "Trazado 9903",
    d: "M225.673,224.053q.538-1.455.953-2.951a5.781,5.781,0,0,1,2.721,1.562q-.259.841-.539,1.676a5.763,5.763,0,0,1-3.134-.287Zm0,0",
    transform: "translate(-137.988 -134.852)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9904",
    "data-name": "Trazado 9904",
    d: "M220.278,222.432l-1.963-.735c.333-.9.643-1.814.9-2.744l2,.551c.31.092.632.183.93.287q-.414,1.495-.953,2.951-.459-.137-.907-.31",
    transform: "translate(-133.5 -133.542)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9905",
    "data-name": "Trazado 9905",
    d: "M220.278,222.432l-1.963-.735c.333-.9.643-1.814.9-2.744l2,.551c.31.092.632.183.93.287q-.414,1.495-.953,2.951Q220.726,222.606,220.278,222.432Zm0,0",
    transform: "translate(-133.5 -133.542)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9906",
    "data-name": "Trazado 9906",
    d: "M40.121,100.06a4.686,4.686,0,0,0,1.217,3.673c.39-.425.792-.838,1.205-1.251s.826-.812,1.251-1.205a4.676,4.676,0,0,0-3.673-1.217",
    transform: "translate(-24.795 -61.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9907",
    "data-name": "Trazado 9907",
    d: "M40.121,100.06a4.686,4.686,0,0,0,1.217,3.673c.39-.425.792-.838,1.205-1.251s.826-.812,1.251-1.205a4.676,4.676,0,0,0-3.673-1.217Zm0,0",
    transform: "translate(-24.795 -61.005)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9908",
    "data-name": "Trazado 9908",
    d: "M43.3,105.677a21.039,21.039,0,0,0,1.883,1.986l1.469,1.355c.39-.413.792-.838,1.194-1.251s.836-.8,1.263-1.194l-1.366-1.47a19.986,19.986,0,0,0-1.986-1.894q-.634.6-1.251,1.217c-.414.413-.815.826-1.205,1.251",
    transform: "translate(-26.756 -62.948)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9909",
    "data-name": "Trazado 9909",
    d: "M43.3,105.677a21.039,21.039,0,0,0,1.883,1.986l1.469,1.355c.39-.413.792-.838,1.194-1.251s.836-.8,1.263-1.194l-1.366-1.47a19.986,19.986,0,0,0-1.986-1.894q-.634.6-1.251,1.217c-.414.413-.815.826-1.205,1.251Zm0,0",
    transform: "translate(-26.756 -62.948)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9910",
    "data-name": "Trazado 9910",
    d: "M55.486,115.424q.567-.57,1.159-1.114l-2.3-2.48c-.425.39-.849.792-1.251,1.194s-.815.838-1.205,1.251l2.479,2.3c.367-.39.735-.769,1.114-1.148",
    transform: "translate(-31.998 -68.207)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9911",
    "data-name": "Trazado 9911",
    d: "M55.486,115.424q.567-.57,1.159-1.114l-2.3-2.48c-.425.39-.849.792-1.251,1.194s-.815.838-1.205,1.251l2.479,2.3c.367-.39.735-.769,1.114-1.148Zm0,0",
    transform: "translate(-31.998 -68.207)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9912",
    "data-name": "Trazado 9912",
    d: "M58.249,120.45l2.238,2.066c.333-.356.677-.712,1.022-1.068s.712-.689,1.079-1.022l-2.066-2.238c-.39.367-.781.735-1.159,1.114s-.746.758-1.114,1.148",
    transform: "translate(-35.874 -72.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9913",
    "data-name": "Trazado 9913",
    d: "M58.249,120.45l2.238,2.066c.333-.356.677-.712,1.022-1.068s.712-.689,1.079-1.022l-2.066-2.238c-.39.367-.781.735-1.159,1.114s-.746.758-1.114,1.148Zm0,0",
    transform: "translate(-35.874 -72.084)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9914",
    "data-name": "Trazado 9914",
    d: "M67.168,127.106q.485-.479.987-.941l-2.066-2.239c-.367.333-.723.678-1.079,1.022s-.689.712-1.022,1.068l2.239,2.066q.462-.5.941-.976",
    transform: "translate(-39.374 -75.584)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9915",
    "data-name": "Trazado 9915",
    d: "M67.168,127.106q.485-.479.987-.941l-2.066-2.239c-.367.333-.723.678-1.079,1.022s-.689.712-1.022,1.068l2.239,2.066q.462-.5.941-.976Zm0,0",
    transform: "translate(-39.374 -75.584)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9916",
    "data-name": "Trazado 9916",
    d: "M40.062,113.746c-.012,1.7.964,2.95,2.411,4.247.677-.861,1.4-1.7,2.147-2.525-1.5-1.217-2.893-2-4.557-1.722",
    transform: "translate(-24.782 -69.341)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9917",
    "data-name": "Trazado 9917",
    d: "M40.062,113.746c-.012,1.7.964,2.95,2.411,4.247.677-.861,1.4-1.7,2.147-2.525C43.115,114.251,41.726,113.471,40.062,113.746Zm0,0",
    transform: "translate(-24.782 -69.341)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9918",
    "data-name": "Trazado 9918",
    d: "M47.447,121.783l1.412,1.125c.654-.827,1.343-1.619,2.066-2.411l-1.343-1.228c-.4-.356-.8-.7-1.194-1.022q-1.112,1.224-2.147,2.514c.367.344.769.677,1.205,1.022",
    transform: "translate(-28.551 -72.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9919",
    "data-name": "Trazado 9919",
    d: "M47.447,121.783l1.412,1.125c.654-.827,1.343-1.619,2.066-2.411l-1.343-1.228q-.588-.521-1.194-1.022-1.112,1.224-2.147,2.514c.367.344.769.677,1.205,1.022Zm0,0",
    transform: "translate(-28.551 -72.12)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9920",
    "data-name": "Trazado 9920",
    d: "M57.257,126.081l-2.239-2.066c-.723.792-1.412,1.584-2.066,2.411l2.388,1.894q.911-1.159,1.917-2.239",
    transform: "translate(-32.644 -75.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9921",
    "data-name": "Trazado 9921",
    d: "M57.257,126.081l-2.239-2.066c-.723.792-1.412,1.584-2.066,2.411l2.388,1.894Q56.251,127.161,57.257,126.081Zm0,0",
    transform: "translate(-32.644 -75.638)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9922",
    "data-name": "Trazado 9922",
    d: "M61.449,133.445q.852-1.071,1.78-2.078l-2.239-2.055q-1.005,1.079-1.917,2.239Zm0,0",
    transform: "translate(-36.377 -78.869)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9923",
    "data-name": "Trazado 9923",
    d: "M39.974,125.643a3.622,3.622,0,0,0,.643,1.986c.459-.666.93-1.331,1.435-1.974a3.652,3.652,0,0,0-2.078-.012",
    transform: "translate(-24.728 -76.542)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9924",
    "data-name": "Trazado 9924",
    d: "M39.974,125.643a3.622,3.622,0,0,0,.643,1.986c.459-.666.93-1.331,1.435-1.974a3.652,3.652,0,0,0-2.078-.012Zm0,0",
    transform: "translate(-24.728 -76.542)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9925",
    "data-name": "Trazado 9925",
    d: "M44.159,130.158c.585-.873,1.205-1.722,1.86-2.56a9.515,9.515,0,0,0-2.962-1.7q-.742.969-1.435,1.974a9.772,9.772,0,0,0,2.537,2.285",
    transform: "translate(-25.733 -76.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9926",
    "data-name": "Trazado 9926",
    d: "M44.159,130.158c.585-.873,1.205-1.722,1.86-2.56a9.515,9.515,0,0,0-2.962-1.7q-.742.969-1.435,1.974A9.772,9.772,0,0,0,44.159,130.158Zm0,0",
    transform: "translate(-25.733 -76.787)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9927",
    "data-name": "Trazado 9927",
    d: "M50.651,134.513c.539-.8,1.125-1.6,1.734-2.376l-2.147-1.688c-.081-.069-.161-.126-.253-.2q-.976,1.246-1.86,2.56c.08.069.172.126.252.183Zm0,0",
    transform: "translate(-29.7 -79.443)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9928",
    "data-name": "Trazado 9928",
    d: "M57.137,139.156q.746-1.129,1.584-2.193l-2.388-1.883c-.609.78-1.194,1.572-1.734,2.376Zm0,0",
    transform: "translate(-33.649 -82.387)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9929",
    "data-name": "Trazado 9929",
    d: "M39.915,136.305a3.762,3.762,0,0,0,1.619,2.617q.695-1.233,1.481-2.411a3.9,3.9,0,0,0-3.1-.207",
    transform: "translate(-24.692 -82.992)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9930",
    "data-name": "Trazado 9930",
    d: "M39.915,136.305a3.762,3.762,0,0,0,1.619,2.617q.695-1.233,1.481-2.411a3.9,3.9,0,0,0-3.1-.207Zm0,0",
    transform: "translate(-24.692 -82.992)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9931",
    "data-name": "Trazado 9931",
    d: "M45.912,140.816l.735.413q.708-1.268,1.527-2.468l-.7-.459a14.052,14.052,0,0,0-1.929-1.1q-.786,1.177-1.481,2.411a16.649,16.649,0,0,0,1.848,1.205",
    transform: "translate(-27.223 -83.679)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9932",
    "data-name": "Trazado 9932",
    d: "M45.912,140.816l.735.413q.708-1.268,1.527-2.468l-.7-.459a14.052,14.052,0,0,0-1.929-1.1q-.786,1.177-1.481,2.411a16.649,16.649,0,0,0,1.848,1.205Zm0,0",
    transform: "translate(-27.223 -83.679)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9933",
    "data-name": "Trazado 9933",
    d: "M54.738,142.89,52.2,141.2q-.806,1.2-1.515,2.468l2.641,1.5q.673-1.162,1.412-2.284",
    transform: "translate(-31.261 -86.121)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9934",
    "data-name": "Trazado 9934",
    d: "M54.738,142.89,52.2,141.2q-.806,1.2-1.515,2.468l2.641,1.5q.673-1.162,1.412-2.284Zm0,0",
    transform: "translate(-31.261 -86.121)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9935",
    "data-name": "Trazado 9935",
    d: "M39.885,145.878a3.113,3.113,0,0,0,.379,1.182q.378-.793.8-1.561a2.7,2.7,0,0,0-1.182.378",
    transform: "translate(-24.674 -88.741)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9936",
    "data-name": "Trazado 9936",
    d: "M39.885,145.878a3.113,3.113,0,0,0,.379,1.182q.378-.793.8-1.561a2.7,2.7,0,0,0-1.182.378Zm0,0",
    transform: "translate(-24.674 -88.741)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9937",
    "data-name": "Trazado 9937",
    d: "M43.279,149.048q.645-1.4,1.4-2.755a5.774,5.774,0,0,0-3.031-.815q-.413.772-.792,1.562a5.663,5.663,0,0,0,2.422,2.009",
    transform: "translate(-25.267 -88.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9938",
    "data-name": "Trazado 9938",
    d: "M43.279,149.048q.645-1.4,1.4-2.755a5.774,5.774,0,0,0-3.031-.815q-.413.772-.792,1.562A5.663,5.663,0,0,0,43.279,149.048Zm0,0",
    transform: "translate(-25.267 -88.72)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9939",
    "data-name": "Trazado 9939",
    d: "M47.916,150.768l1.906.861q.606-1.3,1.309-2.56l-1.8-1.033c-.287-.149-.574-.31-.861-.448q-.758,1.347-1.4,2.755c.275.149.563.287.85.425",
    transform: "translate(-29.054 -90.015)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9940",
    "data-name": "Trazado 9940",
    d: "M47.916,150.768l1.906.861q.606-1.3,1.309-2.56l-1.8-1.033c-.287-.149-.574-.31-.861-.448q-.758,1.347-1.4,2.755c.275.149.563.287.85.425Zm0,0",
    transform: "translate(-29.054 -90.015)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9941",
    "data-name": "Trazado 9941",
    d: "M40.032,155.051a3.706,3.706,0,0,0,1.757,2.009q.413-1.112.907-2.193a3.661,3.661,0,0,0-2.664.183",
    transform: "translate(-24.763 -94.356)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9942",
    "data-name": "Trazado 9942",
    d: "M40.032,155.051a3.706,3.706,0,0,0,1.757,2.009q.413-1.112.907-2.193a3.661,3.661,0,0,0-2.664.183Zm0,0",
    transform: "translate(-24.763 -94.356)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9943",
    "data-name": "Trazado 9943",
    d: "M47.307,158.554q.429-1.187.965-2.33l-.494-.229a16.338,16.338,0,0,0-2.353-.873c-.333.723-.632,1.458-.918,2.192a15.323,15.323,0,0,0,2.3,1.045Zm0,0",
    transform: "translate(-27.492 -94.61)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9944",
    "data-name": "Trazado 9944",
    d: "M53.83,100c1.688-.023,2.939.965,4.236,2.411-.861.677-1.7,1.4-2.526,2.147-1.217-1.5-2-2.893-1.711-4.557",
    transform: "translate(-33.143 -60.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9945",
    "data-name": "Trazado 9945",
    d: "M53.83,100c1.688-.023,2.939.965,4.236,2.411-.861.677-1.7,1.4-2.526,2.147-1.217-1.5-2-2.893-1.711-4.557Zm0,0",
    transform: "translate(-33.143 -60.99)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9946",
    "data-name": "Trazado 9946",
    d: "M61.874,107.375l1.113,1.423q-1.238.989-2.411,2.055l-1.217-1.332q-.531-.579-1.021-1.194,1.216-1.12,2.514-2.147c.333.367.666.769,1.022,1.194",
    transform: "translate(-35.929 -64.761)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9947",
    "data-name": "Trazado 9947",
    d: "M61.874,107.375l1.113,1.423q-1.238.989-2.411,2.055l-1.217-1.332q-.531-.579-1.021-1.194,1.216-1.12,2.514-2.147c.333.367.666.769,1.022,1.194Zm0,0",
    transform: "translate(-35.929 -64.761)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9948",
    "data-name": "Trazado 9948",
    d: "M66.142,117.2l-2.066-2.25c.792-.723,1.6-1.4,2.422-2.055l1.883,2.376c-.758.609-1.515,1.251-2.239,1.929",
    transform: "translate(-39.428 -68.853)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9949",
    "data-name": "Trazado 9949",
    d: "M66.142,117.2l-2.066-2.25c.792-.723,1.6-1.4,2.422-2.055l1.883,2.376C67.623,115.876,66.866,116.519,66.142,117.2Zm0,0",
    transform: "translate(-39.428 -68.853)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9950",
    "data-name": "Trazado 9950",
    d: "M73.506,121.371q-1.071.852-2.078,1.78l-2.055-2.239c.723-.677,1.481-1.32,2.239-1.928Zm0,0",
    transform: "translate(-42.659 -72.569)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9951",
    "data-name": "Trazado 9951",
    d: "M65.717,99.913a3.522,3.522,0,0,1,1.975.643q-1.006.691-1.975,1.435a3.556,3.556,0,0,1,0-2.078",
    transform: "translate(-40.335 -60.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9952",
    "data-name": "Trazado 9952",
    d: "M65.717,99.913a3.522,3.522,0,0,1,1.975.643q-1.006.691-1.975,1.435A3.556,3.556,0,0,1,65.717,99.913Zm0,0",
    transform: "translate(-40.335 -60.938)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9953",
    "data-name": "Trazado 9953",
    d: "M70.23,104.1q-1.316.879-2.56,1.86A9.338,9.338,0,0,1,65.96,103c.643-.505,1.309-.976,1.975-1.435a9.627,9.627,0,0,1,2.3,2.537",
    transform: "translate(-40.577 -61.943)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9954",
    "data-name": "Trazado 9954",
    d: "M70.23,104.1q-1.316.879-2.56,1.86A9.338,9.338,0,0,1,65.96,103c.643-.505,1.309-.976,1.975-1.435A9.627,9.627,0,0,1,70.23,104.1Zm0,0",
    transform: "translate(-40.577 -61.943)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9955",
    "data-name": "Trazado 9955",
    d: "M74.575,110.59q-1.222.819-2.376,1.734l-1.688-2.147c-.069-.092-.126-.172-.2-.252q1.252-.976,2.571-1.86c.057.08.115.161.172.253Zm0,0",
    transform: "translate(-43.234 -65.909)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9956",
    "data-name": "Trazado 9956",
    d: "M79.217,117.064c-.746.505-1.481,1.033-2.181,1.6l-1.894-2.388q1.153-.914,2.376-1.734Zm0,0",
    transform: "translate(-46.177 -69.859)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9957",
    "data-name": "Trazado 9957",
    d: "M76.367,99.854A3.768,3.768,0,0,1,79,101.473q-1.235.691-2.411,1.481a3.857,3.857,0,0,1-.218-3.1",
    transform: "translate(-46.783 -60.902)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9958",
    "data-name": "Trazado 9958",
    d: "M76.367,99.854A3.768,3.768,0,0,1,79,101.473q-1.235.691-2.411,1.481A3.857,3.857,0,0,1,76.367,99.854Zm0,0",
    transform: "translate(-46.783 -60.902)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9959",
    "data-name": "Trazado 9959",
    d: "M80.894,105.851l.413.735q-1.264.708-2.468,1.515l-.459-.688a13.407,13.407,0,0,1-1.091-1.929q1.172-.793,2.411-1.481a16.656,16.656,0,0,1,1.194,1.848",
    transform: "translate(-47.488 -63.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9960",
    "data-name": "Trazado 9960",
    d: "M80.894,105.851l.413.735q-1.264.708-2.468,1.515l-.459-.688a13.407,13.407,0,0,1-1.091-1.929q1.172-.793,2.411-1.481A16.656,16.656,0,0,1,80.894,105.851Zm0,0",
    transform: "translate(-47.488 -63.432)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9961",
    "data-name": "Trazado 9961",
    d: "M82.951,114.677l-1.688-2.537q1.207-.81,2.48-1.515l1.5,2.641q-1.178.657-2.3,1.412",
    transform: "translate(-49.911 -67.471)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9962",
    "data-name": "Trazado 9962",
    d: "M82.951,114.677l-1.688-2.537q1.207-.81,2.48-1.515l1.5,2.641q-1.178.657-2.3,1.412Zm0,0",
    transform: "translate(-49.911 -67.471)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9963",
    "data-name": "Trazado 9963",
    d: "M85.938,99.824a2.819,2.819,0,0,1,1.183.379q-.789.379-1.561.792a2.7,2.7,0,0,1,.378-1.171",
    transform: "translate(-52.532 -60.884)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9964",
    "data-name": "Trazado 9964",
    d: "M85.938,99.824a2.819,2.819,0,0,1,1.183.379q-.789.379-1.561.792A2.7,2.7,0,0,1,85.938,99.824Zm0,0",
    transform: "translate(-52.532 -60.884)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9965",
    "data-name": "Trazado 9965",
    d: "M89.12,103.218q-1.412.641-2.767,1.4a5.774,5.774,0,0,1-.815-3.031q.772-.413,1.562-.792a5.685,5.685,0,0,1,2.021,2.422",
    transform: "translate(-52.51 -61.477)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9966",
    "data-name": "Trazado 9966",
    d: "M89.12,103.218q-1.412.641-2.767,1.4a5.774,5.774,0,0,1-.815-3.031q.772-.413,1.562-.792A5.685,5.685,0,0,1,89.12,103.218Zm0,0",
    transform: "translate(-52.51 -61.477)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9967",
    "data-name": "Trazado 9967",
    d: "M90.84,107.855l.861,1.906c-.873.4-1.734.827-2.572,1.309l-1.022-1.8c-.161-.287-.321-.574-.459-.861q1.353-.758,2.767-1.4c.138.275.287.563.424.85",
    transform: "translate(-53.806 -65.263)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9968",
    "data-name": "Trazado 9968",
    d: "M90.84,107.855l.861,1.906c-.873.4-1.734.827-2.572,1.309l-1.022-1.8c-.161-.287-.321-.574-.459-.861q1.353-.758,2.767-1.4C90.554,107.28,90.7,107.568,90.84,107.855Zm0,0",
    transform: "translate(-53.806 -65.263)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9969",
    "data-name": "Trazado 9969",
    d: "M.891,192.212a4.736,4.736,0,0,1,3.467-1.745c-.023.574-.046,1.159-.046,1.745s.023,1.159.046,1.734a4.724,4.724,0,0,1-3.467-1.734",
    transform: "translate(-0.891 -116.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9970",
    "data-name": "Trazado 9970",
    d: "M.891,192.212a4.736,4.736,0,0,1,3.467-1.745c-.023.574-.046,1.159-.046,1.745s.023,1.159.046,1.734a4.724,4.724,0,0,1-3.467-1.734Zm0,0",
    transform: "translate(-0.891 -116.168)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9971",
    "data-name": "Trazado 9971",
    d: "M9.708,190.339a20.877,20.877,0,0,1,2.732-.069l2,.08q-.068,1.733,0,3.467l-2,.069a17.62,17.62,0,0,1-2.733-.069c-.023-.574-.046-1.148-.046-1.734s.023-1.16.046-1.745",
    transform: "translate(-6.241 -116.04)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9972",
    "data-name": "Trazado 9972",
    d: "M9.708,190.339a20.877,20.877,0,0,1,2.732-.069l2,.08q-.068,1.733,0,3.467l-2,.069a17.62,17.62,0,0,1-2.733-.069c-.023-.574-.046-1.148-.046-1.734s.023-1.16.046-1.745Zm0,0",
    transform: "translate(-6.241 -116.04)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9973",
    "data-name": "Trazado 9973",
    d: "M25.2,192.23c0,.528.012,1.068.034,1.6l-3.386.138q-.069-1.733,0-3.467l3.386.126q-.035.8-.034,1.607",
    transform: "translate(-13.653 -116.185)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9974",
    "data-name": "Trazado 9974",
    d: "M25.2,192.23c0,.528.012,1.068.034,1.6l-3.386.138q-.069-1.733,0-3.467l3.386.126Q25.2,191.426,25.2,192.23Zm0,0",
    transform: "translate(-13.653 -116.185)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9975",
    "data-name": "Trazado 9975",
    d: "M30.532,190.82l3.042.126q-.068,1.48,0,2.962l-3.042.115q-.035-.8-.034-1.6c0-.539.012-1.068.034-1.607",
    transform: "translate(-18.949 -116.383)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9976",
    "data-name": "Trazado 9976",
    d: "M30.532,190.82l3.042.126q-.068,1.48,0,2.962l-3.042.115q-.035-.8-.034-1.6C30.5,191.888,30.51,191.36,30.532,190.82Zm0,0",
    transform: "translate(-18.949 -116.383)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9977",
    "data-name": "Trazado 9977",
    d: "M41.338,192.624c0,.448.012.907.034,1.354l-3.042.126q-.069-1.48,0-2.962l3.042.115q-.035.682-.034,1.366",
    transform: "translate(-23.705 -116.58)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9978",
    "data-name": "Trazado 9978",
    d: "M41.338,192.624c0,.448.012.907.034,1.354l-3.042.126q-.069-1.48,0-2.962l3.042.115Q41.338,191.941,41.338,192.624Zm0,0",
    transform: "translate(-23.705 -116.58)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9979",
    "data-name": "Trazado 9979",
    d: "M10.515,183.074c1.194-1.205,2.767-1.4,4.707-1.3q-.2,1.647-.252,3.306c-1.929-.2-3.467-.632-4.454-2.009",
    transform: "translate(-6.761 -110.853)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9980",
    "data-name": "Trazado 9980",
    d: "M10.515,183.074c1.194-1.205,2.767-1.4,4.707-1.3q-.2,1.647-.252,3.306c-1.929-.2-3.467-.632-4.454-2.009Zm0,0",
    transform: "translate(-6.761 -110.853)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9981",
    "data-name": "Trazado 9981",
    d: "M23.741,181.952l1.791.207c-.115,1.033-.206,2.089-.241,3.157l-1.814-.08q-.788-.029-1.573-.115c.057-1.114.138-2.216.264-3.306.505.035,1.022.08,1.573.138",
    transform: "translate(-13.707 -110.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9982",
    "data-name": "Trazado 9982",
    d: "M23.741,181.952l1.791.207c-.115,1.033-.206,2.089-.241,3.157l-1.814-.08q-.788-.029-1.573-.115c.057-1.114.138-2.216.264-3.306C22.673,181.849,23.19,181.894,23.741,181.952Zm0,0",
    transform: "translate(-13.707 -110.89)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9983",
    "data-name": "Trazado 9983",
    d: "M33.628,185.98l-3.042-.126c.034-1.068.126-2.124.241-3.157l3.031.344q-.176,1.464-.23,2.939",
    transform: "translate(-19.002 -111.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9984",
    "data-name": "Trazado 9984",
    d: "M33.628,185.98l-3.042-.126c.034-1.068.126-2.124.241-3.157l3.031.344q-.176,1.464-.23,2.939Zm0,0",
    transform: "translate(-19.002 -111.429)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9985",
    "data-name": "Trazado 9985",
    d: "M41.634,183.924q-.155,1.362-.207,2.732l-3.042-.126c.034-1,.115-1.974.229-2.95Zm0,0",
    transform: "translate(-23.759 -111.967)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9986",
    "data-name": "Trazado 9986",
    d: "M18.961,175.074a3.786,3.786,0,0,1,1.86-.941q-.224,1.205-.379,2.411a3.575,3.575,0,0,1-1.481-1.469",
    transform: "translate(-11.912 -106.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9987",
    "data-name": "Trazado 9987",
    d: "M18.961,175.074a3.786,3.786,0,0,1,1.86-.941q-.223,1.2-.379,2.411A3.574,3.574,0,0,1,18.961,175.074Zm0,0",
    transform: "translate(-11.912 -106.206)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9988",
    "data-name": "Trazado 9988",
    d: "M26.546,174.172c-.2,1.033-.368,2.078-.483,3.134a9.632,9.632,0,0,1-3.306-.9q.156-1.205.379-2.411a10.069,10.069,0,0,1,3.409.172",
    transform: "translate(-14.227 -106.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9989",
    "data-name": "Trazado 9989",
    d: "M26.546,174.172c-.2,1.033-.368,2.078-.483,3.134a9.632,9.632,0,0,1-3.306-.9q.156-1.205.379-2.411a10.069,10.069,0,0,1,3.409.172Zm0,0",
    transform: "translate(-14.227 -106.072)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9990",
    "data-name": "Trazado 9990",
    d: "M34.694,175.172q-.292,1.442-.459,2.9l-2.721-.321c-.1-.012-.207-.035-.31-.046.126-1.056.3-2.1.493-3.134.1.023.207.034.31.057Zm0,0",
    transform: "translate(-19.379 -106.475)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9991",
    "data-name": "Trazado 9991",
    d: "M42.417,176.691c-.172.884-.321,1.768-.425,2.675l-3.019-.356q.167-1.462.459-2.9Zm0,0",
    transform: "translate(-24.118 -107.408)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9992",
    "data-name": "Trazado 9992",
    d: "M26.554,167.715A3.809,3.809,0,0,1,29.562,167q-.377,1.366-.666,2.755a3.908,3.908,0,0,1-2.342-2.043",
    transform: "translate(-16.543 -101.83)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9993",
    "data-name": "Trazado 9993",
    d: "M26.554,167.715A3.809,3.809,0,0,1,29.562,167q-.377,1.366-.666,2.755a3.908,3.908,0,0,1-2.342-2.043Zm0,0",
    transform: "translate(-16.543 -101.83)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9994",
    "data-name": "Trazado 9994",
    d: "M35.381,167.529l.8.23q-.387,1.4-.666,2.824l-.815-.161a15.647,15.647,0,0,1-2.147-.6c.2-.93.413-1.849.666-2.756a16.314,16.314,0,0,1,2.158.459",
    transform: "translate(-20.204 -101.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9995",
    "data-name": "Trazado 9995",
    d: "M35.381,167.529l.8.23q-.387,1.4-.666,2.824l-.815-.161a15.647,15.647,0,0,1-2.147-.6c.2-.93.413-1.849.666-2.756a16.314,16.314,0,0,1,2.158.459Zm0,0",
    transform: "translate(-20.204 -101.898)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9996",
    "data-name": "Trazado 9996",
    d: "M43.135,172.245l-2.985-.585c.184-.953.413-1.894.666-2.824l2.939.8q-.361,1.29-.62,2.606",
    transform: "translate(-24.835 -102.975)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9997",
    "data-name": "Trazado 9997",
    d: "M43.135,172.245l-2.985-.585c.184-.953.413-1.894.666-2.824l2.939.8q-.361,1.29-.62,2.606Zm0,0",
    transform: "translate(-24.835 -102.975)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9998",
    "data-name": "Trazado 9998",
    d: "M33.47,161.052a2.986,2.986,0,0,1,1.1-.574c-.184.551-.367,1.114-.539,1.676a2.951,2.951,0,0,1-.563-1.1",
    transform: "translate(-20.761 -97.877)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9999",
    "data-name": "Trazado 9999",
    d: "M33.47,161.052a2.986,2.986,0,0,1,1.1-.574c-.184.551-.367,1.114-.539,1.676A2.951,2.951,0,0,1,33.47,161.052Zm0,0",
    transform: "translate(-20.761 -97.877)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10000",
    "data-name": "Trazado 10000",
    d: "M38.586,160.586q-.539,1.454-.953,2.95a5.779,5.779,0,0,1-2.72-1.561c.172-.562.356-1.125.539-1.676a5.764,5.764,0,0,1,3.134.287",
    transform: "translate(-21.641 -97.698)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10001",
    "data-name": "Trazado 10001",
    d: "M38.586,160.586q-.539,1.454-.953,2.95a5.779,5.779,0,0,1-2.72-1.561c.172-.562.356-1.125.539-1.676a5.764,5.764,0,0,1,3.134.287Zm0,0",
    transform: "translate(-21.641 -97.698)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10002",
    "data-name": "Trazado 10002",
    d: "M43.746,161.524l1.963.735c-.333.9-.643,1.814-.9,2.743l-2-.551c-.31-.092-.632-.184-.93-.287q.414-1.495.953-2.95c.31.092.609.2.907.31",
    transform: "translate(-25.894 -98.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10003",
    "data-name": "Trazado 10003",
    d: "M43.746,161.524l1.963.735c-.333.9-.643,1.814-.9,2.743l-2-.551c-.31-.092-.632-.184-.93-.287q.414-1.495.953-2.95C43.149,161.306,43.448,161.409,43.746,161.524Zm0,0",
    transform: "translate(-25.894 -98.326)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10004",
    "data-name": "Trazado 10004",
    d: "M40.121,284.017a4.672,4.672,0,0,1,1.217-3.673c.39.414.792.838,1.205,1.251s.826.815,1.251,1.205a4.758,4.758,0,0,1-3.673,1.217",
    transform: "translate(-24.795 -170.985)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10005",
    "data-name": "Trazado 10005",
    d: "M40.121,284.017a4.672,4.672,0,0,1,1.217-3.673c.39.414.792.838,1.205,1.251s.826.815,1.251,1.205A4.758,4.758,0,0,1,40.121,284.017Zm0,0",
    transform: "translate(-24.795 -170.985)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10006",
    "data-name": "Trazado 10006",
    d: "M43.3,275.091a21.04,21.04,0,0,1,1.883-1.986l1.469-1.355c.39.425.792.838,1.194,1.251s.838.815,1.263,1.205l-1.366,1.458a18.8,18.8,0,0,1-1.986,1.894q-1.28-1.182-2.457-2.468",
    transform: "translate(-26.756 -165.743)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10007",
    "data-name": "Trazado 10007",
    d: "M43.3,275.091a21.039,21.039,0,0,1,1.883-1.986l1.469-1.355c.39.425.792.838,1.194,1.251s.838.815,1.263,1.205l-1.366,1.458a18.8,18.8,0,0,1-1.986,1.894q-1.28-1.182-2.457-2.468Zm0,0",
    transform: "translate(-26.756 -165.743)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10008",
    "data-name": "Trazado 10008",
    d: "M55.486,267.024q.563.568,1.159,1.1l-2.3,2.491c-.425-.4-.849-.792-1.251-1.205s-.815-.827-1.205-1.251l2.479-2.3c.367.39.735.781,1.114,1.16",
    transform: "translate(-31.998 -162.153)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10009",
    "data-name": "Trazado 10009",
    d: "M55.486,267.024q.563.568,1.159,1.1l-2.3,2.491c-.425-.4-.849-.792-1.251-1.205s-.812-.826-1.205-1.251l2.479-2.3c.367.39.735.781,1.114,1.16Zm0,0",
    transform: "translate(-31.998 -162.153)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10010",
    "data-name": "Trazado 10010",
    d: "M58.249,262.633l2.238-2.066q1,1.1,2.1,2.089L60.522,264.9c-.39-.356-.781-.723-1.159-1.1s-.748-.768-1.114-1.16",
    transform: "translate(-35.874 -158.922)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10011",
    "data-name": "Trazado 10011",
    d: "M58.249,262.633l2.238-2.066q1,1.1,2.1,2.089L60.522,264.9c-.39-.356-.781-.723-1.159-1.1s-.748-.768-1.114-1.16Zm0,0",
    transform: "translate(-35.874 -158.922)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10012",
    "data-name": "Trazado 10012",
    d: "M67.168,256.257q.485.48.987.942l-2.066,2.227q-1.1-.992-2.1-2.09l2.239-2.066c.31.333.62.654.941.987",
    transform: "translate(-39.375 -155.692)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10013",
    "data-name": "Trazado 10013",
    d: "M67.168,256.257q.485.48.987.942l-2.066,2.227q-1.1-.992-2.1-2.09l2.239-2.066C66.536,255.6,66.847,255.924,67.168,256.257Zm0,0",
    transform: "translate(-39.375 -155.692)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10014",
    "data-name": "Trazado 10014",
    d: "M40.062,269.394c-.012-1.688.964-2.939,2.411-4.236q1.026,1.3,2.147,2.514c-1.5,1.229-2.893,2-4.557,1.722",
    transform: "translate(-24.782 -161.723)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10015",
    "data-name": "Trazado 10015",
    d: "M40.062,269.394c-.012-1.688.964-2.939,2.411-4.236q1.026,1.3,2.147,2.514C43.115,268.9,41.726,269.669,40.062,269.394Zm0,0",
    transform: "translate(-24.782 -161.723)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10016",
    "data-name": "Trazado 10016",
    d: "M47.447,260.78l1.412-1.125q.986,1.245,2.066,2.411l-1.343,1.228q-.579.531-1.194,1.022-1.12-1.217-2.147-2.515.585-.531,1.205-1.022",
    transform: "translate(-28.551 -158.366)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10017",
    "data-name": "Trazado 10017",
    d: "M47.447,260.78l1.412-1.125q.986,1.245,2.066,2.411l-1.343,1.228q-.579.531-1.194,1.022-1.12-1.217-2.147-2.515.585-.531,1.205-1.022Zm0,0",
    transform: "translate(-28.551 -158.366)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10018",
    "data-name": "Trazado 10018",
    d: "M57.257,257.049,55.018,259.1q-1.08-1.165-2.066-2.411L55.34,254.8q.916,1.161,1.917,2.25",
    transform: "translate(-32.644 -155.404)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10019",
    "data-name": "Trazado 10019",
    d: "M57.257,257.049,55.018,259.1q-1.08-1.165-2.066-2.411L55.34,254.8q.916,1.161,1.917,2.25Zm0,0",
    transform: "translate(-32.644 -155.404)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10020",
    "data-name": "Trazado 10020",
    d: "M61.449,249.943q.848,1.074,1.78,2.078l-2.239,2.066q-1-1.088-1.917-2.25Zm0,0",
    transform: "translate(-36.377 -152.443)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10021",
    "data-name": "Trazado 10021",
    d: "M39.974,260.894a3.586,3.586,0,0,1,.643-1.975q.691,1.007,1.435,1.975a3.555,3.555,0,0,1-2.078,0",
    transform: "translate(-24.728 -157.917)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10022",
    "data-name": "Trazado 10022",
    d: "M39.974,260.894a3.586,3.586,0,0,1,.643-1.975q.691,1.007,1.435,1.975A3.555,3.555,0,0,1,39.974,260.894Zm0,0",
    transform: "translate(-24.728 -157.917)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10023",
    "data-name": "Trazado 10023",
    d: "M44.159,253.033c.585.873,1.205,1.722,1.86,2.56a9.809,9.809,0,0,1-2.962,1.711q-.738-.972-1.435-1.975a9.805,9.805,0,0,1,2.537-2.3",
    transform: "translate(-25.733 -154.327)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10024",
    "data-name": "Trazado 10024",
    d: "M44.159,253.033c.585.873,1.205,1.722,1.86,2.56a9.809,9.809,0,0,1-2.962,1.711q-.738-.972-1.435-1.975A9.805,9.805,0,0,1,44.159,253.033Zm0,0",
    transform: "translate(-25.733 -154.327)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10025",
    "data-name": "Trazado 10025",
    d: "M50.651,248.678q.816,1.224,1.734,2.376l-2.147,1.7c-.081.057-.161.126-.253.184q-.98-1.243-1.86-2.56c.08-.057.172-.115.252-.183Zm0,0",
    transform: "translate(-29.7 -151.671)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10026",
    "data-name": "Trazado 10026",
    d: "M57.137,244.352q.746,1.123,1.584,2.181l-2.388,1.894c-.609-.781-1.194-1.573-1.734-2.388Zm0,0",
    transform: "translate(-33.649 -149.033)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10027",
    "data-name": "Trazado 10027",
    d: "M39.915,249.1a3.785,3.785,0,0,1,1.619-2.629q.695,1.233,1.481,2.411a3.9,3.9,0,0,1-3.1.218",
    transform: "translate(-24.692 -150.325)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10028",
    "data-name": "Trazado 10028",
    d: "M39.915,249.1a3.785,3.785,0,0,1,1.619-2.629q.695,1.233,1.481,2.411A3.9,3.9,0,0,1,39.915,249.1Zm0,0",
    transform: "translate(-24.692 -150.325)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10029",
    "data-name": "Trazado 10029",
    d: "M45.912,242.734l.735-.413q.712,1.271,1.527,2.48l-.7.459a13.955,13.955,0,0,1-1.929,1.091q-.786-1.177-1.481-2.411a16.648,16.648,0,0,1,1.848-1.205",
    transform: "translate(-27.223 -147.794)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10030",
    "data-name": "Trazado 10030",
    d: "M45.912,242.734l.735-.413q.712,1.271,1.527,2.48l-.7.459a13.955,13.955,0,0,1-1.929,1.091q-.786-1.177-1.481-2.411a16.648,16.648,0,0,1,1.848-1.205Zm0,0",
    transform: "translate(-27.223 -147.794)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10031",
    "data-name": "Trazado 10031",
    d: "M54.738,240.75l-2.537,1.7q-.8-1.212-1.515-2.48l2.641-1.5q.669,1.164,1.412,2.284",
    transform: "translate(-31.261 -145.443)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10032",
    "data-name": "Trazado 10032",
    d: "M54.738,240.75l-2.537,1.7q-.8-1.212-1.515-2.48l2.641-1.5q.669,1.164,1.412,2.284Zm0,0",
    transform: "translate(-31.261 -145.443)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10033",
    "data-name": "Trazado 10033",
    d: "M39.885,241.544a3.105,3.105,0,0,1,.379-1.194q.378.8.8,1.572a3.035,3.035,0,0,1-1.182-.379",
    transform: "translate(-24.674 -146.592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10034",
    "data-name": "Trazado 10034",
    d: "M39.885,241.544a3.105,3.105,0,0,1,.379-1.194q.378.8.8,1.572a3.035,3.035,0,0,1-1.182-.379Zm0,0",
    transform: "translate(-24.674 -146.592)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10035",
    "data-name": "Trazado 10035",
    d: "M43.279,235.2q.645,1.411,1.4,2.767a5.773,5.773,0,0,1-3.031.815q-.413-.778-.792-1.573a5.744,5.744,0,0,1,2.422-2.009",
    transform: "translate(-25.267 -143.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10036",
    "data-name": "Trazado 10036",
    d: "M43.279,235.2q.645,1.411,1.4,2.767a5.773,5.773,0,0,1-3.031.815q-.413-.778-.792-1.573a5.743,5.743,0,0,1,2.422-2.009Zm0,0",
    transform: "translate(-25.267 -143.45)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10037",
    "data-name": "Trazado 10037",
    d: "M47.916,232.764l1.906-.861q.6,1.311,1.309,2.571l-1.8,1.022c-.287.16-.574.31-.861.459q-.758-1.353-1.4-2.767c.275-.149.563-.287.85-.425",
    transform: "translate(-29.054 -141.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10038",
    "data-name": "Trazado 10038",
    d: "M47.916,232.764l1.906-.861q.6,1.311,1.309,2.571l-1.8,1.022c-.287.16-.574.31-.861.459q-.758-1.353-1.4-2.767C47.341,233.04,47.629,232.9,47.916,232.764Zm0,0",
    transform: "translate(-29.054 -141.44)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10039",
    "data-name": "Trazado 10039",
    d: "M40.032,231.116a3.745,3.745,0,0,1,1.757-2.009q.41,1.119.907,2.2a3.714,3.714,0,0,1-2.664-.2",
    transform: "translate(-24.763 -139.735)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10040",
    "data-name": "Trazado 10040",
    d: "M40.032,231.116a3.745,3.745,0,0,1,1.757-2.009q.41,1.119.907,2.2A3.714,3.714,0,0,1,40.032,231.116Zm0,0",
    transform: "translate(-24.763 -139.735)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10041",
    "data-name": "Trazado 10041",
    d: "M47.307,225.958q.435,1.184.965,2.33l-.494.218a15.266,15.266,0,0,1-2.353.884c-.333-.723-.632-1.458-.918-2.193a15.382,15.382,0,0,1,2.3-1.056Zm0,0",
    transform: "translate(-27.492 -137.814)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10042",
    "data-name": "Trazado 10042",
    d: "M53.83,282.735c1.688.012,2.939-.964,4.236-2.411q-1.3-1.036-2.526-2.158c-1.217,1.5-2,2.893-1.711,4.569",
    transform: "translate(-33.143 -169.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10043",
    "data-name": "Trazado 10043",
    d: "M53.83,282.735c1.688.012,2.939-.964,4.236-2.411q-1.3-1.036-2.526-2.158c-1.217,1.5-2,2.893-1.711,4.569Zm0,0",
    transform: "translate(-33.143 -169.656)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10044",
    "data-name": "Trazado 10044",
    d: "M61.874,275.17l1.113-1.412q-1.238-.995-2.411-2.067l-1.217,1.332c-.367.413-.712.8-1.021,1.194q1.216,1.126,2.514,2.159c.333-.379.666-.781,1.022-1.205",
    transform: "translate(-35.929 -165.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10045",
    "data-name": "Trazado 10045",
    d: "M61.874,275.17l1.113-1.412q-1.238-.995-2.411-2.067l-1.217,1.332c-.367.413-.712.8-1.021,1.194q1.216,1.126,2.514,2.159C61.185,276,61.518,275.594,61.874,275.17Zm0,0",
    transform: "translate(-35.929 -165.707)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10046",
    "data-name": "Trazado 10046",
    d: "M66.142,265.953l-2.066,2.238c.792.723,1.6,1.412,2.422,2.067l1.883-2.388q-1.151-.921-2.239-1.917",
    transform: "translate(-39.428 -162.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10047",
    "data-name": "Trazado 10047",
    d: "M66.142,265.953l-2.066,2.238c.792.724,1.6,1.412,2.422,2.067l1.883-2.388Q67.23,266.949,66.142,265.953Zm0,0",
    transform: "translate(-39.428 -162.207)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10048",
    "data-name": "Trazado 10048",
    d: "M73.506,261.964q-1.075-.847-2.078-1.779l-2.055,2.25q1.087,1,2.239,1.917Zm0,0",
    transform: "translate(-42.659 -158.689)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10049",
    "data-name": "Trazado 10049",
    d: "M65.717,286.7a3.614,3.614,0,0,0,1.975-.643q-1.007-.7-1.975-1.446a3.6,3.6,0,0,0,0,2.089",
    transform: "translate(-40.335 -173.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10050",
    "data-name": "Trazado 10050",
    d: "M65.717,286.7a3.614,3.614,0,0,0,1.975-.643q-1.007-.7-1.975-1.446a3.6,3.6,0,0,0,0,2.089Zm0,0",
    transform: "translate(-40.335 -173.587)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10051",
    "data-name": "Trazado 10051",
    d: "M70.23,278.889c-.872-.585-1.733-1.205-2.56-1.871a9.5,9.5,0,0,0-1.711,2.973q.969.742,1.975,1.435a9.8,9.8,0,0,0,2.3-2.537",
    transform: "translate(-40.577 -168.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10052",
    "data-name": "Trazado 10052",
    d: "M70.23,278.889c-.872-.585-1.733-1.205-2.56-1.871a9.5,9.5,0,0,0-1.711,2.973q.969.742,1.975,1.435A9.8,9.8,0,0,0,70.23,278.889Zm0,0",
    transform: "translate(-40.577 -168.956)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10053",
    "data-name": "Trazado 10053",
    d: "M74.575,272.63q-1.214-.83-2.376-1.733l-1.688,2.147c-.069.08-.126.161-.2.241q1.247.987,2.571,1.871c.057-.092.115-.172.172-.264Zm0,0",
    transform: "translate(-43.234 -165.223)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10054",
    "data-name": "Trazado 10054",
    d: "M79.217,266.342q-1.127-.747-2.181-1.6l-1.894,2.4q1.162.9,2.376,1.734Zm0,0",
    transform: "translate(-46.177 -161.472)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10055",
    "data-name": "Trazado 10055",
    d: "M76.367,285.18A3.807,3.807,0,0,0,79,283.561q-1.231-.7-2.411-1.481a3.857,3.857,0,0,0-.218,3.1",
    transform: "translate(-46.783 -172.044)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10056",
    "data-name": "Trazado 10056",
    d: "M76.367,285.18A3.807,3.807,0,0,0,79,283.561q-1.231-.7-2.411-1.481a3.857,3.857,0,0,0-.218,3.1Zm0,0",
    transform: "translate(-46.783 -172.044)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10057",
    "data-name": "Trazado 10057",
    d: "M80.894,277.591l.413-.723q-1.26-.72-2.468-1.527l-.459.689a13.49,13.49,0,0,0-1.091,1.94c.781.528,1.584,1.01,2.411,1.481a15.783,15.783,0,0,0,1.194-1.86",
    transform: "translate(-47.488 -167.933)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10058",
    "data-name": "Trazado 10058",
    d: "M80.894,277.591l.413-.723q-1.26-.721-2.468-1.527l-.459.688a13.491,13.491,0,0,0-1.091,1.94c.781.528,1.584,1.01,2.411,1.481A15.783,15.783,0,0,0,80.894,277.591Zm0,0",
    transform: "translate(-47.488 -167.933)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10059",
    "data-name": "Trazado 10059",
    d: "M82.951,268.866l-1.688,2.526q1.207.816,2.48,1.527l1.5-2.652q-1.174-.657-2.3-1.4",
    transform: "translate(-49.911 -163.984)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10060",
    "data-name": "Trazado 10060",
    d: "M82.951,268.866l-1.688,2.526q1.207.816,2.48,1.527l1.5-2.652q-1.174-.657-2.3-1.4Zm0,0",
    transform: "translate(-49.911 -163.984)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10061",
    "data-name": "Trazado 10061",
    d: "M85.938,288.207a2.827,2.827,0,0,0,1.183-.39q-.789-.379-1.561-.792a2.745,2.745,0,0,0,.378,1.182",
    transform: "translate(-52.531 -175.059)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10062",
    "data-name": "Trazado 10062",
    d: "M85.938,288.207a2.827,2.827,0,0,0,1.183-.39q-.789-.379-1.561-.792A2.745,2.745,0,0,0,85.938,288.207Zm0,0",
    transform: "translate(-52.531 -175.059)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10063",
    "data-name": "Trazado 10063",
    d: "M89.12,280.685q-1.412-.641-2.767-1.4a5.762,5.762,0,0,0-.815,3.019c.517.275,1.034.539,1.562.792a5.653,5.653,0,0,0,2.021-2.411",
    transform: "translate(-52.51 -170.339)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10064",
    "data-name": "Trazado 10064",
    d: "M89.12,280.685q-1.412-.641-2.767-1.4a5.762,5.762,0,0,0-.815,3.019c.517.275,1.034.539,1.562.792A5.653,5.653,0,0,0,89.12,280.685Zm0,0",
    transform: "translate(-52.51 -170.339)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10065",
    "data-name": "Trazado 10065",
    d: "M90.84,275.66l.861-1.906q-1.315-.59-2.572-1.3l-1.022,1.791c-.161.287-.321.574-.459.873q1.353.758,2.767,1.4c.138-.275.287-.562.424-.861",
    transform: "translate(-53.806 -166.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10066",
    "data-name": "Trazado 10066",
    d: "M90.84,275.66l.861-1.906q-1.315-.59-2.572-1.3l-1.022,1.791c-.161.287-.321.574-.459.873q1.353.758,2.767,1.4C90.554,276.245,90.7,275.958,90.84,275.66Zm0,0",
    transform: "translate(-53.806 -166.174)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10067",
    "data-name": "Trazado 10067",
    d: "M95.12,285.733a3.638,3.638,0,0,0,2.009-1.745c-.735-.276-1.469-.586-2.193-.907a3.7,3.7,0,0,0,.183,2.652",
    transform: "translate(-58.154 -172.654)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10068",
    "data-name": "Trazado 10068",
    d: "M95.12,285.733a3.638,3.638,0,0,0,2.009-1.745c-.735-.276-1.469-.586-2.193-.907a3.7,3.7,0,0,0,.183,2.652Zm0,0",
    transform: "translate(-58.154 -172.654)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10069",
    "data-name": "Trazado 10069",
    d: "M98.615,276.746c-.78-.3-1.561-.609-2.33-.964l-.229.482a15.968,15.968,0,0,0-.873,2.365c.723.321,1.458.631,2.193.907a14.733,14.733,0,0,0,1.045-2.285Zm0,0",
    transform: "translate(-58.401 -168.202)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10070",
    "data-name": "Trazado 10070",
    d: "M123.135,312.055c-1.205-1.182-1.4-2.767-1.3-4.7,1.091.126,2.193.207,3.306.252-.2,1.929-.632,3.467-2.009,4.443",
    transform: "translate(-74.643 -187.462)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10071",
    "data-name": "Trazado 10071",
    d: "M123.135,312.055c-1.205-1.182-1.4-2.767-1.3-4.7,1.091.126,2.193.207,3.306.252-.2,1.929-.632,3.467-2.009,4.443Zm0,0",
    transform: "translate(-74.643 -187.462)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10072",
    "data-name": "Trazado 10072",
    d: "M122.031,300.51l.207-1.8c1.045.126,2.1.207,3.157.252l-.069,1.8c-.034.551-.069,1.079-.126,1.573q-1.651-.066-3.295-.252c.023-.505.069-1.033.126-1.573",
    transform: "translate(-74.699 -182.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10073",
    "data-name": "Trazado 10073",
    d: "M122.031,300.51l.207-1.8c1.045.126,2.1.207,3.157.252l-.069,1.8c-.034.551-.069,1.079-.126,1.573q-1.651-.066-3.295-.252c.023-.505.069-1.033.126-1.573Zm0,0",
    transform: "translate(-74.699 -182.185)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10074",
    "data-name": "Trazado 10074",
    d: "M126.053,291.2l-.138,3.042q-1.583-.066-3.157-.252l.344-3.019c.976.115,1.952.2,2.95.229",
    transform: "translate(-75.219 -177.464)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10075",
    "data-name": "Trazado 10075",
    d: "M126.053,291.2l-.138,3.042q-1.583-.066-3.157-.252l.344-3.019c.976.115,1.952.2,2.95.229Zm0,0",
    transform: "translate(-75.219 -177.464)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10076",
    "data-name": "Trazado 10076",
    d: "M123.985,283.2c.907.115,1.814.184,2.732.218l-.126,3.042q-1.479-.053-2.95-.229Zm0,0",
    transform: "translate(-75.757 -172.725)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10077",
    "data-name": "Trazado 10077",
    d: "M115.147,308.06a3.633,3.633,0,0,1-.953-1.848c.8.138,1.607.275,2.422.379a3.692,3.692,0,0,1-1.469,1.469",
    transform: "translate(-69.996 -186.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10078",
    "data-name": "Trazado 10078",
    d: "M115.147,308.06a3.633,3.633,0,0,1-.953-1.848c.8.138,1.607.275,2.422.379A3.692,3.692,0,0,1,115.147,308.06Zm0,0",
    transform: "translate(-69.996 -186.762)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10079",
    "data-name": "Trazado 10079",
    d: "M114.251,297.442c1.022.207,2.066.367,3.123.494a10.052,10.052,0,0,1-.884,3.306c-.815-.1-1.619-.241-2.411-.379a9.586,9.586,0,0,1,.172-3.421",
    transform: "translate(-69.868 -181.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10080",
    "data-name": "Trazado 10080",
    d: "M114.251,297.442c1.022.207,2.066.367,3.123.494a10.052,10.052,0,0,1-.884,3.306c-.815-.1-1.619-.241-2.411-.379A9.586,9.586,0,0,1,114.251,297.442Zm0,0",
    transform: "translate(-69.868 -181.413)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10081",
    "data-name": "Trazado 10081",
    d: "M115.251,289.79c.953.184,1.917.344,2.9.46l-.321,2.709a3.038,3.038,0,0,1-.046.31q-1.571-.184-3.123-.494c.012-.1.035-.207.046-.31Zm0,0",
    transform: "translate(-70.283 -176.746)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10082",
    "data-name": "Trazado 10082",
    d: "M116.763,282.139q1.323.26,2.664.413l-.356,3.031q-1.46-.177-2.9-.46Zm0,0",
    transform: "translate(-71.198 -172.079)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10083",
    "data-name": "Trazado 10083",
    d: "M107.8,298.673a3.749,3.749,0,0,1-.712-3q1.358.382,2.743.654a3.894,3.894,0,0,1-2.032,2.342",
    transform: "translate(-65.632 -180.336)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10084",
    "data-name": "Trazado 10084",
    d: "M107.8,298.673a3.749,3.749,0,0,1-.712-3q1.358.382,2.743.654A3.894,3.894,0,0,1,107.8,298.673Zm0,0",
    transform: "translate(-65.632 -180.336)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10085",
    "data-name": "Trazado 10085",
    d: "M107.62,288.869l.218-.815c.93.264,1.871.482,2.824.677l-.161.815a13.9,13.9,0,0,1-.6,2.135q-1.384-.272-2.744-.655a15.945,15.945,0,0,1,.46-2.158",
    transform: "translate(-65.706 -175.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10086",
    "data-name": "Trazado 10086",
    d: "M107.62,288.869l.218-.815c.93.264,1.871.482,2.824.677l-.161.815a13.9,13.9,0,0,1-.6,2.135q-1.384-.272-2.744-.655A15.945,15.945,0,0,1,107.62,288.869Zm0,0",
    transform: "translate(-65.706 -175.687)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10087",
    "data-name": "Trazado 10087",
    d: "M112.318,281.152l-.6,2.985c-.953-.2-1.894-.413-2.824-.677l.8-2.939c.861.241,1.734.448,2.617.632",
    transform: "translate(-66.765 -171.092)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10088",
    "data-name": "Trazado 10088",
    d: "M112.318,281.152l-.6,2.985c-.953-.2-1.894-.413-2.824-.677l.8-2.939C110.562,280.761,111.434,280.968,112.318,281.152Zm0,0",
    transform: "translate(-66.765 -171.092)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10089",
    "data-name": "Trazado 10089",
    d: "M101.131,294.729a3.09,3.09,0,0,1-.562-1.113c.551.2,1.1.379,1.665.54a2.811,2.811,0,0,1-1.1.574",
    transform: "translate(-61.686 -179.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10090",
    "data-name": "Trazado 10090",
    d: "M101.131,294.729a3.09,3.09,0,0,1-.562-1.113c.551.2,1.1.379,1.665.54a2.811,2.811,0,0,1-1.1.574Zm0,0",
    transform: "translate(-61.686 -179.079)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10091",
    "data-name": "Trazado 10091",
    d: "M100.668,285.582c.964.356,1.94.677,2.939.964a5.739,5.739,0,0,1-1.561,2.709q-.84-.244-1.665-.539a5.663,5.663,0,0,1,.287-3.134",
    transform: "translate(-61.498 -174.179)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10092",
    "data-name": "Trazado 10092",
    d: "M100.668,285.582c.964.356,1.94.677,2.939.964a5.739,5.739,0,0,1-1.561,2.709q-.84-.244-1.665-.539a5.663,5.663,0,0,1,.287-3.134Zm0,0",
    transform: "translate(-61.498 -174.179)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10093",
    "data-name": "Trazado 10093",
    d: "M101.585,280.206l.735-1.952q1.354.5,2.744.9l-.54,1.986c-.1.322-.2.632-.3.942-1-.275-1.986-.609-2.95-.964.1-.3.207-.6.31-.907",
    transform: "translate(-62.116 -169.71)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10094",
    "data-name": "Trazado 10094",
    d: "M101.585,280.206l.735-1.952q1.354.5,2.744.9l-.54,1.986c-.1.322-.2.632-.3.942-1-.275-1.986-.609-2.95-.964.1-.3.207-.6.31-.907Zm0,0",
    transform: "translate(-62.116 -169.71)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10095",
    "data-name": "Trazado 10095",
    d: "M10.515,201.581c1.194,1.194,2.767,1.389,4.707,1.286q-.2-1.647-.252-3.306c-1.929.207-3.467.632-4.454,2.021",
    transform: "translate(-6.761 -121.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10096",
    "data-name": "Trazado 10096",
    d: "M10.515,201.581c1.194,1.194,2.767,1.389,4.707,1.286q-.2-1.647-.252-3.306c-1.929.207-3.467.632-4.454,2.021Zm0,0",
    transform: "translate(-6.761 -121.714)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10097",
    "data-name": "Trazado 10097",
    d: "M23.741,202.435l1.791-.207c-.115-1.045-.206-2.1-.241-3.168l-1.814.08c-.551.034-1.068.069-1.573.115.057,1.114.138,2.216.264,3.306q.788-.04,1.573-.126",
    transform: "translate(-13.707 -121.409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10098",
    "data-name": "Trazado 10098",
    d: "M23.741,202.435l1.791-.207c-.115-1.045-.206-2.1-.241-3.168l-1.814.08c-.551.034-1.068.069-1.573.115.057,1.114.138,2.216.264,3.306q.788-.04,1.573-.126Zm0,0",
    transform: "translate(-13.707 -121.409)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10099",
    "data-name": "Trazado 10099",
    d: "M33.628,198.736l-3.042.126c.034,1.068.126,2.124.241,3.168l3.031-.344q-.176-1.47-.23-2.951",
    transform: "translate(-19.002 -121.211)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10100",
    "data-name": "Trazado 10100",
    d: "M33.628,198.736l-3.042.126c.034,1.068.126,2.124.241,3.168l3.031-.344q-.176-1.47-.23-2.951Zm0,0",
    transform: "translate(-19.002 -121.211)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10101",
    "data-name": "Trazado 10101",
    d: "M41.634,201.133q-.156-1.356-.207-2.721l-3.042.126c.034.987.115,1.975.229,2.951Zm0,0",
    transform: "translate(-23.759 -121.013)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10102",
    "data-name": "Trazado 10102",
    d: "M18.961,211.006a3.6,3.6,0,0,0,1.86.941q-.224-1.188-.379-2.411a3.645,3.645,0,0,0-1.481,1.469",
    transform: "translate(-11.912 -127.799)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10103",
    "data-name": "Trazado 10103",
    d: "M18.961,211.006a3.6,3.6,0,0,0,1.86.941q-.224-1.188-.379-2.411A3.645,3.645,0,0,0,18.961,211.006Zm0,0",
    transform: "translate(-11.912 -127.799)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10104",
    "data-name": "Trazado 10104",
    d: "M26.546,210.375c-.2-1.033-.368-2.078-.483-3.134a9.633,9.633,0,0,0-3.306.9q.156,1.223.379,2.411a9.5,9.5,0,0,0,3.409-.172",
    transform: "translate(-14.227 -126.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10105",
    "data-name": "Trazado 10105",
    d: "M26.546,210.375c-.2-1.033-.368-2.078-.483-3.134a9.633,9.633,0,0,0-3.306.9q.156,1.223.379,2.411a9.5,9.5,0,0,0,3.409-.172Zm0,0",
    transform: "translate(-14.227 -126.398)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10106",
    "data-name": "Trazado 10106",
    d: "M34.694,209.234q-.291-1.442-.459-2.9l-2.721.321-.31.034c.126,1.068.3,2.1.493,3.134a2.894,2.894,0,0,0,.31-.057Zm0,0",
    transform: "translate(-19.379 -125.842)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10107",
    "data-name": "Trazado 10107",
    d: "M42.417,208.08q-.266-1.323-.425-2.663l-3.019.356q.168,1.461.459,2.9Zm0,0",
    transform: "translate(-24.118 -125.286)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.409,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10108",
    "data-name": "Trazado 10108",
    d: "M26.554,217.778a3.764,3.764,0,0,0,3.008.712q-.375-1.361-.666-2.744a3.889,3.889,0,0,0-2.342,2.032",
    transform: "translate(-16.543 -131.586)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10109",
    "data-name": "Trazado 10109",
    d: "M26.554,217.778a3.764,3.764,0,0,0,3.008.712q-.375-1.361-.666-2.744a3.889,3.889,0,0,0-2.342,2.032Zm0,0",
    transform: "translate(-16.543 -131.586)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10110",
    "data-name": "Trazado 10110",
    d: "M35.381,216.846l.8-.218c-.252-.93-.482-1.871-.666-2.824l-.815.161a14.1,14.1,0,0,0-2.147.6c.2.93.413,1.837.666,2.744a16.314,16.314,0,0,0,2.158-.459",
    transform: "translate(-20.204 -130.401)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10111",
    "data-name": "Trazado 10111",
    d: "M35.381,216.846l.8-.218c-.252-.93-.482-1.871-.666-2.824l-.815.161a14.1,14.1,0,0,0-2.147.6c.2.93.413,1.837.666,2.744a16.314,16.314,0,0,0,2.158-.459Zm0,0",
    transform: "translate(-20.204 -130.401)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10112",
    "data-name": "Trazado 10112",
    d: "M43.135,212.274l-2.985.6c.184.953.413,1.894.666,2.824l2.939-.815q-.365-1.289-.62-2.606",
    transform: "translate(-24.835 -129.468)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10113",
    "data-name": "Trazado 10113",
    d: "M43.135,212.274l-2.985.6c.184.953.413,1.894.666,2.824l2.939-.815q-.365-1.289-.62-2.606Zm0,0",
    transform: "translate(-24.835 -129.468)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10114",
    "data-name": "Trazado 10114",
    d: "M33.47,226.207a2.96,2.96,0,0,0,1.1.563c-.184-.551-.367-1.114-.539-1.665a2.867,2.867,0,0,0-.563,1.1",
    transform: "translate(-20.761 -137.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10115",
    "data-name": "Trazado 10115",
    d: "M33.47,226.207a2.96,2.96,0,0,0,1.1.563c-.184-.551-.367-1.114-.539-1.665A2.866,2.866,0,0,0,33.47,226.207Zm0,0",
    transform: "translate(-20.761 -137.294)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10116",
    "data-name": "Trazado 10116",
    d: "M38.586,224.023q-.539-1.454-.953-2.95a5.8,5.8,0,0,0-2.72,1.573c.172.551.356,1.113.539,1.664a5.655,5.655,0,0,0,3.134-.287",
    transform: "translate(-21.641 -134.835)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10117",
    "data-name": "Trazado 10117",
    d: "M38.586,224.023q-.539-1.454-.953-2.95a5.8,5.8,0,0,0-2.72,1.573c.172.551.356,1.113.539,1.664a5.655,5.655,0,0,0,3.134-.287Zm0,0",
    transform: "translate(-21.641 -134.835)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10118",
    "data-name": "Trazado 10118",
    d: "M43.746,222.415l1.963-.746c-.333-.9-.643-1.8-.9-2.744l-2,.551c-.31.092-.632.184-.93.287q.414,1.495.953,2.95c.31-.092.609-.2.907-.3",
    transform: "translate(-25.894 -133.525)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10119",
    "data-name": "Trazado 10119",
    d: "M43.746,222.415l1.963-.746c-.333-.9-.643-1.8-.9-2.744l-2,.551c-.31.092-.632.184-.93.287q.414,1.495.953,2.95C43.149,222.621,43.448,222.518,43.746,222.415Zm0,0",
    transform: "translate(-25.894 -133.525)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10120",
    "data-name": "Trazado 10120",
    d: "M51.1,143.767a32.73,32.73,0,1,1,32.73,32.741A32.731,32.731,0,0,1,51.1,143.767",
    transform: "translate(-31.513 -67.723)",
    fill: "#19458f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10121",
    "data-name": "Trazado 10121",
    d: "M99.892,182.286a22.455,22.455,0,1,0-22.455-22.455,22.452,22.452,0,0,0,22.455,22.455",
    transform: "translate(-47.577 -83.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10122",
    "data-name": "Trazado 10122",
    d: "M111.038,231.092c-1.159,0-2.387-1.068-3.823-1.068s-1.561.953-3.168.953c-1.251,0-1.86-1.194-3.972-1.194-1.3,0-2.365,1.136-3.387,1.01a2.1,2.1,0,0,1-.482-.115,21.761,21.761,0,0,0,2.307,1.171,3.651,3.651,0,0,1,1.562-.436c2.112,0,2.721,1.194,3.972,1.194,1.607,0,1.734-.953,3.169-.953s2.663,1.068,3.823,1.068,2.1-.861,3.295-.861a3.282,3.282,0,0,1,1.159.172,19.411,19.411,0,0,0,1.975-.93c-1.584-.2-1.493-.873-3.134-.873-1.194,0-2.124.861-3.295.861m10.653-7.462c-1.194,0-1.711.8-3.26.8-2.629,0-2.181-.93-4.1-.93-1.194,0-2.124.872-3.283.872s-2.4-1.079-3.835-1.079-1.549.964-3.168.964c-1.263,0-1.86-1.205-3.984-1.205-1.274,0-2.353,1.137-3.375,1.022s-2.273-1.32-3.65-1.194a9.853,9.853,0,0,0-3.594,1.538c.275.379.551.758.838,1.114a7.684,7.684,0,0,1,2.755-1.056c1.377-.115,2.64,1.079,3.65,1.194s2.1-1.01,3.375-1.01c2.124,0,2.721,1.194,3.984,1.194,1.619,0,1.734-.964,3.169-.964s2.663,1.079,3.835,1.079,2.089-.861,3.283-.861c1.917,0,1.469.93,4.1.93,1.55,0,2.067-.815,3.26-.815.919,0,1.033.539,2.021.838.39-.459.769-.93,1.113-1.424-2.089-.115-1.952-1.01-3.134-1.01",
    transform: "translate(-54.9 -135.933)",
    fill: "#19458f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10123",
    "data-name": "Trazado 10123",
    d: "M121.447,233.188c-2.629,0-2.181-.93-4.1-.93-1.194,0-2.124.872-3.283.872s-2.4-1.079-3.835-1.079-1.549.953-3.168.953c-1.263,0-1.86-1.194-3.972-1.194-1.3,0-2.365,1.137-3.387,1.022s-2.273-1.32-3.65-1.205a5.266,5.266,0,0,0-1.665.5q.617.657,1.286,1.263c.126-.023.253-.046.379-.057,1.377-.115,2.64,1.079,3.65,1.205s2.089-1.022,3.387-1.022c2.112,0,2.709,1.194,3.972,1.194,1.619,0,1.734-.953,3.169-.953s2.663,1.079,3.835,1.079,2.089-.872,3.283-.872c1.917,0,1.469.93,4.1.93a5.64,5.64,0,0,0,2.319-.632,24.632,24.632,0,0,0,1.837-1.641,1.654,1.654,0,0,0-.9-.253c-1.194,0-1.711.815-3.26.815",
    transform: "translate(-57.916 -141.267)",
    fill: "#19458f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10124",
    "data-name": "Trazado 10124",
    d: "M110.174,139.283a.134.134,0,0,1,.092.2,1.753,1.753,0,0,0-.252.4c-.034.138-.1.39-.126.528a.761.761,0,0,1-.161.39,1.052,1.052,0,0,1-.218.287,2.631,2.631,0,0,0-.356.23,4.537,4.537,0,0,0-.609.723,6.334,6.334,0,0,0-.367.746,4.369,4.369,0,0,1-.689,1.125,12.036,12.036,0,0,1-1.056,1.01,2.766,2.766,0,0,0-1.125,1.515,3.254,3.254,0,0,0,.138,1.768c.1.149.172.183.356.023s.689-.563.8-.666a1.092,1.092,0,0,0,.321-.689,4.19,4.19,0,0,1,.287-.987c.057-.126.344-.815.4-.9a.246.246,0,0,1,.264-.126c.1.046.2.1.138.241q-.154.332-.275.677a6.155,6.155,0,0,0-.184,1.1c0,.161.115.31.287.161s.505-.425.677-.585.551-.54.539-.85-.012-1.194-.034-1.423-.034-.712.23-.712.218.378.241.563a3.761,3.761,0,0,0,.172.941c.115.275.183.08.252.012a5.4,5.4,0,0,0,.563-.77,1.09,1.09,0,0,0,.184-1.045,4.783,4.783,0,0,1-.046-.918c.012-.183-.057-.562.207-.6s.241.275.264.482a2.525,2.525,0,0,0,.126.6c.035.092.057.092.126-.046a6.549,6.549,0,0,0,.494-1.435c.069-.413.023-.46-.08-.643a2.824,2.824,0,0,1-.241-.8c-.092-.505-.057-.6.115-.62s.183.207.207.333a1.214,1.214,0,0,0,.229.459c.1.172.115.034.149-.034a3.549,3.549,0,0,0,.2-.873c.012-.183,0-.493.183-.493.207,0,.2.333.207.47a5.45,5.45,0,0,1-.264,1.78c-.2.574.149.31.23.264a2.705,2.705,0,0,0,1.24-1.32c.1-.2.229-.287.333-.218s.08.275.035.425a3.039,3.039,0,0,1-1.527,1.722,1.966,1.966,0,0,0-.942,1.263c-.046.126-.654,1.274-.93,1.7A17.417,17.417,0,0,1,109,147.009a5.777,5.777,0,0,1-1.631,1.09c-.493.241-1.217.494-1.446.9-.057.092.012.149.138.115s.655-.057,1.228-.1,1.4-.08,1.492.31-.769,1.136-1.263,1.377a6.7,6.7,0,0,1-.815.367c-.1.046-.126.092-.057.23a30.639,30.639,0,0,1,1.8,4.271c.046.218.057.2-.091.3s-.666.436-.976.6c-.333.183-.115.207.1.2.942-.069,1.217-.528,1.963-.413,1.24.2,1.906,1.034,5.017,1.1,4.294.115,3.846-.677,6.05-.677,2.112,0,2.525,1.894,4.305,1.894a10.268,10.268,0,0,0,1.423-.138c.31-.034.333.3.138.494-.31.31-1.366,1.3-2.078.941-.138-.069-.172-.023-.2.138a2.687,2.687,0,0,1-.3,1.653,6.583,6.583,0,0,1-1.883,1.86,5.318,5.318,0,0,0-1.068.941,2.463,2.463,0,0,0-.092,1.711c.229.482.746.976.528,1.527a2.227,2.227,0,0,1-.964,1.136c-.413.23-2.25,1.309-2.813,1.711a4.248,4.248,0,0,0-1.229,1.412c-.046.092-.057.092-.138.1a3.54,3.54,0,0,1-.769.138.332.332,0,0,1-.333-.333,2.4,2.4,0,0,1,.735-1.481,18.63,18.63,0,0,1,2.2-1.584c1.286-.77,1.436-.965,1.275-2.009a3.693,3.693,0,0,0-.735-1.722,4.632,4.632,0,0,1-1.171-1.562,3.448,3.448,0,0,0-.47-1.068c-.126-.2-.126.023-.115.126a1.582,1.582,0,0,1,.023.4c-.023.1.012.149-.1.149a10.638,10.638,0,0,0-2.675.563,9.039,9.039,0,0,1-3.766.08c-.2-.035-.585-.1-.7-.333-.046-.092-.138,0-.149.057a7.6,7.6,0,0,0,.034,1.045c-.023.184-.379,2-.609,2.744a5.484,5.484,0,0,0-.1,1.676c0,.7-.046,1.733,0,1.952a1.047,1.047,0,0,1,.034.6,4.063,4.063,0,0,0-.149.448c-.023.126-.057.172-.207.229a.551.551,0,0,0-.287.3c-.069.115-.184.333-.3.344s-.115.012-.218-.069q-.179-.183-.367-.356c-.092-.08-.069-.161.012-.183a.7.7,0,0,0,.241-.333,6.466,6.466,0,0,0,.229-.953,5.393,5.393,0,0,0-.115-2.285,6.905,6.905,0,0,1-.138-2.916,7.922,7.922,0,0,0-.333-2.617,6.83,6.83,0,0,1-1.217-3.134c-.034-.138-.092-.138-.138.012a5.742,5.742,0,0,0,.241,2.4,5.974,5.974,0,0,1-1.722-2.95c-.574-1.871-.7-3.594.057-4.81a1.846,1.846,0,0,0-.241-.964,5.059,5.059,0,0,0-2.629-.494c-.872.057-1.1,0-1.309-.229s-.229-.126-.39-.287c-.115-.115-.092-.275.1-.471.172.1.321.057.207-.161-.023-.057-.035-.08.046-.138.115-.069,1.343-.631,1.7-.838.172-.092.069-.138.218-.218a5.789,5.789,0,0,0,1.217-.642,2.746,2.746,0,0,1,1.136-.655c.321-.092.321-.183.229-.367-.069-.149-.046-.218-.218-.321a.963.963,0,0,1-.367-.493c-.057-.149-.264-.379-.161-.54.069-.115.161-.126.275,0,.218.241.321.31.482.344.092.012.092,0,.069-.092a5.259,5.259,0,0,1-.218-1.136,1.861,1.861,0,0,0-.356-.987,2.029,2.029,0,0,1,.069-1.5c.207-.39.287-.379.379-.321.183.115.023.287-.057.447a1.407,1.407,0,0,0,.149,1.114c.069.069.1.161.2-.046a2.657,2.657,0,0,1,.551-.8c.2-.183.528-.459.471-.7a4.088,4.088,0,0,1-.218-1.091,3.285,3.285,0,0,1,.161-1.148c.115-.2.4-.207.31.172a2.515,2.515,0,0,0,.069,1.217c.115.287.3.654.723.218a6.47,6.47,0,0,0,.689-.815.581.581,0,0,0,0-.608,4.144,4.144,0,0,1-.264-1.688c.034-.287.321-.344.333-.012a2.37,2.37,0,0,0,.252.907c.1.241.275.207.459.023s.3-.161.264-.551a1.786,1.786,0,0,1,.138-1.229c.149-.218.482-.183.379.126a1.227,1.227,0,0,0-.069.815c.046.207.183.115.172-.023a1.805,1.805,0,0,1,.494-.93c.229-.183.218-.241.379-.207ZM106.868,172.5a1.24,1.24,0,0,1,.528.344c.126.115.138.2-.012.252a.9.9,0,0,1-.654.115c-.252-.092-.448-.264-.2-.5a1.183,1.183,0,0,1,.333-.207Zm0,0",
    transform: "translate(-61.166 -84.523)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10125",
    "data-name": "Trazado 10125",
    d: "M138.494,210.113a.54.54,0,0,1,.31.092.883.883,0,0,0,.471.115,1.282,1.282,0,0,1,.344-.069c.092,0,.138.069.092.218s-.149.689-.413.735-.47.057-.551-.069a1.433,1.433,0,0,1-.287-.9c0-.057-.034-.126.034-.126Zm10.344.275c-.2,0-.218.012-.31.069s-.321.161-.31.287.035.172.184.252a.469.469,0,0,0,.367.069c.172-.035.207-.046.264-.092s.034-.046,0-.149A1.209,1.209,0,0,0,148.838,210.389Zm.3.069c-.046-.275.012-.31.126-.4a1.249,1.249,0,0,0,.516-.746,6.76,6.76,0,0,0,0-1.527,6.218,6.218,0,0,0-.39-1.562c-.253-.459-.483-1.171-1.01-1.286a7.143,7.143,0,0,1-3.513-2.021c-.1-.172-.023-.275.092-.436.1-.183,1.516-1.079,2.135-1.653a5,5,0,0,0,.769,1.745,1.925,1.925,0,0,0,1.389.907c1.229.172,1.194.643,1.206,1.32.012.586.012,1.481.069,2.181a14.273,14.273,0,0,0,.321,1.779,3.6,3.6,0,0,1,.08.942c-.023.31-.08.321-.218.4a1.775,1.775,0,0,0-.459.356.847.847,0,0,1-.459.31c-.184.046-.551.356-.655-.31Zm0,0",
    transform: "translate(-84.79 -122.486)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10126",
    "data-name": "Trazado 10126",
    d: "M102.93,167.535a1.033,1.033,0,0,0,.252-.528c-.012-.23.149-.184.23-.092a1.391,1.391,0,0,1,.413.838c0,.149-.012.241-.172.218a1.348,1.348,0,0,1-.459-.126c-.172-.115-.448-.023-.264-.31m7.244-28.252a.134.134,0,0,1,.092.2,1.753,1.753,0,0,0-.252.4c-.034.138-.1.39-.126.528a.761.761,0,0,1-.161.39,1.052,1.052,0,0,1-.218.287,2.631,2.631,0,0,0-.356.23,4.537,4.537,0,0,0-.609.723,6.334,6.334,0,0,0-.367.746,4.369,4.369,0,0,1-.689,1.125,12.036,12.036,0,0,1-1.056,1.01,2.766,2.766,0,0,0-1.125,1.515,3.254,3.254,0,0,0,.138,1.768c.1.149.172.183.356.023s.689-.563.8-.666a1.092,1.092,0,0,0,.321-.689,4.19,4.19,0,0,1,.287-.987c.057-.126.344-.815.4-.9a.246.246,0,0,1,.264-.126c.1.046.2.1.138.241q-.154.332-.275.677a6.155,6.155,0,0,0-.184,1.1c0,.161.115.31.287.161s.505-.425.677-.585.551-.54.539-.85-.012-1.194-.034-1.423-.034-.712.23-.712.218.378.241.563a3.761,3.761,0,0,0,.172.941c.115.275.183.08.252.012a5.4,5.4,0,0,0,.563-.77,1.09,1.09,0,0,0,.184-1.045,4.783,4.783,0,0,1-.046-.918c.012-.183-.057-.562.207-.6s.241.275.264.482a2.525,2.525,0,0,0,.126.6c.035.092.057.092.126-.046a6.549,6.549,0,0,0,.494-1.435c.069-.413.023-.459-.08-.643a2.824,2.824,0,0,1-.241-.8c-.092-.505-.057-.6.115-.62s.183.207.207.333a1.211,1.211,0,0,0,.229.459c.1.172.115.034.149-.034a3.549,3.549,0,0,0,.2-.873c.012-.183,0-.493.183-.493.207,0,.2.333.207.47a5.45,5.45,0,0,1-.264,1.78c-.2.574.149.31.23.264a2.705,2.705,0,0,0,1.24-1.32c.1-.2.229-.287.333-.218s.08.275.035.425a3.039,3.039,0,0,1-1.527,1.722,1.966,1.966,0,0,0-.942,1.263c-.046.126-.654,1.274-.93,1.7A17.417,17.417,0,0,1,109,147.009a5.788,5.788,0,0,1-1.631,1.091c-.493.241-1.217.493-1.446.9-.057.092.012.149.138.115s.655-.057,1.228-.1,1.4-.08,1.492.31-.769,1.136-1.263,1.378a6.722,6.722,0,0,1-.815.367c-.1.046-.126.092-.057.23a30.638,30.638,0,0,1,1.8,4.271c.046.218.057.2-.091.3s-.666.436-.976.6c-.333.183-.115.207.1.2.942-.069,1.217-.528,1.963-.413,1.24.2,1.906,1.034,5.017,1.1,4.294.115,3.846-.677,6.05-.677,2.112,0,2.525,1.894,4.305,1.894a10.332,10.332,0,0,0,1.423-.138c.31-.035.333.3.138.493-.31.31-1.366,1.3-2.078.941-.138-.069-.172-.023-.2.138a2.687,2.687,0,0,1-.3,1.653,6.583,6.583,0,0,1-1.883,1.86,5.329,5.329,0,0,0-1.068.941,2.463,2.463,0,0,0-.092,1.711c.229.482.746.976.528,1.527a2.227,2.227,0,0,1-.964,1.136c-.413.23-2.25,1.309-2.813,1.711a4.247,4.247,0,0,0-1.229,1.412c-.046.092-.057.092-.138.1a3.542,3.542,0,0,1-.769.138.332.332,0,0,1-.333-.333,2.4,2.4,0,0,1,.735-1.481,18.632,18.632,0,0,1,2.2-1.584c1.286-.77,1.436-.965,1.275-2.009a3.693,3.693,0,0,0-.735-1.722,4.632,4.632,0,0,1-1.171-1.562,3.448,3.448,0,0,0-.47-1.068c-.126-.2-.126.023-.115.126a1.582,1.582,0,0,1,.023.4c-.023.1.012.149-.1.149a10.637,10.637,0,0,0-2.675.563,9.039,9.039,0,0,1-3.766.08c-.2-.035-.585-.1-.7-.333-.046-.092-.138,0-.149.057a7.6,7.6,0,0,0,.034,1.045c-.023.184-.379,2-.609,2.744a5.484,5.484,0,0,0-.1,1.676c0,.7-.046,1.734,0,1.952a1.047,1.047,0,0,1,.034.6,4.064,4.064,0,0,0-.149.448c-.023.126-.057.172-.207.229a.551.551,0,0,0-.287.3c-.069.115-.184.333-.3.344s-.115.012-.218-.069q-.179-.182-.367-.356c-.092-.08-.069-.161.012-.184a.7.7,0,0,0,.241-.333,6.466,6.466,0,0,0,.229-.953,5.393,5.393,0,0,0-.115-2.285,6.905,6.905,0,0,1-.138-2.916,7.923,7.923,0,0,0-.333-2.617,6.828,6.828,0,0,1-1.217-3.134c-.034-.138-.092-.138-.138.012a5.742,5.742,0,0,0,.241,2.4,5.974,5.974,0,0,1-1.722-2.95c-.574-1.871-.7-3.594.057-4.81a1.846,1.846,0,0,0-.241-.964,5.059,5.059,0,0,0-2.629-.494c-.872.058-1.1,0-1.309-.229s-.229-.126-.39-.287c-.115-.115-.092-.275.1-.471.172.1.321.058.207-.161-.023-.057-.035-.08.046-.138.115-.069,1.343-.631,1.7-.838.172-.092.069-.138.218-.218a5.789,5.789,0,0,0,1.217-.642,2.746,2.746,0,0,1,1.136-.655c.321-.092.321-.183.229-.367-.069-.149-.046-.218-.218-.321a.963.963,0,0,1-.367-.493c-.057-.149-.264-.379-.161-.54.069-.115.161-.126.275,0,.218.241.321.31.482.344.092.012.092,0,.069-.092a5.259,5.259,0,0,1-.218-1.136,1.861,1.861,0,0,0-.356-.987,2.029,2.029,0,0,1,.069-1.5c.207-.39.287-.379.379-.321.183.115.023.287-.057.447a1.407,1.407,0,0,0,.149,1.114c.069.069.1.161.2-.046a2.657,2.657,0,0,1,.551-.8c.2-.183.528-.459.471-.7a4.088,4.088,0,0,1-.218-1.091,3.285,3.285,0,0,1,.161-1.148c.115-.2.4-.207.31.172a2.515,2.515,0,0,0,.069,1.217c.115.287.3.654.723.218a6.47,6.47,0,0,0,.689-.815.581.581,0,0,0,0-.608,4.144,4.144,0,0,1-.264-1.688c.034-.287.321-.344.333-.012a2.372,2.372,0,0,0,.252.907c.1.241.275.207.459.023s.3-.161.264-.551a1.786,1.786,0,0,1,.138-1.229c.149-.218.482-.183.379.127a1.226,1.226,0,0,0-.069.815c.046.207.183.115.172-.023a1.805,1.805,0,0,1,.494-.93c.229-.183.218-.241.379-.207",
    transform: "translate(-61.166 -84.523)",
    fill: "#19458f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10127",
    "data-name": "Trazado 10127",
    d: "M107.849,170.359c.092-.012.161-.023.161-.023a.209.209,0,0,0,.161.1c.1.012.161-.092.218-.092s.057.012.172.012a.34.34,0,0,1-.378.425c-.344-.023-.367-.218-.333-.425",
    transform: "translate(-66.119 -103.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10128",
    "data-name": "Trazado 10128",
    d: "M106.679,197.716a4.489,4.489,0,0,0,1.481,1.55c.092.046.08.1-.012.126a3.973,3.973,0,0,1-2.17-.012,13.281,13.281,0,0,0-1.894-.528c-.31,0-.493.4-.367.907a7.736,7.736,0,0,1,.264,2.262c-.012.126.023.08.1.115a1.859,1.859,0,0,1,.7.655.734.734,0,0,1-.172.746c-.115.126-.184.138-.31.046a4.5,4.5,0,0,1-.861-.735,1.586,1.586,0,0,1-.39-1.114,10.014,10.014,0,0,0-.321-3.019c-.046-.161-.08-.229,0-.356s.241-.528.574-.562c.654-.08.758.138,1.826.012a5.244,5.244,0,0,1,1.549-.092m2,10.826a1.241,1.241,0,0,1,.528.344c.126.115.138.2-.012.252a.9.9,0,0,1-.654.115c-.252-.092-.448-.264-.2-.5a1.183,1.183,0,0,1,.333-.207m8-.344a.54.54,0,0,1,.31.092.883.883,0,0,0,.471.115,1.283,1.283,0,0,1,.344-.069c.092,0,.138.069.092.218s-.149.689-.413.735-.47.057-.551-.069a1.433,1.433,0,0,1-.287-.9c0-.057-.034-.126.034-.126m10.344.275c-.2,0-.218.012-.31.069s-.321.161-.31.287.035.172.184.252a.469.469,0,0,0,.367.069c.172-.035.207-.046.264-.092s.034-.046,0-.149a1.209,1.209,0,0,0-.2-.437m.3.069c-.046-.275.012-.31.126-.4a1.249,1.249,0,0,0,.516-.746,6.761,6.761,0,0,0,0-1.527,6.218,6.218,0,0,0-.39-1.562c-.253-.459-.483-1.171-1.01-1.286A7.143,7.143,0,0,1,123.049,201c-.1-.172-.023-.275.092-.436.1-.183,1.516-1.079,2.135-1.653a5,5,0,0,0,.769,1.745,1.925,1.925,0,0,0,1.389.907c1.229.172,1.194.643,1.206,1.32.012.586.012,1.481.069,2.181a14.269,14.269,0,0,0,.321,1.779,3.594,3.594,0,0,1,.08.942c-.023.31-.08.321-.218.4a1.776,1.776,0,0,0-.459.356.847.847,0,0,1-.459.31c-.184.046-.551.356-.655-.31",
    transform: "translate(-62.974 -120.57)",
    fill: "#19458f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10129",
    "data-name": "Trazado 10129",
    d: "M98.707,181.871A23.218,23.218,0,1,0,75.5,158.647a23.219,23.219,0,0,0,23.212,23.224Zm0,0",
    transform: "translate(-46.393 -82.603)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.19
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10130",
    "data-name": "Trazado 10130",
    d: "M85.012,176.924a31.972,31.972,0,1,0-31.971-31.972,31.973,31.973,0,0,0,31.971,31.972Zm0,0",
    transform: "translate(-32.698 -68.908)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.19
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10131",
    "data-name": "Trazado 10131",
    d: "M132.743,269.952V250.413l-8.013-.735v20.274Zm0,0",
    transform: "translate(-76.422 -152.281)",
    fill: "#19458f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10132",
    "data-name": "Trazado 10132",
    d: "M108.456,261.972a43.976,43.976,0,0,0,17.231,5.373l5.947-6.728a44.179,44.179,0,0,1-17.22-5.384l-3.432-1.7",
    transform: "translate(-66.496 -154.633)",
    fill: "#19458f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10133",
    "data-name": "Trazado 10133",
    d: "M123.23,258.83a44.3,44.3,0,0,0,17.22,5.384",
    transform: "translate(-75.507 -157.863)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.085
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10134",
    "data-name": "Trazado 10134",
    d: "M109.25,274.37a44.565,44.565,0,0,0,17.232,5.384",
    transform: "translate(-66.98 -167.341)",
    fill: "#19458f",
    stroke: "#fff",
    strokeWidth: 1.085
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10135",
    "data-name": "Trazado 10135",
    d: "M108.456,264.628A43.975,43.975,0,0,0,125.687,270l5.947-6.727a44.18,44.18,0,0,1-17.22-5.384",
    transform: "translate(-66.496 -157.289)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10136",
    "data-name": "Trazado 10136",
    d: "M123.842,295.179a1.018,1.018,0,0,0-.608-.4c-1.3-.413-1.481-1.481-1.883-2.445a1.667,1.667,0,0,1-1.837-1.7,5.089,5.089,0,0,1,.207-1.756,1.721,1.721,0,0,1-1.5.539,1.887,1.887,0,0,1-1.481-2.239,2.087,2.087,0,0,1,2.216-1.906c1.619,0,2.158.85,2.135,2.262-.023,1.251-.138,2.147-.115,2.755a.915.915,0,0,0,1.1.8.865.865,0,0,0,.85-1c-.034-.988-.563-1.056-1.148-2.181a4.164,4.164,0,0,1-.31-2.847c.425-.046.735.3,1.251.781a1.128,1.128,0,1,1,2.25,0c.516-.482.827-.826,1.251-.78a4.164,4.164,0,0,1-.31,2.847c-.586,1.125-1.114,1.194-1.148,2.181a.864.864,0,0,0,.85,1,.914.914,0,0,0,1.1-.8c.023-.609-.092-1.5-.115-2.755-.023-1.412.517-2.262,2.135-2.262a2.079,2.079,0,0,1,2.216,1.906,1.888,1.888,0,0,1-1.481,2.239,1.733,1.733,0,0,1-1.5-.539,5.1,5.1,0,0,1,.207,1.756,1.667,1.667,0,0,1-1.837,1.7c-.4.964-.585,2.032-1.883,2.445a1.022,1.022,0,0,0-.609.4",
    transform: "translate(-71.527 -173.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10137",
    "data-name": "Trazado 10137",
    d: "M123.842,295.179a1.018,1.018,0,0,0-.608-.4c-1.3-.413-1.481-1.481-1.883-2.445a1.667,1.667,0,0,1-1.837-1.7,5.089,5.089,0,0,1,.207-1.756,1.721,1.721,0,0,1-1.5.539,1.887,1.887,0,0,1-1.481-2.239,2.087,2.087,0,0,1,2.216-1.906c1.619,0,2.158.85,2.135,2.262-.023,1.251-.138,2.147-.115,2.755a.915.915,0,0,0,1.1.8.865.865,0,0,0,.85-1c-.034-.988-.563-1.056-1.148-2.181a4.164,4.164,0,0,1-.31-2.847c.425-.046.735.3,1.251.781a1.128,1.128,0,1,1,2.25,0c.516-.482.827-.826,1.251-.78a4.164,4.164,0,0,1-.31,2.847c-.586,1.125-1.114,1.194-1.148,2.181a.864.864,0,0,0,.85,1,.914.914,0,0,0,1.1-.8c.023-.609-.092-1.5-.115-2.755-.023-1.412.517-2.262,2.135-2.262a2.079,2.079,0,0,1,2.216,1.906,1.888,1.888,0,0,1-1.481,2.239,1.733,1.733,0,0,1-1.5-.539,5.1,5.1,0,0,1,.207,1.756,1.667,1.667,0,0,1-1.837,1.7c-.4.964-.585,2.032-1.883,2.445a1.022,1.022,0,0,0-.609.4Zm0,0",
    transform: "translate(-71.527 -173.605)",
    fill: "none",
    stroke: "#19458f",
    strokeLinecap: "round",
    strokeWidth: 0.866
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10138",
    "data-name": "Trazado 10138",
    d: "M130.528,303.769c.1,2.043,1.32,2.043,1.745,2.043s1.641,0,1.745-2.044",
    transform: "translate(-79.958 -185.272)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 0.866
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10139",
    "data-name": "Trazado 10139",
    d: "M120.276,290.31c0,.815-1.079.608-1.079-.333a1.216,1.216,0,0,1,1.3-1.217c1.5,0,1.217,2.2,1.01,3.846a1.854,1.854,0,0,0,1.86,1.974,2.776,2.776,0,0,0,2-1.01,2.778,2.778,0,0,0,2,1.01,1.854,1.854,0,0,0,1.86-1.975c-.207-1.641-.493-3.846,1.01-3.846a1.215,1.215,0,0,1,1.3,1.217c0,.941-1.079,1.148-1.079.333",
    transform: "translate(-73.047 -176.118)",
    fill: "none",
    stroke: "#19458f",
    strokeLinecap: "round",
    strokeWidth: 0.866
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10140",
    "data-name": "Trazado 10140",
    d: "M132.09,286.877a2.987,2.987,0,0,0-.631,1.734c-.149-.23-.941-1.125-1.205-1.01-.229,1.412,1.205,2.48,1.722,2.95v.632h.229v-.632c.516-.47,1.952-1.538,1.722-2.95-.264-.115-1.056.781-1.205,1.01a2.987,2.987,0,0,0-.631-1.734",
    transform: "translate(-79.776 -174.969)",
    fill: "#19458f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10141",
    "data-name": "Trazado 10141",
    d: "M121.8,259.91a1.016,1.016,0,1,0-1.01-1.01,1.022,1.022,0,0,0,1.01,1.01Zm4.581,2.193a1,1,0,0,0,1.01-1.01,1.013,1.013,0,1,0-1.01,1.01Zm5.109,1.217a1.016,1.016,0,1,0,0-2.032,1.016,1.016,0,0,0,0,2.032Zm-5.109-8.932a1,1,0,0,0,1.01-1.01,1.01,1.01,0,1,0-1.726.717,1,1,0,0,0,.716.294Zm0,0",
    transform: "translate(-74.016 -153.915)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10142",
    "data-name": "Trazado 10142",
    d: "M98.836,249.141a5.273,5.273,0,0,0,.609-.172,4.221,4.221,0,0,0,2.342-5.246,3.033,3.033,0,0,0-1.641-1.745,3.42,3.42,0,0,0-2.618-.138c-.057.023-.115.057-.183.08a1.688,1.688,0,0,0-.058-.184,3.409,3.409,0,0,0-1.848-1.86,3.074,3.074,0,0,0-2.388-.046,4.052,4.052,0,0,0-2.2,2.158,4.129,4.129,0,0,0-.138,3.088,2.907,2.907,0,0,0,.287.563,3.687,3.687,0,0,0-.609.172,4.209,4.209,0,0,0-2.342,5.247,3.033,3.033,0,0,0,1.642,1.745,3.42,3.42,0,0,0,2.618.126l.172-.069c.023.057.046.115.069.183a3.445,3.445,0,0,0,1.848,1.86,3.072,3.072,0,0,0,2.388.046,4.222,4.222,0,0,0,2.342-5.246,2.886,2.886,0,0,0-.287-.563",
    transform: "translate(-53.903 -146.142)",
    fill: "#19458f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10143",
    "data-name": "Trazado 10143",
    d: "M98.688,249.38a2.75,2.75,0,0,0,1.194-.2,3.69,3.69,0,0,0,2.009-1.963,3.8,3.8,0,0,0,.127-2.813,2.745,2.745,0,0,0-1.446-1.55,3.042,3.042,0,0,0-2.342-.115,1.876,1.876,0,0,0-.563.3,2.455,2.455,0,0,0-.149-.62,3.013,3.013,0,0,0-1.665-1.653,2.7,2.7,0,0,0-2.112-.046,3.857,3.857,0,0,0-2.124,4.787,2.893,2.893,0,0,0,.654,1.01,2.918,2.918,0,0,0-1.194.183,3.858,3.858,0,0,0-2.124,4.788,2.67,2.67,0,0,0,1.435,1.538,3.07,3.07,0,0,0,2.353.126,2.8,2.8,0,0,0,.551-.3,2.436,2.436,0,0,0,.149.62,3.086,3.086,0,0,0,1.665,1.653,2.748,2.748,0,0,0,2.112.046,3.858,3.858,0,0,0,2.124-4.787A2.655,2.655,0,0,0,98.688,249.38Zm0,0",
    transform: "translate(-54.466 -146.703)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.085
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10144",
    "data-name": "Trazado 10144",
    d: "M92.709,243.481a2.829,2.829,0,0,0,1.114,3.835,2.263,2.263,0,0,0,3.111-.873.852.852,0,0,0-.471-1.137c-.413-.183-.735.046-.918.471a.855.855,0,0,0,.493,1.091c-.39.378-.976.493-2.066.011-.964-.436-1.148-2.043-.666-3.134s1.86-1.917,2.767-1.6c1.125.39,1.251.838,1.377,1.538a.863.863,0,0,0-1.136.367c-.2.425-.149.815.264,1a.861.861,0,0,0,1.159-.413,2.262,2.262,0,0,0-1.435-2.893,2.833,2.833,0,0,0-3.594,1.734m-2.663,5.981a2.832,2.832,0,0,1,3.594-1.734,2.262,2.262,0,0,1,1.435,2.893.852.852,0,0,1-1.159.413c-.413-.184-.459-.574-.264-1,.218-.506.746-.483,1.137-.368.023-.54-.287-1.056-1.378-1.538-.964-.425-2.284.516-2.767,1.6a2.742,2.742,0,0,0,.666,3.134,1.508,1.508,0,0,0,2.066-.012.855.855,0,0,1-.493-1.09c.183-.425.5-.655.918-.471a.856.856,0,0,1,.47,1.136,2.262,2.262,0,0,1-3.111.873,2.826,2.826,0,0,1-1.114-3.835m12.089-1.779a2.832,2.832,0,0,1-3.593,1.734,2.266,2.266,0,0,1-1.435-2.893.853.853,0,0,1,1.16-.413c.413.184.459.574.275,1a.887.887,0,0,1-1.148.367c-.023.54.287,1.056,1.377,1.539.941.413,2.285-.516,2.767-1.6a2.712,2.712,0,0,0-.666-3.134,1.615,1.615,0,0,0-2.067,0,.863.863,0,0,1,.494,1.1c-.184.425-.505.655-.919.471a.856.856,0,0,1-.47-1.137,2.263,2.263,0,0,1,3.111-.872,2.825,2.825,0,0,1,1.114,3.835m-2.663,5.981a2.825,2.825,0,0,0-1.114-3.835,2.262,2.262,0,0,0-3.111.873.856.856,0,0,0,.47,1.136c.413.184.735-.046.919-.47a.851.851,0,0,0-.494-1.091c.39-.379.976-.493,2.066-.012.942.413,1.16,2.044.666,3.134a2.6,2.6,0,0,1-2.767,1.6c-1.137-.367-1.229-.723-1.378-1.538a.871.871,0,0,0,1.137-.367c.2-.425.149-.815-.264-1a.852.852,0,0,0-1.159.414,2.263,2.263,0,0,0,1.435,2.893,2.832,2.832,0,0,0,3.593-1.734",
    transform: "translate(-55.077 -147.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10145",
    "data-name": "Trazado 10145",
    d: "M102.717,257.876l.012-.758.321-.712.275-.241,1.1-2.48.046-.424.333-.758.505-.47-.012.689-.333.758-.287.31-1.1,2.48v.367l-.31.723Zm0,0",
    transform: "translate(-62.996 -153.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10146",
    "data-name": "Trazado 10146",
    d: "M97.219,255.59,93.729,255l-1.4-1.6,2.124-.023Zm0,0",
    transform: "translate(-56.66 -154.543)",
    fill: "#fff",
    stroke: "#19458f",
    strokeLinejoin: "round",
    strokeWidth: 0.866
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10147",
    "data-name": "Trazado 10147",
    d: "M64.882,166.982l1.63-1.217L65.042,163.8l-1.619,1.228-.516-.7,4.133-3.088.505.689-1.883,1.412,1.458,1.952,1.894-1.412.516.689-4.133,3.1Zm-4.546-7.577.689-.333,1.24,2.571,1.217-.6-1.148-2.365.654-.321,1.148,2.376,1.4-.689-1.3-2.652.7-.333,1.665,3.409-4.649,2.262Zm1.423-3.008-.321-1.182c-.183-.655-.459-.93-1.045-.769s-.666.539-.493,1.159l.333,1.205Zm-2.594-.723a2.32,2.32,0,0,1-.058-.264,1.32,1.32,0,0,1,1-1.779,1.175,1.175,0,0,1,1.343.39c.023-.505.31-.689.838-.861l.7-.241c.287-.092.471-.149.517-.356l.149-.046.253.93a1.568,1.568,0,0,1-.62.3l-.6.2c-.505.172-.758.344-.574,1.01a.736.736,0,0,0,.046.161l.3,1.091,2.044-.563.229.827-4.982,1.354ZM58.131,148.8l.758-.069.138,1.584,4.385-.4.08.861-4.385.39.138,1.584-.746.069Zm.276-4.787.746.057-.184,2.664,1.377.1.161-2.342.746.046-.161,2.342,2.273.161-.057.838-5.154-.356Zm2.882-1.435c1.205.321,2.055-.08,2.319-1.045s-.287-1.722-1.5-2.043-2.055.08-2.319,1.033.275,1.722,1.5,2.055m1.045-3.938a2.4,2.4,0,0,1,1.986,3.088c-.39,1.481-1.618,2.124-3.26,1.7-1.641-.448-2.388-1.619-1.986-3.1a2.4,2.4,0,0,1,3.26-1.688m.6-1.952.551-1.1c.31-.6.275-.987-.264-1.263s-.85-.046-1.137.54l-.563,1.113Zm-1.446-2.273c.069-.126.115-.207.126-.241a1.338,1.338,0,0,1,1.94-.655,1.172,1.172,0,0,1,.735,1.194c.367-.367.689-.31,1.205-.092l.677.3c.275.126.448.2.632.069l.138.069-.436.861a1.622,1.622,0,0,1-.666-.183l-.563-.253c-.494-.218-.8-.253-1.1.356-.012.012-.034.069-.08.149l-.505,1.022,1.906.941-.39.769-4.615-2.307Zm5.705-1.01.655-.827c.62-.815.436-1.55-.574-2.33-.93-.723-1.722-.712-2.3.034l-.677.884Zm-2.778-3.594c.93-1.205,2.078-1.274,3.421-.23,1.309,1.01,1.539,2.25.574,3.5l-1.125,1.458-4.087-3.157Zm5.694-3.731a1.008,1.008,0,0,0-1.469.046c-.459.4-.505.884-.275,1.148.356.4.873.161,1.492-.161,1.033-.528,1.734-.815,2.411-.046.62.7.505,1.7-.425,2.537a1.8,1.8,0,0,1-2.743.023l.62-.551a1.145,1.145,0,0,0,1.676-.069c.482-.425.516-.942.264-1.229a.839.839,0,0,0-.562-.218,2.7,2.7,0,0,0-1.125.436c-.987.505-1.63.539-2.2-.1-.539-.609-.448-1.55.47-2.365a1.642,1.642,0,0,1,2.48.012ZM71.9,122.9l1.033,1.745,2.1-1.229L74,121.659l.746-.436,2.618,4.443-.746.436L75.42,124.07l-2.1,1.24,1.194,2.032-.746.436-2.606-4.443Zm5.2-2.652,1.975,4.764-.8.333L76.3,120.58Zm2.973,1.389,1.183-.31c.655-.172.93-.447.781-1.033s-.528-.677-1.159-.505l-1.205.31Zm.747-2.583c.149-.046.241-.057.264-.069a1.339,1.339,0,0,1,1.78,1.022,1.189,1.189,0,0,1-.413,1.343c.505.035.689.31.85.85l.229.7c.092.287.149.471.367.528l.034.138-.93.253a1.7,1.7,0,0,1-.3-.632l-.183-.585c-.161-.517-.345-.77-1-.6-.012,0-.069.023-.161.046l-1.1.287.539,2.055-.827.218-1.308-4.994Zm7.072-.953.057.746-2.847.207.092,1.343,2.629-.184.046.723-2.629.183.115,1.55,2.939-.207.057.769-3.789.275-.367-5.155Zm7.164,2.48a1.176,1.176,0,0,0-1.091-1.217c-.976-.183-1.665.39-1.894,1.584-.241,1.229.2,2.055,1.125,2.239a1.261,1.261,0,0,0,1.55-.941l.826.161a2.072,2.072,0,0,1-2.56,1.538c-1.446-.287-2.135-1.469-1.814-3.134s1.424-2.491,2.927-2.192a1.914,1.914,0,0,1,1.757,2.135ZM97.4,122.3c-.494,1.159-.218,2.055.689,2.445s1.757-.034,2.25-1.182.218-2.055-.689-2.446-1.756.023-2.25,1.183m3.743,1.607a2.485,2.485,0,1,1-1.205-3.478c1.412.6,1.871,1.917,1.205,3.478m3.318-1.159L104.2,127.3l2.227-3.157.677.482-2.974,4.213-.735-.516.252-4.558-2.227,3.157-.677-.471,2.974-4.213Zm5.074,6.36a1,1,0,0,0-.1-1.469c-.414-.437-.9-.471-1.16-.218-.378.367-.115.873.218,1.481.573,1.01.872,1.7.138,2.4-.689.655-1.688.574-2.56-.333a1.808,1.808,0,0,1-.115-2.744l.574.609a1.142,1.142,0,0,0,.126,1.676c.436.459.953.482,1.228.218a.814.814,0,0,0,.207-.574,2.688,2.688,0,0,0-.483-1.114c-.528-.964-.6-1.607.034-2.2.586-.551,1.539-.494,2.376.39a1.656,1.656,0,0,1,.081,2.48Zm4.42,3.421-.62.437-.907-1.309-3.616,2.514-.482-.7,3.616-2.514-.907-1.309.62-.425ZM112.1,135.7l.654,1.389,1.688-1.653Zm3.341-.2-3.846,3.926-.39-.838,1-.987-.861-1.814-1.4.16-.39-.815,5.476-.516Zm-2.721,5.2.321,1.309c.149.643.493.9,1.022.769.562-.138.677-.528.516-1.205l-.31-1.263Zm2.227-.551.3,1.182c.149.609.425.85.93.724.425-.115.551-.448.413-1.033l-.3-1.205Zm2.376.849c.252,1.033-.034,1.665-.884,1.871a1.108,1.108,0,0,1-1.205-.4,1.168,1.168,0,0,1-1,1.171c-.873.218-1.642-.252-1.917-1.377l-.539-2.193,5-1.24Zm.677,3.984-3.2.184c-.873.046-1.286.436-1.24,1.251s.505,1.159,1.378,1.1l3.2-.183.046.861-3.249.2a1.861,1.861,0,0,1-2.158-1.929,1.817,1.817,0,0,1,1.917-2.158l3.26-.183Zm-3.869,9.8-.448,1.481,2.376-.1Zm2.618,2.089-5.488.344.264-.873,1.412-.069.574-1.917-1.148-.827.252-.861,4.408,3.272Zm1.263-6.337-4.351-.471-.264,2.445-.781-.08.356-3.295,5.132.539Zm-4.845,9.219-.563,1.091c-.31.6-.275.987.252,1.263s.861.057,1.148-.516l.574-1.114Zm1.423,2.284c-.069.126-.115.207-.126.23a1.332,1.332,0,0,1-1.94.643,1.2,1.2,0,0,1-.735-1.205c-.356.356-.689.31-1.194.08l-.678-.31c-.275-.126-.448-.2-.632-.08l-.138-.069.448-.85a1.49,1.49,0,0,1,.666.2l.551.253c.494.229.8.264,1.114-.344.012-.012.034-.069.08-.149l.517-1.01-1.894-.976.39-.758,4.592,2.365Zm-2,3.295-2.629-.424,1.114,2.4-.609.781-1.389-3.306-1.619-1.24.528-.689,1.584,1.217,3.662.424Zm0,0",
    transform: "translate(-35.802 -72.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10148",
    "data-name": "Trazado 10148",
    d: "M95.328,104.053a38.543,38.543,0,0,1,14.534-2.985,37.173,37.173,0,0,1,14.3,3l1.618-3.421a41.8,41.8,0,0,0-15.854-3A51.157,51.157,0,0,0,93.594,100.3Zm0,0",
    transform: "translate(-57.431 -59.556)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.469
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10149",
    "data-name": "Trazado 10149",
    d: "M105.9,16.063l.172,1.825,1.148-.057.379.6.081,1.562s2.881-.482,9.643,4.546c8.908,6.624,6.142,10.5,6.142,10.5l-16.68-4.684-3.7-.023L85.66,34.442s-.827-3.72,6.165-9.425c5.8-4.73,10.263-5.109,10.263-5.109s-.39.7.643.7l-.39-1.7.321-.976h1.217l.057-1.871a4.1,4.1,0,0,1,1-.057c.287,0,.964.057.964.057v.654",
    transform: "translate(-52.574 -9.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10150",
    "data-name": "Trazado 10150",
    d: "M90.73,58.3c-.08.207,2.17.494,3.766.448s4.626-.609,5.3-.574,7.313-.528,7.359-.9a16.917,16.917,0,0,0-1.366-9.046,4.5,4.5,0,0,1-.218-2.962s.333-.379-.8-.425c-1.584-.057-4.81.941-5.545.919a9.528,9.528,0,0,0-2.973-.115c-3.295.264-5.005,4.087-5.453,5.706-.976,3.524-.39,5.223-.39,5.223Zm34.084,0c.08.207-2.17.494-3.777.448s-4.615-.609-5.292-.574-7.313-.528-7.359-.9c-.46-3.065-.838-4.5.436-7.347a23.079,23.079,0,0,0,1.148-4.661s-.333-.379.8-.425c1.584-.057,4.81.941,5.545.919a9.53,9.53,0,0,1,2.973-.115c3.3.264,5.006,4.087,5.453,5.706.975,3.524.39,5.223.39,5.223Zm0,0",
    transform: "translate(-55.382 -27.351)",
    fill: "#eb172b",
    stroke: "#19458f",
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10151",
    "data-name": "Trazado 10151",
    d: "M89.22,38.547l-1.825.505a22.861,22.861,0,0,1,13.03-11.182.548.548,0,0,1,.6.172.646.646,0,0,1,.1.218.631.631,0,0,1-.459.723c-2.308.666-9.31,4.489-11.446,9.563m31.857-.1,1.825.505a22.819,22.819,0,0,0-13.03-11.182.53.53,0,0,0-.6.172.6.6,0,0,0,.356.942c2.307.666,9.31,4.489,11.446,9.563M100.034,27a1.051,1.051,0,1,1,0-2.1,1.1,1.1,0,0,1,.769.31,1.05,1.05,0,0,1,.31.746A1.069,1.069,0,0,1,100.046,27Zm-2.25.781a1.1,1.1,0,0,1-.758-.31,1.05,1.05,0,0,1-.31-.746,1.069,1.069,0,0,1,1.068-1.045,1.159,1.159,0,0,1,.769.31,1.093,1.093,0,0,1,.31.746,1.071,1.071,0,0,1-1.079,1.045ZM95.649,28.8a1.077,1.077,0,0,1-.758-.31,1,1,0,0,1-.31-.735A1.068,1.068,0,1,1,95.649,28.8Zm-2.021,1.262a1.05,1.05,0,1,1,0-2.1,1.051,1.051,0,1,1,0,2.1Zm-1.86,1.458a1.153,1.153,0,0,1-.758-.31,1.092,1.092,0,0,1-.31-.746,1.074,1.074,0,1,1,1.068,1.056Zm-1.7,1.642a1.126,1.126,0,0,1-.746-.31,1.042,1.042,0,0,1-.31-.746,1.061,1.061,0,0,1,1.068-1.045,1.1,1.1,0,0,1,.758.31,1.047,1.047,0,0,1-.758,1.791Zm-1.5,1.8a1.029,1.029,0,0,1-.758-.31,1,1,0,0,1-.31-.735,1.068,1.068,0,1,1,1.068,1.045Zm-1.32,1.963a1.058,1.058,0,0,1-1.068-1.056,1.068,1.068,0,1,1,1.068,1.056Zm0,0",
    transform: "translate(-52.908 -15.185)",
    fill: "#19458f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10152",
    "data-name": "Trazado 10152",
    d: "M99.781,24.485a1.218,1.218,0,0,0-1.229,1.205v.1a1.224,1.224,0,0,0-1.01-.528H97.53A1.218,1.218,0,0,0,96.3,26.471a.735.735,0,0,0,.023.23l-.057-.058a1.322,1.322,0,0,0-.861-.356H95.4a1.205,1.205,0,0,0-1.182,1.572,1.226,1.226,0,0,0-.827-.31h-.012a1.217,1.217,0,0,0-1.228,1.205,1.385,1.385,0,0,0,.092.482,1.2,1.2,0,0,0-.712-.23h-.012a1.218,1.218,0,0,0-1.079,1.8,1.239,1.239,0,0,0-1.848,1.045,1.221,1.221,0,0,0,.229.712,1.245,1.245,0,0,0-.493-.115h-.012a1.245,1.245,0,0,0-1.24,1.217,1.213,1.213,0,0,0,.31.8A1.311,1.311,0,0,0,87,34.415h-.012a1.211,1.211,0,1,0,.93.4,1.072,1.072,0,0,0,.39.069,1.235,1.235,0,0,0,1.24-1.205,1.2,1.2,0,0,0-.229-.712,1.193,1.193,0,0,0,.493.1,1.22,1.22,0,0,0,1.24-1.205,1.1,1.1,0,0,0-.149-.6,1.239,1.239,0,0,0,1.848-1.045,1.135,1.135,0,0,0-.1-.482,1.258,1.258,0,0,0,.723.23,1.22,1.22,0,0,0,1.24-1.205,1.311,1.311,0,0,0-.057-.367,1.244,1.244,0,0,0,2.078-.884,1.391,1.391,0,0,0-.023-.23l.046.046a1.245,1.245,0,0,0,.873.356,1.228,1.228,0,0,0,1.24-1.205v-.1a1.771,1.771,0,0,0,.138.172,1.243,1.243,0,0,0,2.112-.85,1.2,1.2,0,0,0-.356-.861,1.223,1.223,0,0,0-.872-.356ZM86.992,34.748H87a.879.879,0,1,1-.012,1.757.879.879,0,1,1,0-1.757m1.32-1.963a.884.884,0,1,1-.907.884.9.9,0,0,1,.907-.884m1.515-1.8a.873.873,0,0,1,.9.884.885.885,0,0,1-.9.873h-.012a.879.879,0,1,1,.011-1.757m1.688-1.641h.012a.9.9,0,1,1-.012,0m1.86-1.458h.012a.9.9,0,1,1-.012,0M95.4,26.62a.884.884,0,1,1,0,1.768h-.012A.884.884,0,1,1,95.4,26.62M97.531,25.6h.012a.894.894,0,0,1,.9.884.885.885,0,0,1-.9.873h-.012a.878.878,0,1,1,0-1.757m2.25-.781h.012a.9.9,0,1,1-.012,0",
    transform: "translate(-52.655 -14.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10153",
    "data-name": "Trazado 10153",
    d: "M87.514,35.269a.9.9,0,1,0,.011,0h-.012m1.32-1.963a.884.884,0,1,0,.907.884A.9.9,0,0,0,88.834,33.306Zm1.515-1.8a.879.879,0,1,0,.907.884.894.894,0,0,0-.907-.884m1.688-1.641a.878.878,0,1,0,0,1.756h.012a.878.878,0,1,0,0-1.756h-.012M93.908,28.4a.879.879,0,1,0-.011,1.757h.012a.878.878,0,1,0,0-1.757m2.009-1.263a.884.884,0,1,0,.907.884.9.9,0,0,0-.907-.884Zm2.147-1.022a.879.879,0,1,0-.011,1.757h.012a.885.885,0,0,0,.9-.873.894.894,0,0,0-.9-.884m2.238-.781a.884.884,0,0,0-.9.872.894.894,0,0,0,.9.884h.012a.878.878,0,1,0,0-1.756Zm-12.789,9.93.012.379a.505.505,0,0,1,.516.505.513.513,0,0,1-.528.494.533.533,0,0,1-.367-.149A.477.477,0,0,1,87,36.142a.5.5,0,0,1,.516-.494v-.379m1.32-1.963v.378a.522.522,0,0,1,.379.161.5.5,0,0,1,.149.344.528.528,0,0,1-.907.344.5.5,0,0,1-.149-.344.522.522,0,0,1,.528-.505v-.379m1.516-1.8v.378a.528.528,0,0,1,.379.149.451.451,0,0,1,.138.356.5.5,0,0,1-.516.494.558.558,0,0,1-.379-.149.5.5,0,0,1-.149-.356.513.513,0,0,1,.528-.494V31.5m1.688-1.642.012.379a.485.485,0,0,1,.367.149.5.5,0,0,1,.149.344.522.522,0,0,1-.528.505.532.532,0,0,1-.367-.149.5.5,0,0,1-.149-.356.5.5,0,0,1,.517-.493v-.379M93.909,28.4v.379a.5.5,0,0,1,.516.494.522.522,0,0,1-.528.505.529.529,0,0,1-.367-.149.478.478,0,0,1-.149-.356.506.506,0,0,1,.528-.494V28.4m2.009-1.263v.379a.593.593,0,0,1,.378.161.442.442,0,0,1,.138.344.512.512,0,0,1-.516.505.558.558,0,0,1-.379-.149.548.548,0,0,1-.149-.356.53.53,0,0,1,.528-.505v-.378m2.147-1.022V26.5a.512.512,0,0,1,.516.505.505.505,0,0,1-.528.493.532.532,0,0,1-.367-.149A.452.452,0,0,1,97.536,27a.508.508,0,0,1,.528-.505V26.12m2.239-.781.012.378a.531.531,0,0,1,.367.149.461.461,0,0,1,.149.356.52.52,0,0,1-.528.493.531.531,0,0,1-.367-.149.478.478,0,0,1-.149-.356.51.51,0,0,1,.516-.493Zm0,0",
    transform: "translate(-53.177 -15.455)",
    fill: "#19458f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10154",
    "data-name": "Trazado 10154",
    d: "M84,57.721a1,1,0,0,1-1-.976.987.987,0,0,1,1-.976.976.976,0,1,1,0,1.952",
    transform: "translate(-50.97 -34.014)",
    fill: "#19458f",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.851
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10155",
    "data-name": "Trazado 10155",
    d: "M146.221,26.545a1.045,1.045,0,1,1,1.068-1.045,1,1,0,0,1-.31.735,1.049,1.049,0,0,1-.758.31m2.25.792a1.045,1.045,0,1,1,1.068-1.045,1.056,1.056,0,0,1-1.068,1.045m2.135,1.045a1.051,1.051,0,1,1,0-2.1,1.1,1.1,0,0,1,.758.31,1.044,1.044,0,0,1,.31.735,1.063,1.063,0,0,1-1.068,1.056m2.009,1.263a1.051,1.051,0,1,1,1.068-1.045,1.054,1.054,0,0,1-1.068,1.045m1.848,1.458a1.045,1.045,0,1,1,1.068-1.045,1.054,1.054,0,0,1-1.068,1.045m1.688,1.653a1.045,1.045,0,1,1,1.068-1.045,1.061,1.061,0,0,1-1.068,1.045m1.5,1.826a1.051,1.051,0,1,1,1.068-1.045,1.061,1.061,0,0,1-1.068,1.045m1.309,1.963a1.051,1.051,0,1,1,1.068-1.056,1.063,1.063,0,0,1-1.068,1.056",
    transform: "translate(-88.878 -14.916)",
    fill: "#19458f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10156",
    "data-name": "Trazado 10156",
    d: "M145.97,24.014a1.218,1.218,0,0,0-.872,2.078,1.242,1.242,0,0,0,.873.356,1.21,1.21,0,0,0,1.01-.528v.1a1.164,1.164,0,0,0,.367.861,1.223,1.223,0,0,0,.873.356,1.264,1.264,0,0,0,.918-.4,1.385,1.385,0,0,0-.023.218,1.188,1.188,0,0,0,.367.872,1.262,1.262,0,0,0,.872.344,1.229,1.229,0,0,0,.827-.31,1.3,1.3,0,0,0-.058.367,1.182,1.182,0,0,0,.367.861,1.262,1.262,0,0,0,.873.344,1.241,1.241,0,0,0,.712-.218,1.23,1.23,0,0,0-.092.471,1.2,1.2,0,0,0,.356.861,1.263,1.263,0,0,0,.872.356,1.233,1.233,0,0,0,.609-.161,1.237,1.237,0,0,0,.207,1.458,1.242,1.242,0,0,0,.872.356,1.207,1.207,0,0,0,.505-.1,1.147,1.147,0,0,0-.229.712,1.238,1.238,0,0,0,.356.861,1.284,1.284,0,0,0,.873.344,1.446,1.446,0,0,0,.39-.057,1.18,1.18,0,0,0,.046,1.665,1.244,1.244,0,0,0,.873.356,1.21,1.21,0,0,0,.872-2.078,1.263,1.263,0,0,0-.872-.344,1.457,1.457,0,0,0-.39.057,1.18,1.18,0,0,0-.046-1.665,1.223,1.223,0,0,0-.872-.356v0a1.279,1.279,0,0,0-.505.1,1.182,1.182,0,0,0,.241-.712,1.235,1.235,0,0,0-1.24-1.217,1.369,1.369,0,0,0-.609.161,1.158,1.158,0,0,0,.161-.6,1.182,1.182,0,0,0-.367-.861,1.263,1.263,0,0,0-.873-.344,1.174,1.174,0,0,0-.712.23,1.385,1.385,0,0,0,.092-.482,1.2,1.2,0,0,0-.356-.861,1.263,1.263,0,0,0-.872-.356,1.28,1.28,0,0,0-.838.31.95.95,0,0,0,.069-.367,1.229,1.229,0,0,0-.367-.861,1.305,1.305,0,0,0-.873-.344,1.291,1.291,0,0,0-.93.4.73.73,0,0,0,.023-.23,1.217,1.217,0,0,0-.356-.861,1.252,1.252,0,0,0-.872-.344,1.266,1.266,0,0,0-1.022.517.314.314,0,0,0,.012-.1,1.237,1.237,0,0,0-1.24-1.217m12.743,10.332a.879.879,0,1,1,0,1.756.879.879,0,1,1,0-1.756M157.4,32.383a.878.878,0,1,1-.9.884.889.889,0,0,1,.9-.884m-1.5-1.825a.884.884,0,1,1-.907.884.9.9,0,0,1,.907-.884m-1.688-1.641a.878.878,0,1,1-.9.872.887.887,0,0,1,.9-.872m-1.848-1.469a.879.879,0,1,1-.907.884.887.887,0,0,1,.907-.884m-2.009-1.263a.879.879,0,1,1-.907.873.895.895,0,0,1,.907-.873m-2.135-1.033a.879.879,0,1,1-.907.872.885.885,0,0,1,.907-.872m-2.25-.8a.884.884,0,1,1-.907.884.9.9,0,0,1,.907-.884",
    transform: "translate(-88.627 -14.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10157",
    "data-name": "Trazado 10157",
    d: "M182.351,57.444a.97.97,0,1,1,.987-.964.985.985,0,0,1-.987.964",
    transform: "translate(-110.956 -33.852)",
    fill: "#19458f",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.851
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10158",
    "data-name": "Trazado 10158",
    d: "M133.444,39.465a1.014,1.014,0,0,0-1.033,1,1.027,1.027,0,0,0,2.055,0,1.012,1.012,0,0,0-1.022-1",
    transform: "translate(-81.106 -24.07)",
    fill: "#19458f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10159",
    "data-name": "Trazado 10159",
    d: "M133.444,39.465a1.014,1.014,0,0,0-1.033,1,1.027,1.027,0,0,0,2.055,0,1.012,1.012,0,0,0-1.022-1Zm0,0",
    transform: "translate(-81.106 -24.07)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10160",
    "data-name": "Trazado 10160",
    d: "M133.444,46.116a1,1,0,1,0,1.033,1.01,1.032,1.032,0,0,0-1.033-1.01",
    transform: "translate(-81.106 -28.127)",
    fill: "#19458f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10161",
    "data-name": "Trazado 10161",
    d: "M133.444,46.116a1,1,0,1,0,1.033,1.01A1.032,1.032,0,0,0,133.444,46.116Zm0,0",
    transform: "translate(-81.106 -28.127)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10162",
    "data-name": "Trazado 10162",
    d: "M133.444,32.99a1,1,0,1,0,0,2.009,1,1,0,1,0,0-2.009",
    transform: "translate(-81.106 -20.121)",
    fill: "#19458f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10163",
    "data-name": "Trazado 10163",
    d: "M133.444,32.99a1,1,0,1,0,0,2.009,1,1,0,1,0,0-2.009Zm0,0",
    transform: "translate(-81.106 -20.121)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10164",
    "data-name": "Trazado 10164",
    d: "M128.6,12.638a.122.122,0,0,1-.057-.012,3.254,3.254,0,0,1-2.021-2.984,3.2,3.2,0,0,1,1.642-2.779h-.39a.155.155,0,0,1-.15-.161V6.4a.14.14,0,0,1,.126-.149,1.938,1.938,0,0,0,1.309-1.492,1.227,1.227,0,0,1-.3-.3,1.962,1.962,0,0,0-1.538,1.274.148.148,0,0,1-.149.126h-.31a.155.155,0,0,1-.161-.149V1.56a.157.157,0,0,1,.161-.161h.31a.159.159,0,0,1,.149.126A1.962,1.962,0,0,0,128.764,2.8a1.412,1.412,0,0,1,.3-.287,1.918,1.918,0,0,0-1.309-1.492.16.16,0,0,1-.126-.161v-.3a.152.152,0,0,1,.149-.149h4.271a.145.145,0,0,1,.149.149v.3a.16.16,0,0,1-.126.161,1.957,1.957,0,0,0-1.309,1.492,1.831,1.831,0,0,1,.31.287,2,2,0,0,0,1.539-1.274.149.149,0,0,1,.149-.126h.3a.157.157,0,0,1,.161.161V5.716a.155.155,0,0,1-.161.149h-.3a.14.14,0,0,1-.149-.126,2,2,0,0,0-1.539-1.274,1.523,1.523,0,0,1-.31.3,1.977,1.977,0,0,0,1.309,1.492.14.14,0,0,1,.126.149v.3a.148.148,0,0,1-.149.161h-.505a3.191,3.191,0,0,1,1.63,2.778,3.237,3.237,0,0,1-2.021,2.985.084.084,0,0,1-.057.012.145.145,0,0,1-.126-.069.155.155,0,0,1,.012-.2,1.5,1.5,0,0,0,.447-1.056,1.541,1.541,0,0,0-1.205-1.492.146.146,0,0,1-.115-.172.15.15,0,0,1,.149-.138h.012a5.543,5.543,0,0,1,1.688.287l-.023-.7a7.277,7.277,0,0,0-1.826-.287.142.142,0,0,1-.115-.057.152.152,0,0,1-.023-.138l.493-1.757h-1.229l.46,1.757a.15.15,0,0,1-.034.138.142.142,0,0,1-.115.057,6.47,6.47,0,0,0-1.791.3l-.023.7a5.509,5.509,0,0,1,1.71-.3.172.172,0,0,1,.161.138.154.154,0,0,1-.126.172,1.543,1.543,0,0,0-1.194,1.492,1.484,1.484,0,0,0,.436,1.056.157.157,0,0,1,.023.2.163.163,0,0,1-.138.069",
    transform: "translate(-77.516 -0.251)",
    fill: "#19458f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10165",
    "data-name": "Trazado 10165",
    d: "M129.208,6.762h.815L129.6,8.289ZM131.814,0h-4.27a.309.309,0,0,0-.31.31v.3a.319.319,0,0,0,.264.31A1.757,1.757,0,0,1,128.645,2.2a2.2,2.2,0,0,0-.172.161,1.792,1.792,0,0,1-1.331-1.125.312.312,0,0,0-.31-.252h-.3a.321.321,0,0,0-.321.321V5.464a.319.319,0,0,0,.321.31h.3a.3.3,0,0,0,.31-.253A1.794,1.794,0,0,1,128.473,4.4l.172.172A1.737,1.737,0,0,1,127.5,5.843a.33.33,0,0,0-.264.31v.3a.326.326,0,0,0,.207.3,3.329,3.329,0,0,0-1.3,2.641,3.4,3.4,0,0,0,2.112,3.134.4.4,0,0,0,.115.023.337.337,0,0,0,.264-.138.328.328,0,0,0-.034-.4,1.338,1.338,0,0,1-.39-.941,1.361,1.361,0,0,1,1.079-1.332.323.323,0,0,0,.23-.344.3.3,0,0,0-.31-.275H129.2a5.73,5.73,0,0,0-1.539.229l.012-.367a6.887,6.887,0,0,1,1.653-.253.33.33,0,0,0,.23-.126.222.222,0,0,0,.046-.069.1.1,0,0,0,.034.069.355.355,0,0,0,.23.126,7.1,7.1,0,0,1,1.676.241l.012.367a5.388,5.388,0,0,0-1.515-.218h-.012a.311.311,0,0,0-.31.276.32.32,0,0,0,.241.344,1.372,1.372,0,0,1,1.079,1.332,1.34,1.34,0,0,1-.39.941.329.329,0,0,0-.046.4.356.356,0,0,0,.264.138.5.5,0,0,0,.126-.023A3.42,3.42,0,0,0,133.1,9.391a3.331,3.331,0,0,0-1.286-2.629.309.309,0,0,0,.31-.31v-.3a.318.318,0,0,0-.252-.31,1.749,1.749,0,0,1-1.159-1.274,1.192,1.192,0,0,0,.172-.172c.735.23,1.251.655,1.332,1.125a.318.318,0,0,0,.31.253h.31a.309.309,0,0,0,.31-.31V1.309a.312.312,0,0,0-.31-.321h-.31a.331.331,0,0,0-.31.252c-.08.471-.6.9-1.332,1.125a.773.773,0,0,0-.172-.161A1.768,1.768,0,0,1,131.871.918a.309.309,0,0,0,.252-.31V.31a.309.309,0,0,0-.31-.31m0,.31v.3a2.176,2.176,0,0,0-1.469,1.711,1.221,1.221,0,0,1,.425.413,2.191,2.191,0,0,0,1.756-1.424h.31V5.464h-.31a2.183,2.183,0,0,0-1.756-1.435,1.218,1.218,0,0,1-.425.413,2.16,2.16,0,0,0,1.47,1.71v.3h-1.274a3.052,3.052,0,0,1,.321,5.775,1.641,1.641,0,0,0,.482-1.16,1.705,1.705,0,0,0-1.32-1.642,4.822,4.822,0,0,1,1.86.356l-.034-1.045a6.918,6.918,0,0,0-1.963-.321l.551-1.963h-1.641l.505,1.963a6.626,6.626,0,0,0-1.929.333l-.046,1.045a4.987,4.987,0,0,1,1.883-.367,1.7,1.7,0,0,0-1.32,1.642,1.639,1.639,0,0,0,.482,1.159,3.052,3.052,0,0,1,.321-5.774h-1.148v-.3a2.123,2.123,0,0,0,1.469-1.711,1.187,1.187,0,0,1-.413-.413,2.183,2.183,0,0,0-1.768,1.436h-.3V1.308h.3A2.193,2.193,0,0,0,128.6,2.732a1.188,1.188,0,0,1,.413-.413,2.141,2.141,0,0,0-1.47-1.711V.31Zm0,0",
    transform: "translate(-77.283 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10166",
    "data-name": "Trazado 10166",
    d: "M133.212,26.81a1.088,1.088,0,0,0-.792,1.871,1.706,1.706,0,0,1,1.584,0,1.088,1.088,0,0,0-.792-1.871",
    transform: "translate(-80.909 -16.352)",
    fill: "#19458f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10167",
    "data-name": "Trazado 10167",
    d: "M133.212,26.81a1.088,1.088,0,0,0-.792,1.871,1.706,1.706,0,0,1,1.584,0,1.088,1.088,0,0,0-.792-1.871Zm0,0",
    transform: "translate(-80.909 -16.352)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10168",
    "data-name": "Trazado 10168",
    d: "M134.231,6.709a.626.626,0,1,0,.643.62.63.63,0,0,0-.643-.62",
    transform: "translate(-81.824 -4.092)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10169",
    "data-name": "Trazado 10169",
    d: "M126.086,37.984H127.2a27.772,27.772,0,0,0-1.527-9.758.562.562,0,0,0-.516-.356.4.4,0,0,0-.229.057.621.621,0,0,0-.275.8,25.042,25.042,0,0,1,1.435,9.253m5.074,0h-1.113c0-2.342.2-6.567,1.527-9.758a.552.552,0,0,1,.516-.356.452.452,0,0,1,.23.057.633.633,0,0,1,.275.8,24.8,24.8,0,0,0-1.436,9.253",
    transform: "translate(-76.342 -16.998)",
    fill: "#19458f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10170",
    "data-name": "Trazado 10170",
    d: "M102.975,71.139a31.72,31.72,0,0,0-13.007,2.618,2.091,2.091,0,0,1-2.089-.057,1.692,1.692,0,0,1-.861-1.251,1.476,1.476,0,0,1,.838-1.665c.149-.08.31-.161.471-.23.08-.046.115-.092.092-.172L84.985,58.764a5.833,5.833,0,0,0-.585-1.3,4.224,4.224,0,0,0-.528-.8A1.709,1.709,0,0,0,82.792,56c-.2-.023-.229-.069-.241-.2a.1.1,0,0,1,.057-.126c.046-.012.092-.034.138-.046l4.064-1.274c.069-.023.149-.08.207.012a.241.241,0,0,1-.023.321,2.769,2.769,0,0,0-.574.585,2.677,2.677,0,0,0-.517,1.515,3.987,3.987,0,0,0,.161,1.332c.046.126.046.126.172.069A2.422,2.422,0,0,0,87.8,55.837c0-.149.035-.184.2-.207.115-.023.149-.012.2.138.126.4.241.792.367,1.194.333,1.079.666,2.159.987,3.249a.591.591,0,0,1,.035.092c.023.069.057.149-.057.2s-.172.046-.252-.057a2.645,2.645,0,0,0-1.527-.964,3.4,3.4,0,0,0-.964-.057c-.1.012-.126.046-.092.126a5.631,5.631,0,0,0,1.538,2.044,2.435,2.435,0,0,0,1.389.493,4.255,4.255,0,0,0,1.963-.344,2.519,2.519,0,0,0,1.492-1.619,1.8,1.8,0,0,0-.356-1.791.787.787,0,0,0-1.389.333,1.676,1.676,0,0,0,.023.678c.034.1.069.218.1.333.023.08,0,.115-.092.092a1.482,1.482,0,0,1-.574-.276,2.912,2.912,0,0,1-1.217-2.066,1.392,1.392,0,0,1,.379-1.1,1.9,1.9,0,0,1,2.629-.184c.057.046.126.092.218.172a1.56,1.56,0,0,0-.092-.252,9.117,9.117,0,0,1-.666-1.871,3.786,3.786,0,0,1,.425-2.664c.034-.057.069-.138.115-.207.092-.16.126-.16.275-.057a3.581,3.581,0,0,1,.93.93,3.992,3.992,0,0,1,.6,1.492,7.617,7.617,0,0,1,.092,2.227c0,.034-.012.08-.012.115a.394.394,0,0,1,.012.069c.057-.115.1-.207.161-.3a2.272,2.272,0,0,1,.8-.907,1.6,1.6,0,0,1,2.135.31,2.153,2.153,0,0,1,.367,2.181,3.786,3.786,0,0,1-.781,1.343.338.338,0,0,1-.172.126.452.452,0,0,1,.012-.218,2.03,2.03,0,0,0-.012-.746.792.792,0,0,0-.792-.609c-.6-.023-.838.367-.907.85a2.525,2.525,0,0,0,1.332,2.526,3.229,3.229,0,0,0,1.562.367,3.843,3.843,0,0,0,3.18-1.7,4.157,4.157,0,0,0,.585-1.5c.057-.264.092-.528.138-.792.023-.1,0-.126-.1-.115a3.578,3.578,0,0,0-1.745.666,2.249,2.249,0,0,0-.884,1.286c-.034.149-.138.2-.3.149a.1.1,0,0,1-.069-.069.463.463,0,0,1-.012-.126c-.023-.516-.034-1.045-.046-1.561-.023-.8-.057-1.607-.092-2.411-.012-.413,0-.827-.034-1.229-.012-.126.012-.149.126-.161a.438.438,0,0,0,.126-.011c.092-.012.138.023.172.115a2.866,2.866,0,0,0,2.411,1.917,1.52,1.52,0,0,0,.39.046c.126,0,.149-.023.138-.138a3.794,3.794,0,0,0-1.079-2.388,2.4,2.4,0,0,0-1.1-.62c-.092-.023-.183-.034-.2-.161-.012-.207.023-.252.252-.252h6.085c.2,0,.275.138.207.321a.132.132,0,0,1-.1.069c-.08.023-.172.046-.264.08a2.69,2.69,0,0,0-1.332,1.056,3.987,3.987,0,0,0-.655,1.883c-.012.138,0,.149.138.149a3.141,3.141,0,0,0,2.583-1.458,2.17,2.17,0,0,0,.207-.47c.046-.149.046-.149.207-.138h.115c.069,0,.1.046.115.115a2.544,2.544,0,0,1-.012.3c-.012.172-.012.333-.023.505-.024.9-.046,1.791-.08,2.675l-.069,1.779c-.012.184-.046.218-.229.2a.152.152,0,0,1-.126-.092.16.16,0,0,0-.023-.069,2.269,2.269,0,0,0-1.01-1.378,3.57,3.57,0,0,0-1.619-.574c-.092-.012-.115.012-.1.092a6.083,6.083,0,0,0,.482,1.86,3.731,3.731,0,0,0,2.928,2.124,3.2,3.2,0,0,0,2.055-.333,2.522,2.522,0,0,0,1.366-2.319,1.406,1.406,0,0,0-.138-.585.738.738,0,0,0-.666-.46.845.845,0,0,0-.172,0,.718.718,0,0,0-.723.528,1.4,1.4,0,0,0-.057.723c.012.092.034.183.046.287-.08.023-.115-.023-.149-.058a3.559,3.559,0,0,1-.953-2.055,2.035,2.035,0,0,1,.6-1.619,1.615,1.615,0,0,1,2.25-.046,2.6,2.6,0,0,1,.665.873.24.24,0,0,0,.069.115.727.727,0,0,0,0-.275,7,7,0,0,1,.207-2.491,3.58,3.58,0,0,1,1.389-1.986c.207-.149.207-.149.333.069a3.792,3.792,0,0,1,.6,2.158,4.725,4.725,0,0,1-.321,1.538c-.161.437-.344.861-.528,1.309l.161-.161a1.927,1.927,0,0,1,1.963-.39,1.658,1.658,0,0,1,1.125,1.63,2.172,2.172,0,0,1-.172.7,3.108,3.108,0,0,1-1.136,1.412,1.83,1.83,0,0,1-.482.218c-.092.023-.126,0-.092-.1a3.833,3.833,0,0,0,.126-.517,1.068,1.068,0,0,0-.115-.746.754.754,0,0,0-1.125-.207,1.551,1.551,0,0,0-.585,1.1,2.341,2.341,0,0,0,1.274,2.3,3.894,3.894,0,0,0,2.158.493,2.677,2.677,0,0,0,2.021-.976,8.173,8.173,0,0,0,.987-1.515c.069-.126.057-.161-.069-.172a2.967,2.967,0,0,0-1.631.3,2.813,2.813,0,0,0-.849.712.187.187,0,0,1-.161.1c-.161-.012-.218-.08-.161-.241.252-.826.505-1.641.746-2.456.2-.609.378-1.217.563-1.826.023-.08.046-.161.069-.229a.212.212,0,0,1,.356-.1c.046.034.034.092.034.149a2.021,2.021,0,0,0,.138.827A2.736,2.736,0,0,0,119.9,58.19c.1.057.126.046.161-.069a3.966,3.966,0,0,0,.161-1.423,2.806,2.806,0,0,0-.39-1.24,2.842,2.842,0,0,0-.654-.735c-.057-.046-.126-.08-.115-.172.012-.218.08-.253.287-.2,1.332.424,2.664.849,4,1.263l.1.034c.069.023.138.034.138.126a.211.211,0,0,1-.138.2.163.163,0,0,1-.069.023,1.837,1.837,0,0,0-1.263.838,8.507,8.507,0,0,0-.769,1.424L117.818,70.29c-.034.126-.034.126.092.184s.2.126.321.2a1.732,1.732,0,0,1,.677,1.631,1.891,1.891,0,0,1-1.745,1.688,2.187,2.187,0,0,1-1.24-.23,35.581,35.581,0,0,0-12.95-2.617",
    transform: "translate(-50.694 -31.212)",
    fill: "#fff",
    stroke: "#19458f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.462
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10171",
    "data-name": "Trazado 10171",
    d: "M90.092,88.827l1.182-2.158,3.238,1.045-2.17,2.411Zm0,0",
    transform: "translate(-55.296 -52.86)",
    fill: "#eb172b",
    stroke: "#19458f",
    strokeWidth: 1.484
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10172",
    "data-name": "Trazado 10172",
    d: "M106.712,84.529c-.2-.953.849-1.929,2.353-2.193s2.87.3,3.065,1.251-.838,1.917-2.342,2.181-2.87-.3-3.077-1.24",
    transform: "translate(-65.418 -50.18)",
    fill: "#fff",
    stroke: "#19458f",
    strokeWidth: 1.484
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10173",
    "data-name": "Trazado 10173",
    d: "M129.58,79.224l3.456,2.2-3.468,2.2-3.455-2.2Zm0,0",
    transform: "translate(-77.265 -48.32)",
    fill: "#eb172b",
    stroke: "#19458f",
    strokeWidth: 1.484
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10174",
    "data-name": "Trazado 10174",
    d: "M149.3,83.588c.207-.953,1.584-1.5,3.077-1.251s2.548,1.24,2.342,2.192-1.573,1.5-3.077,1.24-2.537-1.24-2.342-2.181",
    transform: "translate(-91.391 -50.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10175",
    "data-name": "Trazado 10175",
    d: "M149.3,83.588c.207-.953,1.584-1.5,3.077-1.251s2.548,1.24,2.342,2.192-1.573,1.5-3.077,1.24-2.537-1.24-2.342-2.181Zm0,0",
    transform: "translate(-91.391 -50.18)",
    fill: "none",
    stroke: "#19458f",
    strokeWidth: 1.484
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10176",
    "data-name": "Trazado 10176",
    d: "M172.97,88.827l-2.238,1.3-2.181-2.411,3.238-1.045Zm0,0",
    transform: "translate(-103.148 -52.86)",
    fill: "#eb172b",
    stroke: "#19458f",
    strokeWidth: 1.484
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10177",
    "data-name": "Trazado 10177",
    d: "M126.986,100.585s-14.12-6.176-28.184.172",
    transform: "translate(-60.608 -59.704)",
    fill: "none",
    stroke: "#19458f",
    strokeLinecap: "round",
    strokeWidth: 5.108
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10178",
    "data-name": "Trazado 10178",
    d: "M114.99,95.763a11.456,11.456,0,0,1-2.618.85,5.537,5.537,0,0,1,2.526.746c.012-.287-.287-.551-.586-.666a3.238,3.238,0,0,0,1.561-.08,2.472,2.472,0,0,0-1.55-.207c.3-.115.643-.356.666-.643m-6.337.3a10.824,10.824,0,0,1-2.3,1.263,6.142,6.142,0,0,1,2.675.3,1,1,0,0,0-.758-.551,2.953,2.953,0,0,0,1.492-.344,2.672,2.672,0,0,0-1.573.069c.252-.161.516-.448.459-.735m-6.107,1.5a8.822,8.822,0,0,1-1.86,1.631,7.351,7.351,0,0,1,2.675-.264c-.161-.264-.551-.3-.884-.31a2.714,2.714,0,0,0,1.355-.586,2.494,2.494,0,0,0-1.515.333.73.73,0,0,0,.23-.8m24.177.4a14.456,14.456,0,0,1-2.836-.149,4.106,4.106,0,0,1,1.86,1.424c.184-.253.035-.506-.161-.712a3.021,3.021,0,0,0,1.458.437,2.094,2.094,0,0,0-1.286-.7,1.642,1.642,0,0,0,.528-.069m-5.04-1.688a13.9,13.9,0,0,1-2.8.379,4.867,4.867,0,0,1,2.238,1.148.716.716,0,0,0-.367-.746,3.149,3.149,0,0,0,1.539.184,2.347,2.347,0,0,0-1.446-.459,1.1,1.1,0,0,0,.838-.505",
    transform: "translate(-61.757 -58.407)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10179",
    "data-name": "Trazado 10179",
    d: "M123.964,86.669l-3.238,1.044,2.181,2.411,2.239-1.3ZM90.12,88.826,91.3,86.668l3.238,1.045-2.17,2.411Zm0,0",
    transform: "translate(-55.313 -52.86)",
    fill: "#eb172b",
    stroke: "#19458f",
    strokeWidth: 1.484
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHertfordshireConstabularyBadge);
export default __webpack_public_path__ + "static/media/hertfordshireConstabularyBadge.5af4ee0cfa132ffc696bb88dd948b29f.svg";
export { ForwardRef as ReactComponent };